// source: landscope-map-viewer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.landscope.mapviewer.v1.AccessLevel', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.AccountDeletionTerms', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.AccountPlan', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.AddressResult', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ArtifactMetadata', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ArtifactNote', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ArtifactType', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.Attachment', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.AvailableExportFormat', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.BufferPolygon', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculateAreaRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculateAreaResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculateStreamBufferRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CalculateStreamBufferResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CameraPosition', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.Collaborator', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.Comment', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CommentAnchor', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CommentAuthor', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CommentCursor', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CommunicationPreferences', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CompleteExternalLoginRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CompleteExternalLoginResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConfirmAttachmentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConfirmAttachmentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConsentWordingVersions', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.Coordinate', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CouponRejectionReason', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CoverageState', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateArtifactNoteRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateArtifactNoteResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateCommentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateCommentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateDemoAccessRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateDemoAccessResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateProjectDownloadRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateProjectDownloadResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateScopeRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateScopeResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateUserArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateUserArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateUserFolderRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateUserFolderResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateUserRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateUserResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateWorkspaceRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CreateWorkspaceResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CustomContour', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.CustomerIntent', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DEMStatus', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteAttachmentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteAttachmentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteCommentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteCommentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteScopeRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteScopeResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteUserArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteUserArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteUserFolderRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DeleteUserFolderResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DemAcquisitionOverlap', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DemSourceMetadata', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.DemoSlotHolder', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ElevationSample', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportFormat', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportOptions', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportUserArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportUserArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportUserFolderRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExportUserFolderResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ExternalProvider', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GeospatialBounds', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCheckoutStatusRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCheckoutStatusResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCommentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCommentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCommentsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCommentsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCurrentUserRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetCurrentUserResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetLineElevationProfileRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetLineElevationProfileResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetMyEntitlementsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetMyEntitlementsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetPlanCatalogRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetPlanCatalogResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetProjectStatisticsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetProjectStatisticsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetProjectStructureRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetProjectStructureResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetScopeRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetScopeResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetScopesRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetScopesResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetSeatReviewStateRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetSeatReviewStateResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserFolderRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserFolderResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserFoldersRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserFoldersResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.GetUserProjectsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.InviteCollaboratorRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.InviteCollaboratorResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LatLongCoordinate', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LayerConfig', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LayerProcessingState', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LayerStats', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LayerStatus', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LayerValue', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListArtifactNotesRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListArtifactNotesResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListCollaboratorsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListCollaboratorsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListMyWorkspacesResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListProjectsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LoginMethod', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LoginRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LoginResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LogoutRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.LogoutResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.PlanPrice', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.PlanSku', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.PolygonRing', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.Project', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ProjectEntitlement', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ProjectFolder', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ProjectRef', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.QuotePlanRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.QuotePlanResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RecordLayerOpenedRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RecordLayerOpenedResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveAvatarRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveAvatarResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveCollaboratorRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveCollaboratorResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveProjectRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveProjectResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RenameWorkspaceRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RenameWorkspaceResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReorderScopesRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReorderScopesResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReorderUserFoldersRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReorderUserFoldersResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ReplyToCommentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RequestAccountDeletionRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RequestAccountDeletionResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RequestPasswordResetResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ResendVerificationEmailRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ResendVerificationEmailResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ResetPasswordRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ResetPasswordResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RetryLayerProcessingRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RetryLayerProcessingResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.RetryLayerRejection', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SampleElevationRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SampleElevationResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.Scope', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ScopeArtifactConfig', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ScopeArtifactType', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SearchAddressRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SearchAddressResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SeatReviewCollaborator', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetCustomerIntentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetCustomerIntentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetUsagePurposeRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SetUsagePurposeResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.StartDemoProcessingRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.StartDemoProcessingResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.StartExternalLoginRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.StartExternalLoginResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.StatBreakdownItem', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SubmitSupportMessageRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SubmitSupportMessageResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.SupportMessageCategory', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.TeamSize', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.TeamSizeOption', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UTMCoordinate', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateCommentRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateCommentResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateProfileRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateProfileResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateProjectRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateProjectResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateScopeRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateScopeResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateUserArtifactRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateUserArtifactResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateUserFolderRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UpdateUserFolderResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UploadAvatarRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UploadAvatarResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UsagePurpose', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UsagePurposeGroup', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UsagePurposeOption', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UserArtifact', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UserFolder', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.UserProject', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ValidateCouponRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ValidateCouponResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ValidationError', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.ValidationErrorType', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.VerifyUserRequest', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.VerifyUserResponse', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.WorkspaceInfo', null, global);
goog.exportSymbol('proto.landscope.mapviewer.v1.WorkspaceMemberInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.displayName = 'proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CommunicationPreferences = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CommunicationPreferences, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CommunicationPreferences.displayName = 'proto.landscope.mapviewer.v1.CommunicationPreferences';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.displayName = 'proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SubmitSupportMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.displayName = 'proto.landscope.mapviewer.v1.SubmitSupportMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SubmitSupportMessageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.displayName = 'proto.landscope.mapviewer.v1.SubmitSupportMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetPlanCatalogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetPlanCatalogRequest.displayName = 'proto.landscope.mapviewer.v1.GetPlanCatalogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.PlanPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.PlanPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.PlanPrice.displayName = 'proto.landscope.mapviewer.v1.PlanPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetPlanCatalogResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetPlanCatalogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetPlanCatalogResponse.displayName = 'proto.landscope.mapviewer.v1.GetPlanCatalogResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetMyEntitlementsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.displayName = 'proto.landscope.mapviewer.v1.GetMyEntitlementsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ProjectEntitlement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ProjectEntitlement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ProjectEntitlement.displayName = 'proto.landscope.mapviewer.v1.ProjectEntitlement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.AccountPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.AccountPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.AccountPlan.displayName = 'proto.landscope.mapviewer.v1.AccountPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetMyEntitlementsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.displayName = 'proto.landscope.mapviewer.v1.GetMyEntitlementsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.displayName = 'proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.displayName = 'proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.QuotePlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.QuotePlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.QuotePlanRequest.displayName = 'proto.landscope.mapviewer.v1.QuotePlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.QuotePlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.QuotePlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.QuotePlanResponse.displayName = 'proto.landscope.mapviewer.v1.QuotePlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCheckoutStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.displayName = 'proto.landscope.mapviewer.v1.GetCheckoutStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCheckoutStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.displayName = 'proto.landscope.mapviewer.v1.GetCheckoutStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetCustomerIntentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetCustomerIntentRequest.displayName = 'proto.landscope.mapviewer.v1.SetCustomerIntentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetCustomerIntentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetCustomerIntentResponse.displayName = 'proto.landscope.mapviewer.v1.SetCustomerIntentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetSeatReviewStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.displayName = 'proto.landscope.mapviewer.v1.GetSeatReviewStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SeatReviewCollaborator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SeatReviewCollaborator.displayName = 'proto.landscope.mapviewer.v1.SeatReviewCollaborator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetSeatReviewStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.displayName = 'proto.landscope.mapviewer.v1.GetSeatReviewStateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.displayName = 'proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.displayName = 'proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SampleElevationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SampleElevationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SampleElevationRequest.displayName = 'proto.landscope.mapviewer.v1.SampleElevationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SampleElevationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SampleElevationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SampleElevationResponse.displayName = 'proto.landscope.mapviewer.v1.SampleElevationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetLineElevationProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.displayName = 'proto.landscope.mapviewer.v1.GetLineElevationProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LayerValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LayerValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LayerValue.displayName = 'proto.landscope.mapviewer.v1.LayerValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LayerStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LayerStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LayerStats.displayName = 'proto.landscope.mapviewer.v1.LayerStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ElevationSample = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ElevationSample, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ElevationSample.displayName = 'proto.landscope.mapviewer.v1.ElevationSample';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetLineElevationProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.displayName = 'proto.landscope.mapviewer.v1.GetLineElevationProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.displayName = 'proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.displayName = 'proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculateStreamBufferRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.displayName = 'proto.landscope.mapviewer.v1.CalculateStreamBufferRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.PolygonRing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.PolygonRing.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.PolygonRing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.PolygonRing.displayName = 'proto.landscope.mapviewer.v1.PolygonRing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.BufferPolygon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.BufferPolygon.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.BufferPolygon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.BufferPolygon.displayName = 'proto.landscope.mapviewer.v1.BufferPolygon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculateStreamBufferResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.displayName = 'proto.landscope.mapviewer.v1.CalculateStreamBufferResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListProjectsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListProjectsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListProjectsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListProjectsResponse.displayName = 'proto.landscope.mapviewer.v1.ListProjectsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetProjectStructureRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetProjectStructureRequest.displayName = 'proto.landscope.mapviewer.v1.GetProjectStructureRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetProjectStructureResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetProjectStructureResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetProjectStructureResponse.displayName = 'proto.landscope.mapviewer.v1.GetProjectStructureResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LayerStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.LayerStatus.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LayerStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LayerStatus.displayName = 'proto.landscope.mapviewer.v1.LayerStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RecordLayerOpenedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.displayName = 'proto.landscope.mapviewer.v1.RecordLayerOpenedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RecordLayerOpenedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.displayName = 'proto.landscope.mapviewer.v1.RecordLayerOpenedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RetryLayerProcessingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.displayName = 'proto.landscope.mapviewer.v1.RetryLayerProcessingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RetryLayerProcessingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.displayName = 'proto.landscope.mapviewer.v1.RetryLayerProcessingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RetryLayerRejection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RetryLayerRejection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RetryLayerRejection.displayName = 'proto.landscope.mapviewer.v1.RetryLayerRejection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.GetArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.GetArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateUserRequest.displayName = 'proto.landscope.mapviewer.v1.CreateUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConsentWordingVersions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConsentWordingVersions.displayName = 'proto.landscope.mapviewer.v1.ConsentWordingVersions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateUserResponse.displayName = 'proto.landscope.mapviewer.v1.CreateUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.VerifyUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.VerifyUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.VerifyUserRequest.displayName = 'proto.landscope.mapviewer.v1.VerifyUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.VerifyUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.VerifyUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.VerifyUserResponse.displayName = 'proto.landscope.mapviewer.v1.VerifyUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LoginRequest.displayName = 'proto.landscope.mapviewer.v1.LoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LoginResponse.displayName = 'proto.landscope.mapviewer.v1.LoginResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateDemoAccessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateDemoAccessRequest.displayName = 'proto.landscope.mapviewer.v1.CreateDemoAccessRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateDemoAccessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateDemoAccessResponse.displayName = 'proto.landscope.mapviewer.v1.CreateDemoAccessResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.StartExternalLoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.StartExternalLoginRequest.displayName = 'proto.landscope.mapviewer.v1.StartExternalLoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.StartExternalLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.StartExternalLoginResponse.displayName = 'proto.landscope.mapviewer.v1.StartExternalLoginResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CompleteExternalLoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.displayName = 'proto.landscope.mapviewer.v1.CompleteExternalLoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CompleteExternalLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.displayName = 'proto.landscope.mapviewer.v1.CompleteExternalLoginResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RequestPasswordResetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RequestPasswordResetResponse.displayName = 'proto.landscope.mapviewer.v1.RequestPasswordResetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.displayName = 'proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ResetPasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ResetPasswordRequest.displayName = 'proto.landscope.mapviewer.v1.ResetPasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ResetPasswordResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ResetPasswordResponse.displayName = 'proto.landscope.mapviewer.v1.ResetPasswordResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCurrentUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCurrentUserRequest.displayName = 'proto.landscope.mapviewer.v1.GetCurrentUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCurrentUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCurrentUserResponse.displayName = 'proto.landscope.mapviewer.v1.GetCurrentUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.displayName = 'proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UsagePurposeOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UsagePurposeOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UsagePurposeOption.displayName = 'proto.landscope.mapviewer.v1.UsagePurposeOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.UsagePurposeGroup.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UsagePurposeGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UsagePurposeGroup.displayName = 'proto.landscope.mapviewer.v1.UsagePurposeGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.TeamSizeOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.TeamSizeOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.TeamSizeOption.displayName = 'proto.landscope.mapviewer.v1.TeamSizeOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.displayName = 'proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.AccountDeletionTerms.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.AccountDeletionTerms, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.AccountDeletionTerms.displayName = 'proto.landscope.mapviewer.v1.AccountDeletionTerms';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.WorkspaceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.WorkspaceInfo.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.WorkspaceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.WorkspaceInfo.displayName = 'proto.landscope.mapviewer.v1.WorkspaceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListMyWorkspacesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.displayName = 'proto.landscope.mapviewer.v1.ListMyWorkspacesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.displayName = 'proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.displayName = 'proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.displayName = 'proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.displayName = 'proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.displayName = 'proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.WorkspaceMemberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.WorkspaceMemberInfo.displayName = 'proto.landscope.mapviewer.v1.WorkspaceMemberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.displayName = 'proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateWorkspaceRequest.displayName = 'proto.landscope.mapviewer.v1.CreateWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateWorkspaceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateWorkspaceResponse.displayName = 'proto.landscope.mapviewer.v1.CreateWorkspaceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RenameWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RenameWorkspaceRequest.displayName = 'proto.landscope.mapviewer.v1.RenameWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RenameWorkspaceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RenameWorkspaceResponse.displayName = 'proto.landscope.mapviewer.v1.RenameWorkspaceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.displayName = 'proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.displayName = 'proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateProfileRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateProfileResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetUsagePurposeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetUsagePurposeRequest.displayName = 'proto.landscope.mapviewer.v1.SetUsagePurposeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetUsagePurposeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetUsagePurposeResponse.displayName = 'proto.landscope.mapviewer.v1.SetUsagePurposeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UploadAvatarRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UploadAvatarRequest.displayName = 'proto.landscope.mapviewer.v1.UploadAvatarRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UploadAvatarResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UploadAvatarResponse.displayName = 'proto.landscope.mapviewer.v1.UploadAvatarResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveAvatarRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveAvatarRequest.displayName = 'proto.landscope.mapviewer.v1.RemoveAvatarRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveAvatarResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveAvatarResponse.displayName = 'proto.landscope.mapviewer.v1.RemoveAvatarResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LogoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LogoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LogoutRequest.displayName = 'proto.landscope.mapviewer.v1.LogoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LogoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LogoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LogoutResponse.displayName = 'proto.landscope.mapviewer.v1.LogoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CalculateAreaRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculateAreaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculateAreaRequest.displayName = 'proto.landscope.mapviewer.v1.CalculateAreaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CalculateAreaResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculateAreaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculateAreaResponse.displayName = 'proto.landscope.mapviewer.v1.CalculateAreaResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SearchAddressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SearchAddressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SearchAddressRequest.displayName = 'proto.landscope.mapviewer.v1.SearchAddressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SearchAddressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.SearchAddressResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SearchAddressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SearchAddressResponse.displayName = 'proto.landscope.mapviewer.v1.SearchAddressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.AddressResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.AddressResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.AddressResult.displayName = 'proto.landscope.mapviewer.v1.AddressResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ProjectRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ProjectRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ProjectRef.displayName = 'proto.landscope.mapviewer.v1.ProjectRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.Project = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.Project, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.Project.displayName = 'proto.landscope.mapviewer.v1.Project';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ProjectFolder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ProjectFolder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ProjectFolder.displayName = 'proto.landscope.mapviewer.v1.ProjectFolder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ArtifactMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ArtifactMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ArtifactMetadata.displayName = 'proto.landscope.mapviewer.v1.ArtifactMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GeospatialBounds = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GeospatialBounds, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GeospatialBounds.displayName = 'proto.landscope.mapviewer.v1.GeospatialBounds';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CustomContour = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CustomContour, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CustomContour.displayName = 'proto.landscope.mapviewer.v1.CustomContour';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.displayName = 'proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.displayName = 'proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.displayName = 'proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.displayName = 'proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.StartDemoProcessingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.StartDemoProcessingRequest.displayName = 'proto.landscope.mapviewer.v1.StartDemoProcessingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.StartDemoProcessingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.StartDemoProcessingResponse.displayName = 'proto.landscope.mapviewer.v1.StartDemoProcessingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.displayName = 'proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.displayName = 'proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DemoSlotHolder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DemoSlotHolder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DemoSlotHolder.displayName = 'proto.landscope.mapviewer.v1.DemoSlotHolder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.displayName = 'proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.displayName = 'proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ValidationError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ValidationError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ValidationError.displayName = 'proto.landscope.mapviewer.v1.ValidationError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.displayName = 'proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetUserProjectsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserProjectsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserProjectsResponse.displayName = 'proto.landscope.mapviewer.v1.GetUserProjectsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UserProject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.UserProject.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UserProject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UserProject.displayName = 'proto.landscope.mapviewer.v1.UserProject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.displayName = 'proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.displayName = 'proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DemSourceMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.DemSourceMetadata.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DemSourceMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DemSourceMetadata.displayName = 'proto.landscope.mapviewer.v1.DemSourceMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DemAcquisitionOverlap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DemAcquisitionOverlap.displayName = 'proto.landscope.mapviewer.v1.DemAcquisitionOverlap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.Coordinate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.Coordinate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.Coordinate.displayName = 'proto.landscope.mapviewer.v1.Coordinate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ValidateCouponRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ValidateCouponRequest.displayName = 'proto.landscope.mapviewer.v1.ValidateCouponRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ValidateCouponResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ValidateCouponResponse.displayName = 'proto.landscope.mapviewer.v1.ValidateCouponResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.displayName = 'proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.displayName = 'proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.displayName = 'proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.displayName = 'proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.StatBreakdownItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.StatBreakdownItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.StatBreakdownItem.displayName = 'proto.landscope.mapviewer.v1.StatBreakdownItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetProjectStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.displayName = 'proto.landscope.mapviewer.v1.GetProjectStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetProjectStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.displayName = 'proto.landscope.mapviewer.v1.GetProjectStatisticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateProjectDownloadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.displayName = 'proto.landscope.mapviewer.v1.CreateProjectDownloadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateProjectDownloadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.displayName = 'proto.landscope.mapviewer.v1.CreateProjectDownloadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.displayName = 'proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.displayName = 'proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.ExportArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.ExportArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.displayName = 'proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.displayName = 'proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.AvailableExportFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.AvailableExportFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.AvailableExportFormat.displayName = 'proto.landscope.mapviewer.v1.AvailableExportFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportUserArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportUserArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.ExportUserArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportUserArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportUserArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.ExportUserArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportUserFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportUserFolderRequest.displayName = 'proto.landscope.mapviewer.v1.ExportUserFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportUserFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportUserFolderResponse.displayName = 'proto.landscope.mapviewer.v1.ExportUserFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.UpdateProjectRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateProjectRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateProjectResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveProjectRequest.displayName = 'proto.landscope.mapviewer.v1.RemoveProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveProjectResponse.displayName = 'proto.landscope.mapviewer.v1.RemoveProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ExportOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ExportOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ExportOptions.displayName = 'proto.landscope.mapviewer.v1.ExportOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.InviteCollaboratorRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.InviteCollaboratorRequest.displayName = 'proto.landscope.mapviewer.v1.InviteCollaboratorRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.InviteCollaboratorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.InviteCollaboratorResponse.displayName = 'proto.landscope.mapviewer.v1.InviteCollaboratorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveCollaboratorRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.displayName = 'proto.landscope.mapviewer.v1.RemoveCollaboratorRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RemoveCollaboratorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.displayName = 'proto.landscope.mapviewer.v1.RemoveCollaboratorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListCollaboratorsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListCollaboratorsRequest.displayName = 'proto.landscope.mapviewer.v1.ListCollaboratorsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListCollaboratorsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListCollaboratorsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListCollaboratorsResponse.displayName = 'proto.landscope.mapviewer.v1.ListCollaboratorsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.Collaborator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.Collaborator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.Collaborator.displayName = 'proto.landscope.mapviewer.v1.Collaborator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CameraPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CameraPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CameraPosition.displayName = 'proto.landscope.mapviewer.v1.CameraPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LayerConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LayerConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LayerConfig.displayName = 'proto.landscope.mapviewer.v1.LayerConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ScopeArtifactConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ScopeArtifactConfig.displayName = 'proto.landscope.mapviewer.v1.ScopeArtifactConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.Scope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.Scope.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.Scope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.Scope.displayName = 'proto.landscope.mapviewer.v1.Scope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateScopeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CreateScopeRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateScopeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateScopeRequest.displayName = 'proto.landscope.mapviewer.v1.CreateScopeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateScopeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateScopeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateScopeResponse.displayName = 'proto.landscope.mapviewer.v1.CreateScopeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetScopesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetScopesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetScopesRequest.displayName = 'proto.landscope.mapviewer.v1.GetScopesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetScopesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetScopesResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetScopesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetScopesResponse.displayName = 'proto.landscope.mapviewer.v1.GetScopesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetScopeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetScopeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetScopeRequest.displayName = 'proto.landscope.mapviewer.v1.GetScopeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetScopeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetScopeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetScopeResponse.displayName = 'proto.landscope.mapviewer.v1.GetScopeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.UpdateScopeRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateScopeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateScopeRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateScopeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateScopeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateScopeResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateScopeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteScopeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteScopeRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteScopeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteScopeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteScopeResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteScopeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ReorderScopesRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReorderScopesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReorderScopesRequest.displayName = 'proto.landscope.mapviewer.v1.ReorderScopesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReorderScopesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReorderScopesResponse.displayName = 'proto.landscope.mapviewer.v1.ReorderScopesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.displayName = 'proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.displayName = 'proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.displayName = 'proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.displayName = 'proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CommentAuthor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CommentAuthor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CommentAuthor.displayName = 'proto.landscope.mapviewer.v1.CommentAuthor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.Attachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.Attachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.Attachment.displayName = 'proto.landscope.mapviewer.v1.Attachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CommentAnchor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CommentAnchor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CommentAnchor.displayName = 'proto.landscope.mapviewer.v1.CommentAnchor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.Comment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.Comment.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.Comment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.Comment.displayName = 'proto.landscope.mapviewer.v1.Comment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CommentCursor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CommentCursor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CommentCursor.displayName = 'proto.landscope.mapviewer.v1.CommentCursor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.CreateCommentRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateCommentRequest.displayName = 'proto.landscope.mapviewer.v1.CreateCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateCommentResponse.displayName = 'proto.landscope.mapviewer.v1.CreateCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ReplyToCommentRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReplyToCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReplyToCommentRequest.displayName = 'proto.landscope.mapviewer.v1.ReplyToCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.UpdateCommentRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateCommentRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateCommentResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteCommentRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteCommentResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCommentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCommentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCommentsRequest.displayName = 'proto.landscope.mapviewer.v1.GetCommentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCommentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetCommentsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCommentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCommentsResponse.displayName = 'proto.landscope.mapviewer.v1.GetCommentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCommentRequest.displayName = 'proto.landscope.mapviewer.v1.GetCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetCommentResponse.displayName = 'proto.landscope.mapviewer.v1.GetCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.displayName = 'proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.displayName = 'proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.displayName = 'proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.displayName = 'proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConfirmAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.displayName = 'proto.landscope.mapviewer.v1.ConfirmAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConfirmAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.displayName = 'proto.landscope.mapviewer.v1.ConfirmAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteAttachmentRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteAttachmentResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ArtifactNote = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ArtifactNote.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ArtifactNote, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ArtifactNote.displayName = 'proto.landscope.mapviewer.v1.ArtifactNote';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateArtifactNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.displayName = 'proto.landscope.mapviewer.v1.CreateArtifactNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateArtifactNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.displayName = 'proto.landscope.mapviewer.v1.CreateArtifactNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListArtifactNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListArtifactNotesRequest.displayName = 'proto.landscope.mapviewer.v1.ListArtifactNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ListArtifactNotesResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ListArtifactNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ListArtifactNotesResponse.displayName = 'proto.landscope.mapviewer.v1.ListArtifactNotesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.displayName = 'proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.displayName = 'proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.displayName = 'proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.displayName = 'proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UTMCoordinate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UTMCoordinate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UTMCoordinate.displayName = 'proto.landscope.mapviewer.v1.UTMCoordinate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.LatLongCoordinate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.LatLongCoordinate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.LatLongCoordinate.displayName = 'proto.landscope.mapviewer.v1.LatLongCoordinate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.displayName = 'proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.displayName = 'proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.displayName = 'proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.displayName = 'proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UserFolder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UserFolder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UserFolder.displayName = 'proto.landscope.mapviewer.v1.UserFolder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UserArtifact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UserArtifact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UserArtifact.displayName = 'proto.landscope.mapviewer.v1.UserArtifact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateUserFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateUserFolderRequest.displayName = 'proto.landscope.mapviewer.v1.CreateUserFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateUserFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateUserFolderResponse.displayName = 'proto.landscope.mapviewer.v1.CreateUserFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserFoldersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserFoldersRequest.displayName = 'proto.landscope.mapviewer.v1.GetUserFoldersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetUserFoldersResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserFoldersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserFoldersResponse.displayName = 'proto.landscope.mapviewer.v1.GetUserFoldersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserFolderRequest.displayName = 'proto.landscope.mapviewer.v1.GetUserFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.GetUserFolderResponse.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserFolderResponse.displayName = 'proto.landscope.mapviewer.v1.GetUserFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateUserFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateUserFolderRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateUserFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateUserFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateUserFolderResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateUserFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteUserFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteUserFolderRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteUserFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteUserFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteUserFolderResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteUserFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReorderUserFoldersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.displayName = 'proto.landscope.mapviewer.v1.ReorderUserFoldersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReorderUserFoldersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.displayName = 'proto.landscope.mapviewer.v1.ReorderUserFoldersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateUserArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateUserArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.CreateUserArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.CreateUserArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.CreateUserArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.CreateUserArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.GetUserArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.GetUserArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.GetUserArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.GetUserArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateUserArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.UpdateUserArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.UpdateUserArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.UpdateUserArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteUserArtifactRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.displayName = 'proto.landscope.mapviewer.v1.DeleteUserArtifactRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.DeleteUserArtifactResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.displayName = 'proto.landscope.mapviewer.v1.DeleteUserArtifactResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.repeatedFields_, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.displayName = 'proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.displayName = 'proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ResendVerificationEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.displayName = 'proto.landscope.mapviewer.v1.ResendVerificationEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.ResendVerificationEmailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.displayName = 'proto.landscope.mapviewer.v1.ResendVerificationEmailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RequestAccountDeletionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.displayName = 'proto.landscope.mapviewer.v1.RequestAccountDeletionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.landscope.mapviewer.v1.RequestAccountDeletionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.displayName = 'proto.landscope.mapviewer.v1.RequestAccountDeletionResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest;
  return proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CommunicationPreferences.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CommunicationPreferences} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.toObject = function(includeInstance, msg) {
  var f, obj = {
marketingEmail: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
adAudience: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CommunicationPreferences}
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CommunicationPreferences;
  return proto.landscope.mapviewer.v1.CommunicationPreferences.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CommunicationPreferences} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CommunicationPreferences}
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarketingEmail(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdAudience(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CommunicationPreferences.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CommunicationPreferences} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketingEmail();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAdAudience();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool marketing_email = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.prototype.getMarketingEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CommunicationPreferences} returns this
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.prototype.setMarketingEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool ad_audience = 2;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.prototype.getAdAudience = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CommunicationPreferences} returns this
 */
proto.landscope.mapviewer.v1.CommunicationPreferences.prototype.setAdAudience = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
preferences: (f = msg.getPreferences()) && proto.landscope.mapviewer.v1.CommunicationPreferences.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse;
  return proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.CommunicationPreferences;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommunicationPreferences.deserializeBinaryFromReader);
      msg.setPreferences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreferences();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.CommunicationPreferences.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommunicationPreferences preferences = 1;
 * @return {?proto.landscope.mapviewer.v1.CommunicationPreferences}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.prototype.getPreferences = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommunicationPreferences} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommunicationPreferences, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommunicationPreferences|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse} returns this
*/
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.prototype.setPreferences = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse} returns this
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.prototype.clearPreferences = function() {
  return this.setPreferences(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetMyCommunicationPreferencesResponse.prototype.hasPreferences = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
marketingEmail: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
adAudience: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
consentWordingVersions: (f = msg.getConsentWordingVersions()) && proto.landscope.mapviewer.v1.ConsentWordingVersions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest;
  return proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarketingEmail(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdAudience(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.ConsentWordingVersions;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ConsentWordingVersions.deserializeBinaryFromReader);
      msg.setConsentWordingVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketingEmail();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAdAudience();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getConsentWordingVersions();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.ConsentWordingVersions.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool marketing_email = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.getMarketingEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.setMarketingEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool ad_audience = 2;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.getAdAudience = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.setAdAudience = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional ConsentWordingVersions consent_wording_versions = 3;
 * @return {?proto.landscope.mapviewer.v1.ConsentWordingVersions}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.getConsentWordingVersions = function() {
  return /** @type{?proto.landscope.mapviewer.v1.ConsentWordingVersions} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.ConsentWordingVersions, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.ConsentWordingVersions|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} returns this
*/
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.setConsentWordingVersions = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.clearConsentWordingVersions = function() {
  return this.setConsentWordingVersions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesRequest.prototype.hasConsentWordingVersions = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
preferences: (f = msg.getPreferences()) && proto.landscope.mapviewer.v1.CommunicationPreferences.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse;
  return proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.CommunicationPreferences;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommunicationPreferences.deserializeBinaryFromReader);
      msg.setPreferences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreferences();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.CommunicationPreferences.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommunicationPreferences preferences = 1;
 * @return {?proto.landscope.mapviewer.v1.CommunicationPreferences}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.prototype.getPreferences = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommunicationPreferences} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommunicationPreferences, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommunicationPreferences|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse} returns this
*/
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.prototype.setPreferences = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.prototype.clearPreferences = function() {
  return this.setPreferences(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateMyCommunicationPreferencesResponse.prototype.hasPreferences = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
category: jspb.Message.getFieldWithDefault(msg, 1, 0),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SubmitSupportMessageRequest;
  return proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.SupportMessageCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional SupportMessageCategory category = 1;
 * @return {!proto.landscope.mapviewer.v1.SupportMessageCategory}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.prototype.getCategory = function() {
  return /** @type {!proto.landscope.mapviewer.v1.SupportMessageCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.SupportMessageCategory} value
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} returns this
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageRequest} returns this
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SubmitSupportMessageResponse;
  return proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.SubmitSupportMessageResponse} returns this
 */
proto.landscope.mapviewer.v1.SubmitSupportMessageResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetPlanCatalogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetPlanCatalogRequest;
  return proto.landscope.mapviewer.v1.GetPlanCatalogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetPlanCatalogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPlanCatalogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.PlanPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.PlanPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.PlanPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
sku: jspb.Message.getFieldWithDefault(msg, 1, 0),
demoPriceCents: jspb.Message.getFieldWithDefault(msg, 2, 0),
fullPriceCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
currencyCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
isSubscription: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
displayName: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.PlanPrice}
 */
proto.landscope.mapviewer.v1.PlanPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.PlanPrice;
  return proto.landscope.mapviewer.v1.PlanPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.PlanPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.PlanPrice}
 */
proto.landscope.mapviewer.v1.PlanPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (reader.readEnum());
      msg.setSku(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDemoPriceCents(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFullPriceCents(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrencyCode(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSubscription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.PlanPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.PlanPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.PlanPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSku();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDemoPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFullPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsSubscription();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional PlanSku sku = 1;
 * @return {!proto.landscope.mapviewer.v1.PlanSku}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.getSku = function() {
  return /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanSku} value
 * @return {!proto.landscope.mapviewer.v1.PlanPrice} returns this
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.setSku = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 demo_price_cents = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.getDemoPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.PlanPrice} returns this
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.setDemoPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 full_price_cents = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.getFullPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.PlanPrice} returns this
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.setFullPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string currency_code = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.PlanPrice} returns this
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_subscription = 5;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.getIsSubscription = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.PlanPrice} returns this
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.setIsSubscription = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string display_name = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.PlanPrice} returns this
 */
proto.landscope.mapviewer.v1.PlanPrice.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetPlanCatalogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
demoWindowDays: jspb.Message.getFieldWithDefault(msg, 1, 0),
currencyCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.landscope.mapviewer.v1.PlanPrice.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetPlanCatalogResponse;
  return proto.landscope.mapviewer.v1.GetPlanCatalogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDemoWindowDays(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrencyCode(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.PlanPrice;
      reader.readMessage(value,proto.landscope.mapviewer.v1.PlanPrice.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetPlanCatalogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDemoWindowDays();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.PlanPrice.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 demo_window_days = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.getDemoWindowDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.setDemoWindowDays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string currency_code = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PlanPrice prices = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.PlanPrice>}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.PlanPrice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.PlanPrice, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.PlanPrice>} value
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} returns this
*/
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanPrice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.PlanPrice}
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.PlanPrice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetPlanCatalogResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPlanCatalogResponse.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetMyEntitlementsRequest;
  return proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ProjectEntitlement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ProjectEntitlement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
processingStatus: jspb.Message.getFieldWithDefault(msg, 2, ""),
accessLevel: jspb.Message.getFieldWithDefault(msg, 3, 0),
demoExpiresAt: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
customerIntent: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ProjectEntitlement;
  return proto.landscope.mapviewer.v1.ProjectEntitlement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ProjectEntitlement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProcessingStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.landscope.mapviewer.v1.AccessLevel} */ (reader.readEnum());
      msg.setAccessLevel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDemoExpiresAt(value);
      break;
    case 5:
      var value = /** @type {!proto.landscope.mapviewer.v1.CustomerIntent} */ (reader.readEnum());
      msg.setCustomerIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ProjectEntitlement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ProjectEntitlement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProcessingStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccessLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCustomerIntent();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement} returns this
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string processing_status = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.getProcessingStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement} returns this
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.setProcessingStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AccessLevel access_level = 3;
 * @return {!proto.landscope.mapviewer.v1.AccessLevel}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.getAccessLevel = function() {
  return /** @type {!proto.landscope.mapviewer.v1.AccessLevel} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.AccessLevel} value
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement} returns this
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.setAccessLevel = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 demo_expires_at = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.getDemoExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement} returns this
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.setDemoExpiresAt = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement} returns this
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.clearDemoExpiresAt = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.hasDemoExpiresAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CustomerIntent customer_intent = 5;
 * @return {!proto.landscope.mapviewer.v1.CustomerIntent}
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.getCustomerIntent = function() {
  return /** @type {!proto.landscope.mapviewer.v1.CustomerIntent} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.CustomerIntent} value
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement} returns this
 */
proto.landscope.mapviewer.v1.ProjectEntitlement.prototype.setCustomerIntent = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.AccountPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.AccountPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AccountPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
kind: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
expiresAt: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.AccountPlan}
 */
proto.landscope.mapviewer.v1.AccountPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.AccountPlan;
  return proto.landscope.mapviewer.v1.AccountPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.AccountPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.AccountPlan}
 */
proto.landscope.mapviewer.v1.AccountPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.AccountPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.AccountPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AccountPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string kind = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.AccountPlan} returns this
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.AccountPlan} returns this
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 expires_at = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.AccountPlan} returns this
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.setExpiresAt = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.AccountPlan} returns this
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.clearExpiresAt = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.AccountPlan.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectsList: jspb.Message.toObjectList(msg.getProjectsList(),
    proto.landscope.mapviewer.v1.ProjectEntitlement.toObject, includeInstance),
activePlansList: jspb.Message.toObjectList(msg.getActivePlansList(),
    proto.landscope.mapviewer.v1.AccountPlan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetMyEntitlementsResponse;
  return proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.landscope.mapviewer.v1.ProjectEntitlement;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ProjectEntitlement.deserializeBinaryFromReader);
      msg.addProjects(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.AccountPlan;
      reader.readMessage(value,proto.landscope.mapviewer.v1.AccountPlan.deserializeBinaryFromReader);
      msg.addActivePlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.ProjectEntitlement.serializeBinaryToWriter
    );
  }
  f = message.getActivePlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.AccountPlan.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProjectEntitlement projects = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.ProjectEntitlement>}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.getProjectsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ProjectEntitlement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ProjectEntitlement, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ProjectEntitlement>} value
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.setProjectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ProjectEntitlement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ProjectEntitlement}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.addProjects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.ProjectEntitlement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.clearProjectsList = function() {
  return this.setProjectsList([]);
};


/**
 * repeated AccountPlan active_plans = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.AccountPlan>}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.getActivePlansList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.AccountPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.AccountPlan, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.AccountPlan>} value
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.setActivePlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.AccountPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.AccountPlan}
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.addActivePlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.AccountPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetMyEntitlementsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetMyEntitlementsResponse.prototype.clearActivePlansList = function() {
  return this.setActivePlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sku: jspb.Message.getFieldWithDefault(msg, 1, 0),
projectId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
couponCode: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest;
  return proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (reader.readEnum());
      msg.setSku(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSku();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional PlanSku sku = 1;
 * @return {!proto.landscope.mapviewer.v1.PlanSku}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.getSku = function() {
  return /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanSku} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.clearProjectId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.hasProjectId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string coupon_code = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.getCouponCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.setCouponCode = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.clearCouponCode = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutRequest.prototype.hasCouponCode = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
checkoutSessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientSecret: jspb.Message.getFieldWithDefault(msg, 2, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
grossAmountCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
discountCents: jspb.Message.getFieldWithDefault(msg, 5, 0),
currencyCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
sku: jspb.Message.getFieldWithDefault(msg, 7, 0),
creditCents: jspb.Message.getFieldWithDefault(msg, 8, 0),
couponRejectionReason: jspb.Message.getFieldWithDefault(msg, 9, 0),
couponCodeApplied: jspb.Message.getFieldWithDefault(msg, 10, ""),
couponExpiresAt: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse;
  return proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCheckoutSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientSecret(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGrossAmountCents(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscountCents(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrencyCode(value);
      break;
    case 7:
      var value = /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (reader.readEnum());
      msg.setSku(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCents(value);
      break;
    case 9:
      var value = /** @type {!proto.landscope.mapviewer.v1.CouponRejectionReason} */ (reader.readEnum());
      msg.setCouponRejectionReason(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponCodeApplied(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCouponExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheckoutSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getGrossAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDiscountCents();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSku();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCreditCents();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCouponRejectionReason();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCouponCodeApplied();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional string checkout_session_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getCheckoutSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setCheckoutSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_secret = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 amount_cents = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 gross_amount_cents = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getGrossAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setGrossAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 discount_cents = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getDiscountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setDiscountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string currency_code = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional PlanSku sku = 7;
 * @return {!proto.landscope.mapviewer.v1.PlanSku}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getSku = function() {
  return /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanSku} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setSku = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int64 credit_cents = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getCreditCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setCreditCents = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional CouponRejectionReason coupon_rejection_reason = 9;
 * @return {!proto.landscope.mapviewer.v1.CouponRejectionReason}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getCouponRejectionReason = function() {
  return /** @type {!proto.landscope.mapviewer.v1.CouponRejectionReason} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.CouponRejectionReason} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setCouponRejectionReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string coupon_code_applied = 10;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getCouponCodeApplied = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setCouponCodeApplied = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 coupon_expires_at = 11;
 * @return {number}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.getCouponExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.setCouponExpiresAt = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse} returns this
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.clearCouponExpiresAt = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InitiatePlanCheckoutResponse.prototype.hasCouponExpiresAt = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.QuotePlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.QuotePlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sku: jspb.Message.getFieldWithDefault(msg, 1, 0),
projectId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
couponCode: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.QuotePlanRequest;
  return proto.landscope.mapviewer.v1.QuotePlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.QuotePlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (reader.readEnum());
      msg.setSku(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.QuotePlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.QuotePlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSku();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional PlanSku sku = 1;
 * @return {!proto.landscope.mapviewer.v1.PlanSku}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.getSku = function() {
  return /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanSku} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.clearProjectId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.hasProjectId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string coupon_code = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.getCouponCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.setCouponCode = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanRequest} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.clearCouponCode = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.QuotePlanRequest.prototype.hasCouponCode = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.QuotePlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.QuotePlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
sku: jspb.Message.getFieldWithDefault(msg, 1, 0),
grossAmountCents: jspb.Message.getFieldWithDefault(msg, 2, 0),
discountCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
creditCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
amountCents: jspb.Message.getFieldWithDefault(msg, 5, 0),
currencyCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
duringDemo: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
couponValid: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
couponError: jspb.Message.getFieldWithDefault(msg, 9, ""),
couponRejectionReason: jspb.Message.getFieldWithDefault(msg, 10, 0),
couponExpiresAt: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.QuotePlanResponse;
  return proto.landscope.mapviewer.v1.QuotePlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.QuotePlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (reader.readEnum());
      msg.setSku(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGrossAmountCents(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscountCents(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCents(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrencyCode(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDuringDemo(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCouponValid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponError(value);
      break;
    case 10:
      var value = /** @type {!proto.landscope.mapviewer.v1.CouponRejectionReason} */ (reader.readEnum());
      msg.setCouponRejectionReason(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCouponExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.QuotePlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.QuotePlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSku();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGrossAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDiscountCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreditCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDuringDemo();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCouponValid();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCouponError();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCouponRejectionReason();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional PlanSku sku = 1;
 * @return {!proto.landscope.mapviewer.v1.PlanSku}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getSku = function() {
  return /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanSku} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setSku = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 gross_amount_cents = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getGrossAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setGrossAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 discount_cents = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getDiscountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setDiscountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 credit_cents = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getCreditCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setCreditCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 amount_cents = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string currency_code = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool during_demo = 7;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getDuringDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setDuringDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool coupon_valid = 8;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getCouponValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setCouponValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string coupon_error = 9;
 * @return {string}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getCouponError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setCouponError = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional CouponRejectionReason coupon_rejection_reason = 10;
 * @return {!proto.landscope.mapviewer.v1.CouponRejectionReason}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getCouponRejectionReason = function() {
  return /** @type {!proto.landscope.mapviewer.v1.CouponRejectionReason} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.CouponRejectionReason} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setCouponRejectionReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 coupon_expires_at = 11;
 * @return {number}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.getCouponExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.setCouponExpiresAt = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.QuotePlanResponse} returns this
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.clearCouponExpiresAt = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.QuotePlanResponse.prototype.hasCouponExpiresAt = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCheckoutStatusRequest;
  return proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
finalized: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
status: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCheckoutStatusResponse;
  return proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinalized(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFinalized();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool finalized = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.prototype.getFinalized = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.prototype.setFinalized = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCheckoutStatusResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCheckoutStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetCustomerIntentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
intent: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetCustomerIntentRequest;
  return proto.landscope.mapviewer.v1.SetCustomerIntentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.CustomerIntent} */ (reader.readEnum());
      msg.setIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetCustomerIntentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntent();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} returns this
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CustomerIntent intent = 2;
 * @return {!proto.landscope.mapviewer.v1.CustomerIntent}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.prototype.getIntent = function() {
  return /** @type {!proto.landscope.mapviewer.v1.CustomerIntent} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.CustomerIntent} value
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentRequest} returns this
 */
proto.landscope.mapviewer.v1.SetCustomerIntentRequest.prototype.setIntent = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetCustomerIntentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentResponse}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetCustomerIntentResponse;
  return proto.landscope.mapviewer.v1.SetCustomerIntentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentResponse}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetCustomerIntentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetCustomerIntentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.SetCustomerIntentResponse} returns this
 */
proto.landscope.mapviewer.v1.SetCustomerIntentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetSeatReviewStateRequest;
  return proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SeatReviewCollaborator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 5, ""),
projectName: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SeatReviewCollaborator;
  return proto.landscope.mapviewer.v1.SeatReviewCollaborator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SeatReviewCollaborator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProjectName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} returns this
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} returns this
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} returns this
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} returns this
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string project_id = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} returns this
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string project_name = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.getProjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator} returns this
 */
proto.landscope.mapviewer.v1.SeatReviewCollaborator.prototype.setProjectName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hasUnlimited: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
collaboratorsList: jspb.Message.toObjectList(msg.getCollaboratorsList(),
    proto.landscope.mapviewer.v1.SeatReviewCollaborator.toObject, includeInstance),
billableNow: jspb.Message.getFieldWithDefault(msg, 3, 0),
quantityNow: jspb.Message.getFieldWithDefault(msg, 4, 0),
hasSubscription: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
driftExists: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
projectSeatPriceCents: jspb.Message.getFieldWithDefault(msg, 7, 0),
workspaceSeatPriceCents: jspb.Message.getFieldWithDefault(msg, 8, 0),
includedWorkspaceEditorSeats: jspb.Message.getFieldWithDefault(msg, 9, 0),
activeWorkspaceMembers: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetSeatReviewStateResponse;
  return proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasUnlimited(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.SeatReviewCollaborator;
      reader.readMessage(value,proto.landscope.mapviewer.v1.SeatReviewCollaborator.deserializeBinaryFromReader);
      msg.addCollaborators(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBillableNow(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantityNow(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasSubscription(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDriftExists(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProjectSeatPriceCents(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkspaceSeatPriceCents(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIncludedWorkspaceEditorSeats(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveWorkspaceMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasUnlimited();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCollaboratorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.SeatReviewCollaborator.serializeBinaryToWriter
    );
  }
  f = message.getBillableNow();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getQuantityNow();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getHasSubscription();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getDriftExists();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getProjectSeatPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getWorkspaceSeatPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getIncludedWorkspaceEditorSeats();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getActiveWorkspaceMembers();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional bool has_unlimited = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getHasUnlimited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setHasUnlimited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated SeatReviewCollaborator collaborators = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.SeatReviewCollaborator>}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getCollaboratorsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.SeatReviewCollaborator>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.SeatReviewCollaborator, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.SeatReviewCollaborator>} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
*/
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setCollaboratorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.SeatReviewCollaborator=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.SeatReviewCollaborator}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.addCollaborators = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.SeatReviewCollaborator, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.clearCollaboratorsList = function() {
  return this.setCollaboratorsList([]);
};


/**
 * optional int32 billable_now = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getBillableNow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setBillableNow = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 quantity_now = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getQuantityNow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setQuantityNow = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool has_subscription = 5;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getHasSubscription = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setHasSubscription = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool drift_exists = 6;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getDriftExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setDriftExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 project_seat_price_cents = 7;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getProjectSeatPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setProjectSeatPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 workspace_seat_price_cents = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getWorkspaceSeatPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setWorkspaceSeatPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 included_workspace_editor_seats = 9;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getIncludedWorkspaceEditorSeats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setIncludedWorkspaceEditorSeats = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 active_workspace_members = 10;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.getActiveWorkspaceMembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetSeatReviewStateResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSeatReviewStateResponse.prototype.setActiveWorkspaceMembers = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest;
  return proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
applied: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
needsCheckout: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
billableNow: jspb.Message.getFieldWithDefault(msg, 3, 0),
priceCents: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse;
  return proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplied(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeedsCheckout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBillableNow(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPriceCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplied();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getNeedsCheckout();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBillableNow();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional bool applied = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.getApplied = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.setApplied = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool needs_checkout = 2;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.getNeedsCheckout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.setNeedsCheckout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 billable_now = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.getBillableNow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.setBillableNow = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 price_cents = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.getPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmProjectSeatRebaseResponse.prototype.setPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SampleElevationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SampleElevationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SampleElevationRequest}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SampleElevationRequest;
  return proto.landscope.mapviewer.v1.SampleElevationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SampleElevationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SampleElevationRequest}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SampleElevationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SampleElevationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SampleElevationRequest} returns this
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.SampleElevationRequest} returns this
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.SampleElevationRequest} returns this
 */
proto.landscope.mapviewer.v1.SampleElevationRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SampleElevationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SampleElevationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
elevationMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SampleElevationResponse}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SampleElevationResponse;
  return proto.landscope.mapviewer.v1.SampleElevationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SampleElevationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SampleElevationResponse}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevationMeters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SampleElevationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SampleElevationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getElevationMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.SampleElevationResponse} returns this
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SampleElevationResponse} returns this
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double elevation_meters = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.getElevationMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.SampleElevationResponse} returns this
 */
proto.landscope.mapviewer.v1.SampleElevationResponse.prototype.setElevationMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
startLatitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
startLongitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
endLatitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
endLongitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
numSamples: jspb.Message.getFieldWithDefault(msg, 6, 0),
samplingLayersList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetLineElevationProfileRequest;
  return proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStartLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStartLongitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEndLatitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEndLongitude(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumSamples(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addSamplingLayers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getStartLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getEndLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getEndLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getNumSamples();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSamplingLayersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double start_latitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getStartLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setStartLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double start_longitude = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getStartLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setStartLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double end_latitude = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getEndLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setEndLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double end_longitude = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getEndLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setEndLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 num_samples = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getNumSamples = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setNumSamples = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated string sampling_layers = 7;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.getSamplingLayersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.setSamplingLayersList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.addSamplingLayers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileRequest.prototype.clearSamplingLayersList = function() {
  return this.setSamplingLayersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LayerValue.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LayerValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LayerValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
valid: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LayerValue}
 */
proto.landscope.mapviewer.v1.LayerValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LayerValue;
  return proto.landscope.mapviewer.v1.LayerValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LayerValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LayerValue}
 */
proto.landscope.mapviewer.v1.LayerValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LayerValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LayerValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LayerValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getValid();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LayerValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LayerValue} returns this
 */
proto.landscope.mapviewer.v1.LayerValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool valid = 2;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.LayerValue.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.LayerValue} returns this
 */
proto.landscope.mapviewer.v1.LayerValue.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LayerStats.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LayerStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LayerStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerStats.toObject = function(includeInstance, msg) {
  var f, obj = {
min: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
max: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LayerStats}
 */
proto.landscope.mapviewer.v1.LayerStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LayerStats;
  return proto.landscope.mapviewer.v1.LayerStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LayerStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LayerStats}
 */
proto.landscope.mapviewer.v1.LayerStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LayerStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LayerStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LayerStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMax();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double min = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LayerStats.prototype.getMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LayerStats} returns this
 */
proto.landscope.mapviewer.v1.LayerStats.prototype.setMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double max = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LayerStats.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LayerStats} returns this
 */
proto.landscope.mapviewer.v1.LayerStats.prototype.setMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ElevationSample.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ElevationSample} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ElevationSample.toObject = function(includeInstance, msg) {
  var f, obj = {
distanceMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
elevationMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
valid: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
distance3dMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
layerValuesMap: (f = msg.getLayerValuesMap()) ? f.toObject(includeInstance, proto.landscope.mapviewer.v1.LayerValue.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ElevationSample}
 */
proto.landscope.mapviewer.v1.ElevationSample.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ElevationSample;
  return proto.landscope.mapviewer.v1.ElevationSample.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ElevationSample} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ElevationSample}
 */
proto.landscope.mapviewer.v1.ElevationSample.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistanceMeters(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevationMeters(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistance3dMeters(value);
      break;
    case 5:
      var value = msg.getLayerValuesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.landscope.mapviewer.v1.LayerValue.deserializeBinaryFromReader, "", new proto.landscope.mapviewer.v1.LayerValue());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ElevationSample.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ElevationSample} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ElevationSample.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistanceMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getElevationMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getValid();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getDistance3dMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLayerValuesMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getLayerValuesMap(true),
    5,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.landscope.mapviewer.v1.LayerValue.serializeBinaryToWriter);
  }
};


/**
 * optional double distance_meters = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.getDistanceMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ElevationSample} returns this
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.setDistanceMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double elevation_meters = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.getElevationMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ElevationSample} returns this
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.setElevationMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional bool valid = 3;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ElevationSample} returns this
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double distance_3d_meters = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.getDistance3dMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ElevationSample} returns this
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.setDistance3dMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * map<string, LayerValue> layer_values = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.landscope.mapviewer.v1.LayerValue>}
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.getLayerValuesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.landscope.mapviewer.v1.LayerValue>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.landscope.mapviewer.v1.LayerValue));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.landscope.mapviewer.v1.ElevationSample} returns this
 */
proto.landscope.mapviewer.v1.ElevationSample.prototype.clearLayerValuesMap = function() {
  this.getLayerValuesMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
samplesList: jspb.Message.toObjectList(msg.getSamplesList(),
    proto.landscope.mapviewer.v1.ElevationSample.toObject, includeInstance),
totalDistanceMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
totalDistance3dMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
hemisphere: jspb.Message.getFieldWithDefault(msg, 6, ""),
layerStatsMap: (f = msg.getLayerStatsMap()) ? f.toObject(includeInstance, proto.landscope.mapviewer.v1.LayerStats.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetLineElevationProfileResponse;
  return proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.ElevationSample;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ElevationSample.deserializeBinaryFromReader);
      msg.addSamples(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDistanceMeters(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDistance3dMeters(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHemisphere(value);
      break;
    case 7:
      var value = msg.getLayerStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.landscope.mapviewer.v1.LayerStats.deserializeBinaryFromReader, "", new proto.landscope.mapviewer.v1.LayerStats());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSamplesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.ElevationSample.serializeBinaryToWriter
    );
  }
  f = message.getTotalDistanceMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTotalDistance3dMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getHemisphere();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLayerStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getLayerStatsMap(true),
    7,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.landscope.mapviewer.v1.LayerStats.serializeBinaryToWriter);
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ElevationSample samples = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.ElevationSample>}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getSamplesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ElevationSample>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ElevationSample, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ElevationSample>} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
*/
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.setSamplesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ElevationSample=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ElevationSample}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.addSamples = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.ElevationSample, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.clearSamplesList = function() {
  return this.setSamplesList([]);
};


/**
 * optional double total_distance_meters = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getTotalDistanceMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.setTotalDistanceMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double total_distance_3d_meters = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getTotalDistance3dMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.setTotalDistance3dMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string hemisphere = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getHemisphere = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.setHemisphere = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * map<string, LayerStats> layer_stats = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.landscope.mapviewer.v1.LayerStats>}
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.getLayerStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.landscope.mapviewer.v1.LayerStats>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      proto.landscope.mapviewer.v1.LayerStats));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.landscope.mapviewer.v1.GetLineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetLineElevationProfileResponse.prototype.clearLayerStatsMap = function() {
  this.getLayerStatsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
coordinatesList: jspb.Message.toObjectList(msg.getCoordinatesList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
numSamples: jspb.Message.getFieldWithDefault(msg, 3, 0),
samplingLayersList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest;
  return proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addCoordinates(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumSamples(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addSamplingLayers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getNumSamples();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSamplingLayersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Coordinate coordinates = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.getCoordinatesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
*/
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.setCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.addCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.clearCoordinatesList = function() {
  return this.setCoordinatesList([]);
};


/**
 * optional int32 num_samples = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.getNumSamples = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.setNumSamples = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated string sampling_layers = 4;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.getSamplingLayersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.setSamplingLayersList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.addSamplingLayers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileRequest.prototype.clearSamplingLayersList = function() {
  return this.setSamplingLayersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
samplesList: jspb.Message.toObjectList(msg.getSamplesList(),
    proto.landscope.mapviewer.v1.ElevationSample.toObject, includeInstance),
totalDistanceMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
totalDistance3dMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
hemisphere: jspb.Message.getFieldWithDefault(msg, 6, ""),
layerStatsMap: (f = msg.getLayerStatsMap()) ? f.toObject(includeInstance, proto.landscope.mapviewer.v1.LayerStats.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse;
  return proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.ElevationSample;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ElevationSample.deserializeBinaryFromReader);
      msg.addSamples(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDistanceMeters(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDistance3dMeters(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHemisphere(value);
      break;
    case 7:
      var value = msg.getLayerStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.landscope.mapviewer.v1.LayerStats.deserializeBinaryFromReader, "", new proto.landscope.mapviewer.v1.LayerStats());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSamplesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.ElevationSample.serializeBinaryToWriter
    );
  }
  f = message.getTotalDistanceMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTotalDistance3dMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getHemisphere();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLayerStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getLayerStatsMap(true),
    7,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.landscope.mapviewer.v1.LayerStats.serializeBinaryToWriter);
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ElevationSample samples = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.ElevationSample>}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getSamplesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ElevationSample>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ElevationSample, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ElevationSample>} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
*/
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.setSamplesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ElevationSample=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ElevationSample}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.addSamples = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.ElevationSample, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.clearSamplesList = function() {
  return this.setSamplesList([]);
};


/**
 * optional double total_distance_meters = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getTotalDistanceMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.setTotalDistanceMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double total_distance_3d_meters = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getTotalDistance3dMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.setTotalDistance3dMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string hemisphere = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getHemisphere = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.setHemisphere = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * map<string, LayerStats> layer_stats = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.landscope.mapviewer.v1.LayerStats>}
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.getLayerStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.landscope.mapviewer.v1.LayerStats>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      proto.landscope.mapviewer.v1.LayerStats));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.GetPolylineElevationProfileResponse.prototype.clearLayerStatsMap = function() {
  this.getLayerStatsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
lineCoordinatesList: jspb.Message.toObjectList(msg.getLineCoordinatesList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
bufferDistanceMeters: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculateStreamBufferRequest;
  return proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addLineCoordinates(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBufferDistanceMeters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLineCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getBufferDistanceMeters();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Coordinate line_coordinates = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.getLineCoordinatesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} returns this
*/
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.setLineCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.addLineCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.clearLineCoordinatesList = function() {
  return this.setLineCoordinatesList([]);
};


/**
 * optional double buffer_distance_meters = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.getBufferDistanceMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferRequest.prototype.setBufferDistanceMeters = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.PolygonRing.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.PolygonRing.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.PolygonRing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.PolygonRing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.PolygonRing.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.PolygonRing}
 */
proto.landscope.mapviewer.v1.PolygonRing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.PolygonRing;
  return proto.landscope.mapviewer.v1.PolygonRing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.PolygonRing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.PolygonRing}
 */
proto.landscope.mapviewer.v1.PolygonRing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.PolygonRing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.PolygonRing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.PolygonRing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.PolygonRing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Coordinate points = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.PolygonRing.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.PolygonRing} returns this
*/
proto.landscope.mapviewer.v1.PolygonRing.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.PolygonRing.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.PolygonRing} returns this
 */
proto.landscope.mapviewer.v1.PolygonRing.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.BufferPolygon.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.BufferPolygon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.BufferPolygon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.BufferPolygon.toObject = function(includeInstance, msg) {
  var f, obj = {
exteriorList: jspb.Message.toObjectList(msg.getExteriorList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
holesList: jspb.Message.toObjectList(msg.getHolesList(),
    proto.landscope.mapviewer.v1.PolygonRing.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon}
 */
proto.landscope.mapviewer.v1.BufferPolygon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.BufferPolygon;
  return proto.landscope.mapviewer.v1.BufferPolygon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.BufferPolygon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon}
 */
proto.landscope.mapviewer.v1.BufferPolygon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addExterior(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.PolygonRing;
      reader.readMessage(value,proto.landscope.mapviewer.v1.PolygonRing.deserializeBinaryFromReader);
      msg.addHoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.BufferPolygon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.BufferPolygon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.BufferPolygon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExteriorList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getHolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.PolygonRing.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Coordinate exterior = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.getExteriorList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon} returns this
*/
proto.landscope.mapviewer.v1.BufferPolygon.prototype.setExteriorList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.addExterior = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon} returns this
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.clearExteriorList = function() {
  return this.setExteriorList([]);
};


/**
 * repeated PolygonRing holes = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.PolygonRing>}
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.getHolesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.PolygonRing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.PolygonRing, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.PolygonRing>} value
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon} returns this
*/
proto.landscope.mapviewer.v1.BufferPolygon.prototype.setHolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.PolygonRing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.PolygonRing}
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.addHoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.PolygonRing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon} returns this
 */
proto.landscope.mapviewer.v1.BufferPolygon.prototype.clearHolesList = function() {
  return this.setHolesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
bufferPolygonList: jspb.Message.toObjectList(msg.getBufferPolygonList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
bufferPolygonsList: jspb.Message.toObjectList(msg.getBufferPolygonsList(),
    proto.landscope.mapviewer.v1.BufferPolygon.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculateStreamBufferResponse;
  return proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addBufferPolygon(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.BufferPolygon;
      reader.readMessage(value,proto.landscope.mapviewer.v1.BufferPolygon.deserializeBinaryFromReader);
      msg.addBufferPolygons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBufferPolygonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getBufferPolygonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.BufferPolygon.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Coordinate buffer_polygon = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.getBufferPolygonList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.setBufferPolygonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.addBufferPolygon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.clearBufferPolygonList = function() {
  return this.setBufferPolygonList([]);
};


/**
 * repeated BufferPolygon buffer_polygons = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.BufferPolygon>}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.getBufferPolygonsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.BufferPolygon>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.BufferPolygon, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.BufferPolygon>} value
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.setBufferPolygonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.BufferPolygon=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.BufferPolygon}
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.addBufferPolygons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.BufferPolygon, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculateStreamBufferResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateStreamBufferResponse.prototype.clearBufferPolygonsList = function() {
  return this.setBufferPolygonsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListProjectsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListProjectsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectsList: jspb.Message.toObjectList(msg.getProjectsList(),
    proto.landscope.mapviewer.v1.Project.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListProjectsResponse}
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListProjectsResponse;
  return proto.landscope.mapviewer.v1.ListProjectsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListProjectsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListProjectsResponse}
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Project;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Project.deserializeBinaryFromReader);
      msg.addProjects(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListProjectsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListProjectsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Project.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Project projects = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Project>}
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.prototype.getProjectsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Project>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Project, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Project>} value
 * @return {!proto.landscope.mapviewer.v1.ListProjectsResponse} returns this
*/
proto.landscope.mapviewer.v1.ListProjectsResponse.prototype.setProjectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Project=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Project}
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.prototype.addProjects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Project, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListProjectsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListProjectsResponse.prototype.clearProjectsList = function() {
  return this.setProjectsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetProjectStructureRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureRequest}
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetProjectStructureRequest;
  return proto.landscope.mapviewer.v1.GetProjectStructureRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureRequest}
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetProjectStructureRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureRequest} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStructureRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetProjectStructureResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
project: (f = msg.getProject()) && proto.landscope.mapviewer.v1.ProjectRef.toObject(includeInstance, f),
foldersList: jspb.Message.toObjectList(msg.getFoldersList(),
    proto.landscope.mapviewer.v1.ProjectFolder.toObject, includeInstance),
artifactsList: jspb.Message.toObjectList(msg.getArtifactsList(),
    proto.landscope.mapviewer.v1.ArtifactMetadata.toObject, includeInstance),
layerStatusesList: jspb.Message.toObjectList(msg.getLayerStatusesList(),
    proto.landscope.mapviewer.v1.LayerStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetProjectStructureResponse;
  return proto.landscope.mapviewer.v1.GetProjectStructureResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.ProjectRef;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ProjectRef.deserializeBinaryFromReader);
      msg.setProject(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.ProjectFolder;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ProjectFolder.deserializeBinaryFromReader);
      msg.addFolders(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.ArtifactMetadata;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ArtifactMetadata.deserializeBinaryFromReader);
      msg.addArtifacts(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.LayerStatus;
      reader.readMessage(value,proto.landscope.mapviewer.v1.LayerStatus.deserializeBinaryFromReader);
      msg.addLayerStatuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetProjectStructureResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProject();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.ProjectRef.serializeBinaryToWriter
    );
  }
  f = message.getFoldersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.ProjectFolder.serializeBinaryToWriter
    );
  }
  f = message.getArtifactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.ArtifactMetadata.serializeBinaryToWriter
    );
  }
  f = message.getLayerStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.LayerStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProjectRef project = 1;
 * @return {?proto.landscope.mapviewer.v1.ProjectRef}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.getProject = function() {
  return /** @type{?proto.landscope.mapviewer.v1.ProjectRef} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.ProjectRef, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.ProjectRef|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.setProject = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.clearProject = function() {
  return this.setProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.hasProject = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ProjectFolder folders = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.ProjectFolder>}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.getFoldersList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ProjectFolder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ProjectFolder, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ProjectFolder>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.setFoldersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ProjectFolder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.addFolders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.ProjectFolder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.clearFoldersList = function() {
  return this.setFoldersList([]);
};


/**
 * repeated ArtifactMetadata artifacts = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.ArtifactMetadata>}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.getArtifactsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ArtifactMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ArtifactMetadata, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ArtifactMetadata>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.setArtifactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ArtifactMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.addArtifacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.ArtifactMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.clearArtifactsList = function() {
  return this.setArtifactsList([]);
};


/**
 * repeated LayerStatus layer_statuses = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.LayerStatus>}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.getLayerStatusesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.LayerStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.LayerStatus, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.LayerStatus>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.setLayerStatusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.LayerStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.LayerStatus}
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.addLayerStatuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.LayerStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStructureResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStructureResponse.prototype.clearLayerStatusesList = function() {
  return this.setLayerStatusesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.LayerStatus.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LayerStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LayerStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
layerName: jspb.Message.getFieldWithDefault(msg, 1, ""),
state: jspb.Message.getFieldWithDefault(msg, 2, 0),
folderIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
userRetryCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
retryAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LayerStatus}
 */
proto.landscope.mapviewer.v1.LayerStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LayerStatus;
  return proto.landscope.mapviewer.v1.LayerStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LayerStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LayerStatus}
 */
proto.landscope.mapviewer.v1.LayerStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLayerName(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.LayerProcessingState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addFolderIds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserRetryCount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRetryAvailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LayerStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LayerStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLayerName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFolderIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getUserRetryCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRetryAvailable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string layer_name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.getLayerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.setLayerName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LayerProcessingState state = 2;
 * @return {!proto.landscope.mapviewer.v1.LayerProcessingState}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.getState = function() {
  return /** @type {!proto.landscope.mapviewer.v1.LayerProcessingState} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.LayerProcessingState} value
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string folder_ids = 3;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.getFolderIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.setFolderIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.addFolderIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.clearFolderIdsList = function() {
  return this.setFolderIdsList([]);
};


/**
 * optional int32 user_retry_count = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.getUserRetryCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.setUserRetryCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool retry_available = 5;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.getRetryAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.LayerStatus} returns this
 */
proto.landscope.mapviewer.v1.LayerStatus.prototype.setRetryAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
objectKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RecordLayerOpenedRequest;
  return proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setObjectKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObjectKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} returns this
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string object_key = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.prototype.getObjectKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RecordLayerOpenedRequest} returns this
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedRequest.prototype.setObjectKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RecordLayerOpenedResponse;
  return proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RecordLayerOpenedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RecordLayerOpenedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
layerNamesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RetryLayerProcessingRequest;
  return proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addLayerNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLayerNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string layer_names = 2;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.getLayerNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.setLayerNamesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.addLayerNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingRequest} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingRequest.prototype.clearLayerNamesList = function() {
  return this.setLayerNamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
layersQueuedList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
rejectedList: jspb.Message.toObjectList(msg.getRejectedList(),
    proto.landscope.mapviewer.v1.RetryLayerRejection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RetryLayerProcessingResponse;
  return proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addLayersQueued(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.RetryLayerRejection;
      reader.readMessage(value,proto.landscope.mapviewer.v1.RetryLayerRejection.deserializeBinaryFromReader);
      msg.addRejected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLayersQueuedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getRejectedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.RetryLayerRejection.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string layers_queued = 3;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.getLayersQueuedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.setLayersQueuedList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.addLayersQueued = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.clearLayersQueuedList = function() {
  return this.setLayersQueuedList([]);
};


/**
 * repeated RetryLayerRejection rejected = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.RetryLayerRejection>}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.getRejectedList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.RetryLayerRejection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.RetryLayerRejection, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.RetryLayerRejection>} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
*/
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.setRejectedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.RetryLayerRejection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.RetryLayerRejection}
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.addRejected = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.RetryLayerRejection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerProcessingResponse.prototype.clearRejectedList = function() {
  return this.setRejectedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RetryLayerRejection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RetryLayerRejection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.toObject = function(includeInstance, msg) {
  var f, obj = {
layerName: jspb.Message.getFieldWithDefault(msg, 1, ""),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerRejection}
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RetryLayerRejection;
  return proto.landscope.mapviewer.v1.RetryLayerRejection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RetryLayerRejection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RetryLayerRejection}
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLayerName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RetryLayerRejection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RetryLayerRejection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLayerName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string layer_name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.prototype.getLayerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerRejection} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.prototype.setLayerName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RetryLayerRejection} returns this
 */
proto.landscope.mapviewer.v1.RetryLayerRejection.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
artifactId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetArtifactRequest}
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetArtifactRequest;
  return proto.landscope.mapviewer.v1.GetArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetArtifactRequest}
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.GetArtifactRequest.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && proto.landscope.mapviewer.v1.ArtifactMetadata.toObject(includeInstance, f),
blobData: msg.getBlobData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetArtifactResponse}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetArtifactResponse;
  return proto.landscope.mapviewer.v1.GetArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetArtifactResponse}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.ArtifactMetadata;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ArtifactMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBlobData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.ArtifactMetadata.serializeBinaryToWriter
    );
  }
  f = message.getBlobData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional ArtifactMetadata metadata = 1;
 * @return {?proto.landscope.mapviewer.v1.ArtifactMetadata}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.getMetadata = function() {
  return /** @type{?proto.landscope.mapviewer.v1.ArtifactMetadata} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.ArtifactMetadata, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.ArtifactMetadata|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetArtifactResponse} returns this
*/
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes blob_data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.getBlobData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes blob_data = 2;
 * This is a type-conversion wrapper around `getBlobData()`
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.getBlobData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBlobData()));
};


/**
 * optional bytes blob_data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBlobData()`
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.getBlobData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBlobData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.landscope.mapviewer.v1.GetArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.GetArtifactResponse.prototype.setBlobData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
usagePurpose: jspb.Message.getFieldWithDefault(msg, 4, 0),
otherUsageDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
marketingEmailConsent: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
adAudienceConsent: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
consentWordingVersions: (f = msg.getConsentWordingVersions()) && proto.landscope.mapviewer.v1.ConsentWordingVersions.toObject(includeInstance, f),
referralCode: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateUserRequest;
  return proto.landscope.mapviewer.v1.CreateUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (reader.readEnum());
      msg.setUsagePurpose(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOtherUsageDescription(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarketingEmailConsent(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdAudienceConsent(value);
      break;
    case 8:
      var value = new proto.landscope.mapviewer.v1.ConsentWordingVersions;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ConsentWordingVersions.deserializeBinaryFromReader);
      msg.setConsentWordingVersions(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReferralCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsagePurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getOtherUsageDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMarketingEmailConsent();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAdAudienceConsent();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getConsentWordingVersions();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.landscope.mapviewer.v1.ConsentWordingVersions.serializeBinaryToWriter
    );
  }
  f = message.getReferralCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional UsagePurpose usage_purpose = 4;
 * @return {!proto.landscope.mapviewer.v1.UsagePurpose}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getUsagePurpose = function() {
  return /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.UsagePurpose} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setUsagePurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string other_usage_description = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getOtherUsageDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setOtherUsageDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool marketing_email_consent = 6;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getMarketingEmailConsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setMarketingEmailConsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool ad_audience_consent = 7;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getAdAudienceConsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setAdAudienceConsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional ConsentWordingVersions consent_wording_versions = 8;
 * @return {?proto.landscope.mapviewer.v1.ConsentWordingVersions}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getConsentWordingVersions = function() {
  return /** @type{?proto.landscope.mapviewer.v1.ConsentWordingVersions} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.ConsentWordingVersions, 8));
};


/**
 * @param {?proto.landscope.mapviewer.v1.ConsentWordingVersions|undefined} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
*/
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setConsentWordingVersions = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.clearConsentWordingVersions = function() {
  return this.setConsentWordingVersions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.hasConsentWordingVersions = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string referral_code = 9;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.getReferralCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserRequest.prototype.setReferralCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConsentWordingVersions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConsentWordingVersions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.toObject = function(includeInstance, msg) {
  var f, obj = {
marketingEmail: jspb.Message.getFieldWithDefault(msg, 1, ""),
adAudience: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConsentWordingVersions}
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConsentWordingVersions;
  return proto.landscope.mapviewer.v1.ConsentWordingVersions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConsentWordingVersions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConsentWordingVersions}
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMarketingEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAdAudience(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConsentWordingVersions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConsentWordingVersions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketingEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdAudience();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string marketing_email = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.prototype.getMarketingEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConsentWordingVersions} returns this
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.prototype.setMarketingEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ad_audience = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.prototype.getAdAudience = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConsentWordingVersions} returns this
 */
proto.landscope.mapviewer.v1.ConsentWordingVersions.prototype.setAdAudience = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateUserResponse}
 */
proto.landscope.mapviewer.v1.CreateUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateUserResponse;
  return proto.landscope.mapviewer.v1.CreateUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateUserResponse}
 */
proto.landscope.mapviewer.v1.CreateUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateUserResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateUserResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.VerifyUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.VerifyUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
code: jspb.Message.getFieldWithDefault(msg, 2, ""),
password: jspb.Message.getFieldWithDefault(msg, 3, ""),
csrfToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.VerifyUserRequest}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.VerifyUserRequest;
  return proto.landscope.mapviewer.v1.VerifyUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.VerifyUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.VerifyUserRequest}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCsrfToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.VerifyUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.VerifyUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCsrfToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserRequest} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserRequest} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserRequest} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string csrf_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.getCsrfToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserRequest} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserRequest.prototype.setCsrfToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.VerifyUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.VerifyUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
sessionToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.VerifyUserResponse}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.VerifyUserResponse;
  return proto.landscope.mapviewer.v1.VerifyUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.VerifyUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.VerifyUserResponse}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.VerifyUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.VerifyUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserResponse} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserResponse} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string session_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserResponse} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string session_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.VerifyUserResponse} returns this
 */
proto.landscope.mapviewer.v1.VerifyUserResponse.prototype.setSessionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
password: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LoginRequest}
 */
proto.landscope.mapviewer.v1.LoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LoginRequest;
  return proto.landscope.mapviewer.v1.LoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LoginRequest}
 */
proto.landscope.mapviewer.v1.LoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LoginRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LoginRequest} returns this
 */
proto.landscope.mapviewer.v1.LoginRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LoginRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LoginRequest} returns this
 */
proto.landscope.mapviewer.v1.LoginRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
sessionToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LoginResponse}
 */
proto.landscope.mapviewer.v1.LoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LoginResponse;
  return proto.landscope.mapviewer.v1.LoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LoginResponse}
 */
proto.landscope.mapviewer.v1.LoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.LoginResponse} returns this
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LoginResponse} returns this
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string session_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LoginResponse} returns this
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string session_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LoginResponse} returns this
 */
proto.landscope.mapviewer.v1.LoginResponse.prototype.setSessionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateDemoAccessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateDemoAccessRequest;
  return proto.landscope.mapviewer.v1.CreateDemoAccessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateDemoAccessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessRequest.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateDemoAccessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
sessionToken: jspb.Message.getFieldWithDefault(msg, 4, ""),
hasExistingAccount: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateDemoAccessResponse;
  return proto.landscope.mapviewer.v1.CreateDemoAccessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionToken(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasExistingAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateDemoAccessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHasExistingAccount();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string session_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string session_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.setSessionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool has_existing_account = 5;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.getHasExistingAccount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateDemoAccessResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateDemoAccessResponse.prototype.setHasExistingAccount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.StartExternalLoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
provider: jspb.Message.getFieldWithDefault(msg, 1, 0),
referralCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginRequest}
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.StartExternalLoginRequest;
  return proto.landscope.mapviewer.v1.StartExternalLoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginRequest}
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.ExternalProvider} */ (reader.readEnum());
      msg.setProvider(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReferralCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.StartExternalLoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProvider();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReferralCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ExternalProvider provider = 1;
 * @return {!proto.landscope.mapviewer.v1.ExternalProvider}
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.prototype.getProvider = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ExternalProvider} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExternalProvider} value
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} returns this
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.prototype.setProvider = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string referral_code = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.prototype.getReferralCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginRequest} returns this
 */
proto.landscope.mapviewer.v1.StartExternalLoginRequest.prototype.setReferralCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.StartExternalLoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
authUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginResponse}
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.StartExternalLoginResponse;
  return proto.landscope.mapviewer.v1.StartExternalLoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginResponse}
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAuthUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.StartExternalLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.StartExternalLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auth_url = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.prototype.getAuthUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StartExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.StartExternalLoginResponse.prototype.setAuthUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
intentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
intentToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
referralCode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CompleteExternalLoginRequest;
  return proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIntentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIntentToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReferralCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntentToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReferralCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string intent_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.getIntentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.setIntentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string intent_token = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.getIntentToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.setIntentToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string referral_code = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.getReferralCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginRequest} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginRequest.prototype.setReferralCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
sessionToken: jspb.Message.getFieldWithDefault(msg, 4, ""),
email: jspb.Message.getFieldWithDefault(msg, 5, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 6, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CompleteExternalLoginResponse;
  return proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string session_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string session_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setSessionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string first_name = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string last_name = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CompleteExternalLoginResponse} returns this
 */
proto.landscope.mapviewer.v1.CompleteExternalLoginResponse.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RequestPasswordResetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RequestPasswordResetResponse;
  return proto.landscope.mapviewer.v1.RequestPasswordResetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RequestPasswordResetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestPasswordResetResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest;
  return proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest} returns this
 */
proto.landscope.mapviewer.v1.RequestPasswordResetByEmailRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ResetPasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
resetCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
newPassword: jspb.Message.getFieldWithDefault(msg, 3, ""),
csrfToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordRequest}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ResetPasswordRequest;
  return proto.landscope.mapviewer.v1.ResetPasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordRequest}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setResetCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNewPassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCsrfToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ResetPasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResetCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCsrfToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordRequest} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reset_code = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.getResetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordRequest} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.setResetCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string new_password = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordRequest} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string csrf_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.getCsrfToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordRequest} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordRequest.prototype.setCsrfToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ResetPasswordResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
sessionToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordResponse}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ResetPasswordResponse;
  return proto.landscope.mapviewer.v1.ResetPasswordResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordResponse}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ResetPasswordResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ResetPasswordResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordResponse} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordResponse} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string session_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordResponse} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string session_token = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResetPasswordResponse} returns this
 */
proto.landscope.mapviewer.v1.ResetPasswordResponse.prototype.setSessionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCurrentUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserRequest}
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCurrentUserRequest;
  return proto.landscope.mapviewer.v1.GetCurrentUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserRequest}
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCurrentUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCurrentUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
loginMethod: jspb.Message.getFieldWithDefault(msg, 4, 0),
userId: jspb.Message.getFieldWithDefault(msg, 5, ""),
commentColor: jspb.Message.getFieldWithDefault(msg, 6, ""),
avatarUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
needsUsagePurpose: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
activeWorkspace: (f = msg.getActiveWorkspace()) && proto.landscope.mapviewer.v1.WorkspaceInfo.toObject(includeInstance, f),
accountDeletion: (f = msg.getAccountDeletion()) && proto.landscope.mapviewer.v1.AccountDeletionTerms.toObject(includeInstance, f),
needsConsentChoice: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
avatar: jspb.Message.getFieldWithDefault(msg, 12, ""),
usagePurpose: jspb.Message.getFieldWithDefault(msg, 13, 0),
teamSize: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCurrentUserResponse;
  return proto.landscope.mapviewer.v1.GetCurrentUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {!proto.landscope.mapviewer.v1.LoginMethod} */ (reader.readEnum());
      msg.setLoginMethod(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentColor(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAvatarUrl(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeedsUsagePurpose(value);
      break;
    case 9:
      var value = new proto.landscope.mapviewer.v1.WorkspaceInfo;
      reader.readMessage(value,proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader);
      msg.setActiveWorkspace(value);
      break;
    case 10:
      var value = new proto.landscope.mapviewer.v1.AccountDeletionTerms;
      reader.readMessage(value,proto.landscope.mapviewer.v1.AccountDeletionTerms.deserializeBinaryFromReader);
      msg.setAccountDeletion(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeedsConsentChoice(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAvatar(value);
      break;
    case 13:
      var value = /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (reader.readEnum());
      msg.setUsagePurpose(value);
      break;
    case 14:
      var value = /** @type {!proto.landscope.mapviewer.v1.TeamSize} */ (reader.readEnum());
      msg.setTeamSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCurrentUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLoginMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCommentColor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAvatarUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNeedsUsagePurpose();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getActiveWorkspace();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter
    );
  }
  f = message.getAccountDeletion();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.landscope.mapviewer.v1.AccountDeletionTerms.serializeBinaryToWriter
    );
  }
  f = message.getNeedsConsentChoice();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUsagePurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getTeamSize();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional LoginMethod login_method = 4;
 * @return {!proto.landscope.mapviewer.v1.LoginMethod}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getLoginMethod = function() {
  return /** @type {!proto.landscope.mapviewer.v1.LoginMethod} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.LoginMethod} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setLoginMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string user_id = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string comment_color = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getCommentColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setCommentColor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string avatar_url = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getAvatarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setAvatarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool needs_usage_purpose = 8;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getNeedsUsagePurpose = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setNeedsUsagePurpose = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional WorkspaceInfo active_workspace = 9;
 * @return {?proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getActiveWorkspace = function() {
  return /** @type{?proto.landscope.mapviewer.v1.WorkspaceInfo} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.WorkspaceInfo, 9));
};


/**
 * @param {?proto.landscope.mapviewer.v1.WorkspaceInfo|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
*/
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setActiveWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.clearActiveWorkspace = function() {
  return this.setActiveWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.hasActiveWorkspace = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional AccountDeletionTerms account_deletion = 10;
 * @return {?proto.landscope.mapviewer.v1.AccountDeletionTerms}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getAccountDeletion = function() {
  return /** @type{?proto.landscope.mapviewer.v1.AccountDeletionTerms} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.AccountDeletionTerms, 10));
};


/**
 * @param {?proto.landscope.mapviewer.v1.AccountDeletionTerms|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
*/
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setAccountDeletion = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.clearAccountDeletion = function() {
  return this.setAccountDeletion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.hasAccountDeletion = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool needs_consent_choice = 11;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getNeedsConsentChoice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setNeedsConsentChoice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string avatar = 12;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional UsagePurpose usage_purpose = 13;
 * @return {!proto.landscope.mapviewer.v1.UsagePurpose}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getUsagePurpose = function() {
  return /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.UsagePurpose} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setUsagePurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional TeamSize team_size = 14;
 * @return {!proto.landscope.mapviewer.v1.TeamSize}
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.getTeamSize = function() {
  return /** @type {!proto.landscope.mapviewer.v1.TeamSize} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.TeamSize} value
 * @return {!proto.landscope.mapviewer.v1.GetCurrentUserResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCurrentUserResponse.prototype.setTeamSize = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest;
  return proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UsagePurposeOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
detail: jspb.Message.getFieldWithDefault(msg, 3, ""),
avatar: jspb.Message.getFieldWithDefault(msg, 4, ""),
requiresDescription: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UsagePurposeOption;
  return proto.landscope.mapviewer.v1.UsagePurposeOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (reader.readEnum());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDetail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAvatar(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UsagePurposeOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRequiresDescription();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional UsagePurpose value = 1;
 * @return {!proto.landscope.mapviewer.v1.UsagePurpose}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.getValue = function() {
  return /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.UsagePurpose} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string detail = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string avatar = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool requires_description = 5;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.getRequiresDescription = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeOption.prototype.setRequiresDescription = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UsagePurposeGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.landscope.mapviewer.v1.UsagePurposeOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UsagePurposeGroup;
  return proto.landscope.mapviewer.v1.UsagePurposeGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLabel(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.UsagePurposeOption;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UsagePurposeOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UsagePurposeGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.UsagePurposeOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated UsagePurposeOption options = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.UsagePurposeOption>}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.UsagePurposeOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.UsagePurposeOption, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.UsagePurposeOption>} value
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup} returns this
*/
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeOption}
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.UsagePurposeOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup} returns this
 */
proto.landscope.mapviewer.v1.UsagePurposeGroup.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.TeamSizeOption.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.TeamSizeOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.TeamSizeOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.TeamSizeOption.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0),
label: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.TeamSizeOption}
 */
proto.landscope.mapviewer.v1.TeamSizeOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.TeamSizeOption;
  return proto.landscope.mapviewer.v1.TeamSizeOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.TeamSizeOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.TeamSizeOption}
 */
proto.landscope.mapviewer.v1.TeamSizeOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.TeamSize} */ (reader.readEnum());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.TeamSizeOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.TeamSizeOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.TeamSizeOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.TeamSizeOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TeamSize value = 1;
 * @return {!proto.landscope.mapviewer.v1.TeamSize}
 */
proto.landscope.mapviewer.v1.TeamSizeOption.prototype.getValue = function() {
  return /** @type {!proto.landscope.mapviewer.v1.TeamSize} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.TeamSize} value
 * @return {!proto.landscope.mapviewer.v1.TeamSizeOption} returns this
 */
proto.landscope.mapviewer.v1.TeamSizeOption.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.TeamSizeOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.TeamSizeOption} returns this
 */
proto.landscope.mapviewer.v1.TeamSizeOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.landscope.mapviewer.v1.UsagePurposeGroup.toObject, includeInstance),
teamSizesList: jspb.Message.toObjectList(msg.getTeamSizesList(),
    proto.landscope.mapviewer.v1.TeamSizeOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse;
  return proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UsagePurposeGroup;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UsagePurposeGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.TeamSizeOption;
      reader.readMessage(value,proto.landscope.mapviewer.v1.TeamSizeOption.deserializeBinaryFromReader);
      msg.addTeamSizes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UsagePurposeGroup.serializeBinaryToWriter
    );
  }
  f = message.getTeamSizesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.TeamSizeOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UsagePurposeGroup groups = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.UsagePurposeGroup>}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.UsagePurposeGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.UsagePurposeGroup, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.UsagePurposeGroup>} value
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} returns this
*/
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UsagePurposeGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.UsagePurposeGroup}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.UsagePurposeGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * repeated TeamSizeOption team_sizes = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.TeamSizeOption>}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.getTeamSizesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.TeamSizeOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.TeamSizeOption, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.TeamSizeOption>} value
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} returns this
*/
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.setTeamSizesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.TeamSizeOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.TeamSizeOption}
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.addTeamSizes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.TeamSizeOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListUsagePurposeOptionsResponse.prototype.clearTeamSizesList = function() {
  return this.setTeamSizesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.AccountDeletionTerms.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.AccountDeletionTerms} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.toObject = function(includeInstance, msg) {
  var f, obj = {
consequencesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
reasonMaxLength: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.AccountDeletionTerms}
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.AccountDeletionTerms;
  return proto.landscope.mapviewer.v1.AccountDeletionTerms.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.AccountDeletionTerms} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.AccountDeletionTerms}
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addConsequences(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReasonMaxLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.AccountDeletionTerms.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.AccountDeletionTerms} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConsequencesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getReasonMaxLength();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated string consequences = 1;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.getConsequencesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.AccountDeletionTerms} returns this
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.setConsequencesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.AccountDeletionTerms} returns this
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.addConsequences = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.AccountDeletionTerms} returns this
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.clearConsequencesList = function() {
  return this.setConsequencesList([]);
};


/**
 * optional int32 reason_max_length = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.getReasonMaxLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.AccountDeletionTerms} returns this
 */
proto.landscope.mapviewer.v1.AccountDeletionTerms.prototype.setReasonMaxLength = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.WorkspaceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.WorkspaceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
role: jspb.Message.getFieldWithDefault(msg, 3, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
plansList: jspb.Message.toObjectList(msg.getPlansList(),
    proto.landscope.mapviewer.v1.AccountPlan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.WorkspaceInfo;
  return proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.WorkspaceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 6:
      var value = new proto.landscope.mapviewer.v1.AccountPlan;
      reader.readMessage(value,proto.landscope.mapviewer.v1.AccountPlan.deserializeBinaryFromReader);
      msg.addPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.WorkspaceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.landscope.mapviewer.v1.AccountPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string role = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_active = 4;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated AccountPlan plans = 6;
 * @return {!Array<!proto.landscope.mapviewer.v1.AccountPlan>}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.getPlansList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.AccountPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.AccountPlan, 6));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.AccountPlan>} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo} returns this
*/
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.setPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.AccountPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.AccountPlan}
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.addPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.landscope.mapviewer.v1.AccountPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceInfo.prototype.clearPlansList = function() {
  return this.setPlansList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspacesList: jspb.Message.toObjectList(msg.getWorkspacesList(),
    proto.landscope.mapviewer.v1.WorkspaceInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse}
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListMyWorkspacesResponse;
  return proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse}
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.WorkspaceInfo;
      reader.readMessage(value,proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader);
      msg.addWorkspaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspacesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WorkspaceInfo workspaces = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.WorkspaceInfo>}
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.prototype.getWorkspacesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.WorkspaceInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.WorkspaceInfo, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.WorkspaceInfo>} value
 * @return {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse} returns this
*/
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.prototype.setWorkspacesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.WorkspaceInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.prototype.addWorkspaces = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.WorkspaceInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListMyWorkspacesResponse} returns this
 */
proto.landscope.mapviewer.v1.ListMyWorkspacesResponse.prototype.clearWorkspacesList = function() {
  return this.setWorkspacesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest;
  return proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest} returns this
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspace: (f = msg.getWorkspace()) && proto.landscope.mapviewer.v1.WorkspaceInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse;
  return proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.WorkspaceInfo;
      reader.readMessage(value,proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkspaceInfo workspace = 1;
 * @return {?proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.prototype.getWorkspace = function() {
  return /** @type{?proto.landscope.mapviewer.v1.WorkspaceInfo} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.WorkspaceInfo, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.WorkspaceInfo|undefined} value
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse} returns this
*/
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse} returns this
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SetActiveWorkspaceResponse.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
role: jspb.Message.getFieldWithDefault(msg, 5, ""),
acknowledgeSeatCharge: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest;
  return proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRole(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAcknowledgeSeatCharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string role = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool acknowledge_seat_charge = 6;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.getAcknowledgeSeatCharge = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.setAcknowledgeSeatCharge = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.clearAcknowledgeSeatCharge = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberRequest.prototype.hasAcknowledgeSeatCharge = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
userWasCreated: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
userNotFound: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse;
  return proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserWasCreated(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserNotFound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserWasCreated();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getUserNotFound();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool user_was_created = 3;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.getUserWasCreated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.setUserWasCreated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool user_not_found = 4;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.getUserNotFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteWorkspaceMemberResponse.prototype.setUserNotFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest;
  return proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest} returns this
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.WorkspaceMemberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
role: jspb.Message.getFieldWithDefault(msg, 5, ""),
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
grantedAt: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.WorkspaceMemberInfo;
  return proto.landscope.mapviewer.v1.WorkspaceMemberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRole(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGrantedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.WorkspaceMemberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGrantedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string role = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 granted_at = 7;
 * @return {number}
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.getGrantedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo} returns this
 */
proto.landscope.mapviewer.v1.WorkspaceMemberInfo.prototype.setGrantedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.landscope.mapviewer.v1.WorkspaceMemberInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse;
  return proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.WorkspaceMemberInfo;
      reader.readMessage(value,proto.landscope.mapviewer.v1.WorkspaceMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.WorkspaceMemberInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WorkspaceMemberInfo members = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.WorkspaceMemberInfo>}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.WorkspaceMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.WorkspaceMemberInfo, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.WorkspaceMemberInfo>} value
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse} returns this
*/
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.WorkspaceMemberInfo}
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.WorkspaceMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse} returns this
 */
proto.landscope.mapviewer.v1.ListWorkspaceMembersResponse.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateWorkspaceRequest;
  return proto.landscope.mapviewer.v1.CreateWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateWorkspaceRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateWorkspaceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspace: (f = msg.getWorkspace()) && proto.landscope.mapviewer.v1.WorkspaceInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateWorkspaceResponse;
  return proto.landscope.mapviewer.v1.CreateWorkspaceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.WorkspaceInfo;
      reader.readMessage(value,proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateWorkspaceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkspaceInfo workspace = 1;
 * @return {?proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.prototype.getWorkspace = function() {
  return /** @type{?proto.landscope.mapviewer.v1.WorkspaceInfo} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.WorkspaceInfo, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.WorkspaceInfo|undefined} value
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse} returns this
*/
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateWorkspaceResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateWorkspaceResponse.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RenameWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RenameWorkspaceRequest;
  return proto.landscope.mapviewer.v1.RenameWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RenameWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} returns this
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceRequest} returns this
 */
proto.landscope.mapviewer.v1.RenameWorkspaceRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RenameWorkspaceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspace: (f = msg.getWorkspace()) && proto.landscope.mapviewer.v1.WorkspaceInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RenameWorkspaceResponse;
  return proto.landscope.mapviewer.v1.RenameWorkspaceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.WorkspaceInfo;
      reader.readMessage(value,proto.landscope.mapviewer.v1.WorkspaceInfo.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RenameWorkspaceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.WorkspaceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkspaceInfo workspace = 1;
 * @return {?proto.landscope.mapviewer.v1.WorkspaceInfo}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.prototype.getWorkspace = function() {
  return /** @type{?proto.landscope.mapviewer.v1.WorkspaceInfo} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.WorkspaceInfo, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.WorkspaceInfo|undefined} value
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse} returns this
*/
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.RenameWorkspaceResponse} returns this
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RenameWorkspaceResponse.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
memberUserId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest;
  return proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMemberUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMemberUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string member_user_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.prototype.getMemberUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest} returns this
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberRequest.prototype.setMemberUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse;
  return proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse} returns this
 */
proto.landscope.mapviewer.v1.RemoveWorkspaceMemberResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
commentColor: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateProfileRequest}
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateProfileRequest;
  return proto.landscope.mapviewer.v1.UpdateProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateProfileRequest}
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentColor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string comment_color = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.prototype.getCommentColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProfileRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProfileRequest.prototype.setCommentColor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
commentColor: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateProfileResponse}
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateProfileResponse;
  return proto.landscope.mapviewer.v1.UpdateProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateProfileResponse}
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentColor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string comment_color = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.prototype.getCommentColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProfileResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateProfileResponse.prototype.setCommentColor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetUsagePurposeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
usagePurpose: jspb.Message.getFieldWithDefault(msg, 1, 0),
otherUsageDescription: jspb.Message.getFieldWithDefault(msg, 2, ""),
marketingEmailConsent: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
adAudienceConsent: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
consentWordingVersions: (f = msg.getConsentWordingVersions()) && proto.landscope.mapviewer.v1.ConsentWordingVersions.toObject(includeInstance, f),
teamSize: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetUsagePurposeRequest;
  return proto.landscope.mapviewer.v1.SetUsagePurposeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (reader.readEnum());
      msg.setUsagePurpose(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOtherUsageDescription(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarketingEmailConsent(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdAudienceConsent(value);
      break;
    case 5:
      var value = new proto.landscope.mapviewer.v1.ConsentWordingVersions;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ConsentWordingVersions.deserializeBinaryFromReader);
      msg.setConsentWordingVersions(value);
      break;
    case 6:
      var value = /** @type {!proto.landscope.mapviewer.v1.TeamSize} */ (reader.readEnum());
      msg.setTeamSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetUsagePurposeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsagePurpose();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOtherUsageDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMarketingEmailConsent();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAdAudienceConsent();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getConsentWordingVersions();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.landscope.mapviewer.v1.ConsentWordingVersions.serializeBinaryToWriter
    );
  }
  f = message.getTeamSize();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional UsagePurpose usage_purpose = 1;
 * @return {!proto.landscope.mapviewer.v1.UsagePurpose}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.getUsagePurpose = function() {
  return /** @type {!proto.landscope.mapviewer.v1.UsagePurpose} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.UsagePurpose} value
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.setUsagePurpose = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string other_usage_description = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.getOtherUsageDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.setOtherUsageDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool marketing_email_consent = 3;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.getMarketingEmailConsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.setMarketingEmailConsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool ad_audience_consent = 4;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.getAdAudienceConsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.setAdAudienceConsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional ConsentWordingVersions consent_wording_versions = 5;
 * @return {?proto.landscope.mapviewer.v1.ConsentWordingVersions}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.getConsentWordingVersions = function() {
  return /** @type{?proto.landscope.mapviewer.v1.ConsentWordingVersions} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.ConsentWordingVersions, 5));
};


/**
 * @param {?proto.landscope.mapviewer.v1.ConsentWordingVersions|undefined} value
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
*/
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.setConsentWordingVersions = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.clearConsentWordingVersions = function() {
  return this.setConsentWordingVersions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.hasConsentWordingVersions = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TeamSize team_size = 6;
 * @return {!proto.landscope.mapviewer.v1.TeamSize}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.getTeamSize = function() {
  return /** @type {!proto.landscope.mapviewer.v1.TeamSize} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.TeamSize} value
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetUsagePurposeRequest.prototype.setTeamSize = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetUsagePurposeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeResponse}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetUsagePurposeResponse;
  return proto.landscope.mapviewer.v1.SetUsagePurposeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetUsagePurposeResponse}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetUsagePurposeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetUsagePurposeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetUsagePurposeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UploadAvatarRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
image: msg.getImage_asB64(),
contentType: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarRequest}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UploadAvatarRequest;
  return proto.landscope.mapviewer.v1.UploadAvatarRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarRequest}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UploadAvatarRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImage_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bytes image = 1;
 * @return {!(string|Uint8Array)}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.getImage = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes image = 1;
 * This is a type-conversion wrapper around `getImage()`
 * @return {string}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.getImage_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImage()));
};


/**
 * optional bytes image = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImage()`
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.getImage_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImage()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarRequest} returns this
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.setImage = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string content_type = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarRequest} returns this
 */
proto.landscope.mapviewer.v1.UploadAvatarRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UploadAvatarResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
avatarUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarResponse}
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UploadAvatarResponse;
  return proto.landscope.mapviewer.v1.UploadAvatarResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarResponse}
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAvatarUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UploadAvatarResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UploadAvatarResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvatarUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string avatar_url = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.prototype.getAvatarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UploadAvatarResponse} returns this
 */
proto.landscope.mapviewer.v1.UploadAvatarResponse.prototype.setAvatarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveAvatarRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveAvatarRequest}
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveAvatarRequest;
  return proto.landscope.mapviewer.v1.RemoveAvatarRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveAvatarRequest}
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveAvatarRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveAvatarRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveAvatarResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveAvatarResponse}
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveAvatarResponse;
  return proto.landscope.mapviewer.v1.RemoveAvatarResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveAvatarResponse}
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveAvatarResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveAvatarResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveAvatarResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LogoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LogoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LogoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LogoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LogoutRequest}
 */
proto.landscope.mapviewer.v1.LogoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LogoutRequest;
  return proto.landscope.mapviewer.v1.LogoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LogoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LogoutRequest}
 */
proto.landscope.mapviewer.v1.LogoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LogoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LogoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LogoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LogoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LogoutRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LogoutRequest} returns this
 */
proto.landscope.mapviewer.v1.LogoutRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LogoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LogoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LogoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LogoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LogoutResponse}
 */
proto.landscope.mapviewer.v1.LogoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LogoutResponse;
  return proto.landscope.mapviewer.v1.LogoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LogoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LogoutResponse}
 */
proto.landscope.mapviewer.v1.LogoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LogoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LogoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LogoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LogoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.LogoutResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.LogoutResponse} returns this
 */
proto.landscope.mapviewer.v1.LogoutResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LogoutResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LogoutResponse} returns this
 */
proto.landscope.mapviewer.v1.LogoutResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculateAreaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
coordinatesList: jspb.Message.toObjectList(msg.getCoordinatesList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
bufferMeters: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaRequest}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculateAreaRequest;
  return proto.landscope.mapviewer.v1.CalculateAreaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaRequest}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addCoordinates(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBufferMeters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculateAreaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated Coordinate coordinates = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.getCoordinatesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaRequest} returns this
*/
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.setCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.addCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.clearCoordinatesList = function() {
  return this.setCoordinatesList([]);
};


/**
 * optional int32 buffer_meters = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.getBufferMeters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.setBufferMeters = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.clearBufferMeters = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CalculateAreaRequest.prototype.hasBufferMeters = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculateAreaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
projectAreaAcres: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
bufferAreaAcres: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
bufferPolygonList: jspb.Message.toObjectList(msg.getBufferPolygonList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculateAreaResponse;
  return proto.landscope.mapviewer.v1.CalculateAreaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProjectAreaAcres(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBufferAreaAcres(value);
      break;
    case 5:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addBufferPolygon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculateAreaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculateAreaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectAreaAcres();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getBufferAreaAcres();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getBufferPolygonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double project_area_acres = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.getProjectAreaAcres = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.setProjectAreaAcres = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double buffer_area_acres = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.getBufferAreaAcres = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.setBufferAreaAcres = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated Coordinate buffer_polygon = 5;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.getBufferPolygonList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 5));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.setBufferPolygonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.addBufferPolygon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculateAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculateAreaResponse.prototype.clearBufferPolygonList = function() {
  return this.setBufferPolygonList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SearchAddressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SearchAddressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
searchText: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SearchAddressRequest}
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SearchAddressRequest;
  return proto.landscope.mapviewer.v1.SearchAddressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SearchAddressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SearchAddressRequest}
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSearchText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SearchAddressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SearchAddressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string search_text = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SearchAddressRequest} returns this
 */
proto.landscope.mapviewer.v1.SearchAddressRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SearchAddressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SearchAddressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.landscope.mapviewer.v1.AddressResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SearchAddressResponse}
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SearchAddressResponse;
  return proto.landscope.mapviewer.v1.SearchAddressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SearchAddressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SearchAddressResponse}
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.AddressResult;
      reader.readMessage(value,proto.landscope.mapviewer.v1.AddressResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SearchAddressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SearchAddressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.AddressResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddressResult results = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.AddressResult>}
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.AddressResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.AddressResult, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.AddressResult>} value
 * @return {!proto.landscope.mapviewer.v1.SearchAddressResponse} returns this
*/
proto.landscope.mapviewer.v1.SearchAddressResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.AddressResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.AddressResult}
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.AddressResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.SearchAddressResponse} returns this
 */
proto.landscope.mapviewer.v1.SearchAddressResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.AddressResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.AddressResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AddressResult.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.AddressResult}
 */
proto.landscope.mapviewer.v1.AddressResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.AddressResult;
  return proto.landscope.mapviewer.v1.AddressResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.AddressResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.AddressResult}
 */
proto.landscope.mapviewer.v1.AddressResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.AddressResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.AddressResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AddressResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.AddressResult} returns this
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.AddressResult} returns this
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.AddressResult} returns this
 */
proto.landscope.mapviewer.v1.AddressResult.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ProjectRef.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ProjectRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ProjectRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ProjectRef.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ProjectRef}
 */
proto.landscope.mapviewer.v1.ProjectRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ProjectRef;
  return proto.landscope.mapviewer.v1.ProjectRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ProjectRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ProjectRef}
 */
proto.landscope.mapviewer.v1.ProjectRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ProjectRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ProjectRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ProjectRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ProjectRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectRef.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectRef} returns this
 */
proto.landscope.mapviewer.v1.ProjectRef.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.Project.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.Project.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.Project} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Project.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
bounds: (f = msg.getBounds()) && proto.landscope.mapviewer.v1.GeospatialBounds.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.Project}
 */
proto.landscope.mapviewer.v1.Project.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.Project;
  return proto.landscope.mapviewer.v1.Project.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.Project} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.Project}
 */
proto.landscope.mapviewer.v1.Project.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.GeospatialBounds;
      reader.readMessage(value,proto.landscope.mapviewer.v1.GeospatialBounds.deserializeBinaryFromReader);
      msg.setBounds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.Project.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.Project.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.Project} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Project.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBounds();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.GeospatialBounds.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Project.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Project} returns this
 */
proto.landscope.mapviewer.v1.Project.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Project.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Project} returns this
 */
proto.landscope.mapviewer.v1.Project.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional GeospatialBounds bounds = 3;
 * @return {?proto.landscope.mapviewer.v1.GeospatialBounds}
 */
proto.landscope.mapviewer.v1.Project.prototype.getBounds = function() {
  return /** @type{?proto.landscope.mapviewer.v1.GeospatialBounds} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.GeospatialBounds, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.GeospatialBounds|undefined} value
 * @return {!proto.landscope.mapviewer.v1.Project} returns this
*/
proto.landscope.mapviewer.v1.Project.prototype.setBounds = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.Project} returns this
 */
proto.landscope.mapviewer.v1.Project.prototype.clearBounds = function() {
  return this.setBounds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Project.prototype.hasBounds = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Project.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Project} returns this
 */
proto.landscope.mapviewer.v1.Project.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ProjectFolder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ProjectFolder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ProjectFolder.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, ""),
parentId: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder}
 */
proto.landscope.mapviewer.v1.ProjectFolder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ProjectFolder;
  return proto.landscope.mapviewer.v1.ProjectFolder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ProjectFolder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder}
 */
proto.landscope.mapviewer.v1.ProjectFolder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ProjectFolder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ProjectFolder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ProjectFolder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder} returns this
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder} returns this
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder} returns this
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder} returns this
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string parent_id = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder} returns this
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ProjectFolder} returns this
 */
proto.landscope.mapviewer.v1.ProjectFolder.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ArtifactMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ArtifactMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
folderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, 0),
metadata: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
presignedUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
bounds: (f = msg.getBounds()) && proto.landscope.mapviewer.v1.GeospatialBounds.toObject(includeInstance, f),
sortOrder: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ArtifactMetadata;
  return proto.landscope.mapviewer.v1.ArtifactMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ArtifactMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.landscope.mapviewer.v1.ArtifactType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMetadata(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPresignedUrl(value);
      break;
    case 8:
      var value = new proto.landscope.mapviewer.v1.GeospatialBounds;
      reader.readMessage(value,proto.landscope.mapviewer.v1.GeospatialBounds.deserializeBinaryFromReader);
      msg.setBounds(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ArtifactMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ArtifactMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMetadata();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPresignedUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBounds();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.landscope.mapviewer.v1.GeospatialBounds.serializeBinaryToWriter
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string folder_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ArtifactType type = 4;
 * @return {!proto.landscope.mapviewer.v1.ArtifactType}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getType = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ArtifactType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ArtifactType} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string metadata = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getMetadata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setMetadata = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string presigned_url = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getPresignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setPresignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional GeospatialBounds bounds = 8;
 * @return {?proto.landscope.mapviewer.v1.GeospatialBounds}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getBounds = function() {
  return /** @type{?proto.landscope.mapviewer.v1.GeospatialBounds} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.GeospatialBounds, 8));
};


/**
 * @param {?proto.landscope.mapviewer.v1.GeospatialBounds|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
*/
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setBounds = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.clearBounds = function() {
  return this.setBounds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.hasBounds = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 sort_order = 9;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactMetadata} returns this
 */
proto.landscope.mapviewer.v1.ArtifactMetadata.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GeospatialBounds.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GeospatialBounds} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GeospatialBounds.toObject = function(includeInstance, msg) {
  var f, obj = {
west: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
south: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
east: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
north: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GeospatialBounds}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GeospatialBounds;
  return proto.landscope.mapviewer.v1.GeospatialBounds.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GeospatialBounds} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GeospatialBounds}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWest(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSouth(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEast(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNorth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GeospatialBounds.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GeospatialBounds} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GeospatialBounds.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWest();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSouth();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEast();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getNorth();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional double west = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.getWest = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GeospatialBounds} returns this
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.setWest = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double south = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.getSouth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GeospatialBounds} returns this
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.setSouth = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double east = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.getEast = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GeospatialBounds} returns this
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.setEast = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double north = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.getNorth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GeospatialBounds} returns this
 */
proto.landscope.mapviewer.v1.GeospatialBounds.prototype.setNorth = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CustomContour.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CustomContour.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CustomContour} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CustomContour.toObject = function(includeInstance, msg) {
  var f, obj = {
unit: jspb.Message.getFieldWithDefault(msg, 1, ""),
intervalValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CustomContour}
 */
proto.landscope.mapviewer.v1.CustomContour.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CustomContour;
  return proto.landscope.mapviewer.v1.CustomContour.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CustomContour} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CustomContour}
 */
proto.landscope.mapviewer.v1.CustomContour.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUnit(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setIntervalValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CustomContour.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CustomContour.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CustomContour} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CustomContour.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntervalValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string unit = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CustomContour.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CustomContour} returns this
 */
proto.landscope.mapviewer.v1.CustomContour.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double interval_value = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CustomContour.prototype.getIntervalValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CustomContour} returns this
 */
proto.landscope.mapviewer.v1.CustomContour.prototype.setIntervalValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.repeatedFields_ = [3,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
coordinatesList: jspb.Message.toObjectList(msg.getCoordinatesList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
bufferMeters: jspb.Message.getFieldWithDefault(msg, 4, 0),
areaAcres: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
standardContourUnit: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
customContoursList: jspb.Message.toObjectList(msg.getCustomContoursList(),
    proto.landscope.mapviewer.v1.CustomContour.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest;
  return proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addCoordinates(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBufferMeters(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAreaAcres(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStandardContourUnit(value);
      break;
    case 7:
      var value = new proto.landscope.mapviewer.v1.CustomContour;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CustomContour.deserializeBinaryFromReader);
      msg.addCustomContours(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getBufferMeters();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAreaAcres();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCustomContoursList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.landscope.mapviewer.v1.CustomContour.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Coordinate coordinates = 3;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getCoordinatesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 3));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
*/
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.addCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.clearCoordinatesList = function() {
  return this.setCoordinatesList([]);
};


/**
 * optional int32 buffer_meters = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getBufferMeters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setBufferMeters = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double area_acres = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getAreaAcres = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setAreaAcres = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string standard_contour_unit = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getStandardContourUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setStandardContourUnit = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.clearStandardContourUnit = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.hasStandardContourUnit = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated CustomContour custom_contours = 7;
 * @return {!Array<!proto.landscope.mapviewer.v1.CustomContour>}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.getCustomContoursList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.CustomContour>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.CustomContour, 7));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.CustomContour>} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
*/
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.setCustomContoursList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CustomContour=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.CustomContour}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.addCustomContours = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.landscope.mapviewer.v1.CustomContour, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest.prototype.clearCustomContoursList = function() {
  return this.setCustomContoursList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
gateOutcome: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
redirectedToProjectId: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse;
  return proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGateOutcome(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRedirectedToProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string gate_outcome = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.getGateOutcome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.setGateOutcome = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.clearGateOutcome = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.hasGateOutcome = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string redirected_to_project_id = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.getRedirectedToProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.setRedirectedToProjectId = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.clearRedirectedToProjectId = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.NewProjectFromPolygonResponse.prototype.hasRedirectedToProjectId = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest;
  return proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
uploadUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
objectKey: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse;
  return proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUploadUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setObjectKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUploadUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getObjectKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string upload_url = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.getUploadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.setUploadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string object_key = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.getObjectKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse} returns this
 */
proto.landscope.mapviewer.v1.NewProjectFromDEMInitResponse.prototype.setObjectKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.StartDemoProcessingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.StartDemoProcessingRequest;
  return proto.landscope.mapviewer.v1.StartDemoProcessingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.StartDemoProcessingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingRequest} returns this
 */
proto.landscope.mapviewer.v1.StartDemoProcessingRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.StartDemoProcessingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
gateOutcome: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.StartDemoProcessingResponse;
  return proto.landscope.mapviewer.v1.StartDemoProcessingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGateOutcome(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.StartDemoProcessingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGateOutcome();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string gate_outcome = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.getGateOutcome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StartDemoProcessingResponse} returns this
 */
proto.landscope.mapviewer.v1.StartDemoProcessingResponse.prototype.setGateOutcome = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest;
  return proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest} returns this
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
queued: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse;
  return proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQueued(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQueued();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool queued = 3;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.getQueued = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestFullResolutionBuildResponse.prototype.setQueued = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DemoSlotHolder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DemoSlotHolder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
issuedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
slotFreesAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
demoExpiresAt: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DemoSlotHolder;
  return proto.landscope.mapviewer.v1.DemoSlotHolder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DemoSlotHolder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIssuedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSlotFreesAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDemoExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DemoSlotHolder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DemoSlotHolder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIssuedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSlotFreesAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder} returns this
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder} returns this
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 issued_at = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.getIssuedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder} returns this
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.setIssuedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 slot_frees_at = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.getSlotFreesAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder} returns this
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.setSlotFreesAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 demo_expires_at = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.getDemoExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder} returns this
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.setDemoExpiresAt = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder} returns this
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.clearDemoExpiresAt = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemoSlotHolder.prototype.hasDemoExpiresAt = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
slotsTotal: jspb.Message.getFieldWithDefault(msg, 1, 0),
slotsUsed: jspb.Message.getFieldWithDefault(msg, 2, 0),
nextSlotFreesAt: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
holdersList: jspb.Message.toObjectList(msg.getHoldersList(),
    proto.landscope.mapviewer.v1.DemoSlotHolder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse;
  return proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSlotsTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSlotsUsed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextSlotFreesAt(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.DemoSlotHolder;
      reader.readMessage(value,proto.landscope.mapviewer.v1.DemoSlotHolder.deserializeBinaryFromReader);
      msg.addHolders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlotsTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSlotsUsed();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getHoldersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.DemoSlotHolder.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 slots_total = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.getSlotsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} returns this
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.setSlotsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 slots_used = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.getSlotsUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} returns this
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.setSlotsUsed = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 next_slot_frees_at = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.getNextSlotFreesAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} returns this
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.setNextSlotFreesAt = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} returns this
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.clearNextSlotFreesAt = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.hasNextSlotFreesAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated DemoSlotHolder holders = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.DemoSlotHolder>}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.getHoldersList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.DemoSlotHolder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.DemoSlotHolder, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.DemoSlotHolder>} value
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} returns this
*/
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.setHoldersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DemoSlotHolder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.DemoSlotHolder}
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.addHolders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.DemoSlotHolder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse} returns this
 */
proto.landscope.mapviewer.v1.GetDemoSlotInfoResponse.prototype.clearHoldersList = function() {
  return this.setHoldersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestedBoundsGeojson: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
bufferBoundsGeojson: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest;
  return proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRequestedBoundsGeojson(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBufferBoundsGeojson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string requested_bounds_geojson = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.getRequestedBoundsGeojson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.setRequestedBoundsGeojson = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.clearRequestedBoundsGeojson = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.hasRequestedBoundsGeojson = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string buffer_bounds_geojson = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.getBufferBoundsGeojson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.setBufferBoundsGeojson = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.clearBufferBoundsGeojson = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadRequest.prototype.hasBufferBoundsGeojson = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ValidationError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ValidationError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ValidationError.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
userMessage: jspb.Message.getFieldWithDefault(msg, 3, ""),
detailsMap: (f = msg.getDetailsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ValidationError}
 */
proto.landscope.mapviewer.v1.ValidationError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ValidationError;
  return proto.landscope.mapviewer.v1.ValidationError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ValidationError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ValidationError}
 */
proto.landscope.mapviewer.v1.ValidationError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.ValidationErrorType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserMessage(value);
      break;
    case 4:
      var value = msg.getDetailsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readStringRequireUtf8, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ValidationError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ValidationError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ValidationError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDetailsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getDetailsMap(true),
    4,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional ValidationErrorType type = 1;
 * @return {!proto.landscope.mapviewer.v1.ValidationErrorType}
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.getType = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ValidationErrorType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ValidationErrorType} value
 * @return {!proto.landscope.mapviewer.v1.ValidationError} returns this
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidationError} returns this
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_message = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.getUserMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidationError} returns this
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.setUserMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> details = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.getDetailsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.landscope.mapviewer.v1.ValidationError} returns this
 */
proto.landscope.mapviewer.v1.ValidationError.prototype.clearDetailsMap = function() {
  this.getDetailsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
requestedBoundsGeojson: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestedAreaAcres: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
validationErrorsList: jspb.Message.toObjectList(msg.getValidationErrorsList(),
    proto.landscope.mapviewer.v1.ValidationError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse;
  return proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRequestedBoundsGeojson(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRequestedAreaAcres(value);
      break;
    case 8:
      var value = new proto.landscope.mapviewer.v1.ValidationError;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ValidationError.deserializeBinaryFromReader);
      msg.addValidationErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestedBoundsGeojson();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestedAreaAcres();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getValidationErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.landscope.mapviewer.v1.ValidationError.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string requested_bounds_geojson = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.getRequestedBoundsGeojson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.setRequestedBoundsGeojson = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double requested_area_acres = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.getRequestedAreaAcres = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.setRequestedAreaAcres = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated ValidationError validation_errors = 8;
 * @return {!Array<!proto.landscope.mapviewer.v1.ValidationError>}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.getValidationErrorsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ValidationError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ValidationError, 8));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ValidationError>} value
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} returns this
*/
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.setValidationErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ValidationError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ValidationError}
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.addValidationErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.landscope.mapviewer.v1.ValidationError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse} returns this
 */
proto.landscope.mapviewer.v1.FinalizeDEMUploadResponse.prototype.clearValidationErrorsList = function() {
  return this.setValidationErrorsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserProjectsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserProjectsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
projectsList: jspb.Message.toObjectList(msg.getProjectsList(),
    proto.landscope.mapviewer.v1.UserProject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserProjectsResponse}
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserProjectsResponse;
  return proto.landscope.mapviewer.v1.GetUserProjectsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserProjectsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserProjectsResponse}
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UserProject;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserProject.deserializeBinaryFromReader);
      msg.addProjects(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserProjectsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserProjectsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UserProject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserProject projects = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.UserProject>}
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.prototype.getProjectsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.UserProject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.UserProject, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.UserProject>} value
 * @return {!proto.landscope.mapviewer.v1.GetUserProjectsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetUserProjectsResponse.prototype.setProjectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UserProject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.UserProject}
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.prototype.addProjects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.UserProject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetUserProjectsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetUserProjectsResponse.prototype.clearProjectsList = function() {
  return this.setProjectsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.UserProject.repeatedFields_ = [4,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UserProject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UserProject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UserProject.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
requestedBoundsList: jspb.Message.toObjectList(msg.getRequestedBoundsList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
bufferMeters: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
requestedAreaAcres: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
bufferBounds: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
bufferAreaAcres: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
resultBounds: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
processingStatus: jspb.Message.getFieldWithDefault(msg, 10, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
requestedBoundsGeojson: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
demStatus: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
demoExpiresAt: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
paymentStatus: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
paymentMethod: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
displayStatus: jspb.Message.getFieldWithDefault(msg, 17, ""),
isOwner: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
standardContourUnit: (f = jspb.Message.getField(msg, 19)) == null ? undefined : f,
customContoursList: jspb.Message.toObjectList(msg.getCustomContoursList(),
    proto.landscope.mapviewer.v1.CustomContour.toObject, includeInstance),
boundaryColor: (f = jspb.Message.getField(msg, 21)) == null ? undefined : f,
demSourceType: (f = jspb.Message.getField(msg, 22)) == null ? undefined : f,
demSourceMetadata: (f = msg.getDemSourceMetadata()) && proto.landscope.mapviewer.v1.DemSourceMetadata.toObject(includeInstance, f),
scoutingGeneratedAt: (f = jspb.Message.getField(msg, 24)) == null ? undefined : f,
myRole: (f = jspb.Message.getField(msg, 25)) == null ? undefined : f,
isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
homeAccountId: (f = jspb.Message.getField(msg, 27)) == null ? undefined : f,
accessLevel: jspb.Message.getFieldWithDefault(msg, 28, 0),
hasFailedLayers: jspb.Message.getBooleanFieldWithDefault(msg, 29, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UserProject}
 */
proto.landscope.mapviewer.v1.UserProject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UserProject;
  return proto.landscope.mapviewer.v1.UserProject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UserProject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UserProject}
 */
proto.landscope.mapviewer.v1.UserProject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addRequestedBounds(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBufferMeters(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRequestedAreaAcres(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBufferBounds(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBufferAreaAcres(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setResultBounds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProcessingStatus(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRequestedBoundsGeojson(value);
      break;
    case 13:
      var value = /** @type {!proto.landscope.mapviewer.v1.DEMStatus} */ (reader.readEnum());
      msg.setDemStatus(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDemoExpiresAt(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPaymentStatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPaymentMethod(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayStatus(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOwner(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStandardContourUnit(value);
      break;
    case 20:
      var value = new proto.landscope.mapviewer.v1.CustomContour;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CustomContour.deserializeBinaryFromReader);
      msg.addCustomContours(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBoundaryColor(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDemSourceType(value);
      break;
    case 23:
      var value = new proto.landscope.mapviewer.v1.DemSourceMetadata;
      reader.readMessage(value,proto.landscope.mapviewer.v1.DemSourceMetadata.deserializeBinaryFromReader);
      msg.setDemSourceMetadata(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setScoutingGeneratedAt(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMyRole(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHomeAccountId(value);
      break;
    case 28:
      var value = /** @type {!proto.landscope.mapviewer.v1.AccessLevel} */ (reader.readEnum());
      msg.setAccessLevel(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasFailedLayers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UserProject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UserProject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UserProject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestedBoundsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getProcessingStatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {!proto.landscope.mapviewer.v1.DEMStatus} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getDisplayStatus();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getIsOwner();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCustomContoursList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      proto.landscope.mapviewer.v1.CustomContour.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeString(
      21,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDemSourceMetadata();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.landscope.mapviewer.v1.DemSourceMetadata.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getAccessLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getHasFailedLayers();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Coordinate requested_bounds = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getRequestedBoundsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
*/
proto.landscope.mapviewer.v1.UserProject.prototype.setRequestedBoundsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.addRequestedBounds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearRequestedBoundsList = function() {
  return this.setRequestedBoundsList([]);
};


/**
 * optional int32 buffer_meters = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getBufferMeters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setBufferMeters = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearBufferMeters = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasBufferMeters = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional double requested_area_acres = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getRequestedAreaAcres = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setRequestedAreaAcres = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearRequestedAreaAcres = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasRequestedAreaAcres = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string buffer_bounds = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getBufferBounds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setBufferBounds = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearBufferBounds = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasBufferBounds = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double buffer_area_acres = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getBufferAreaAcres = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setBufferAreaAcres = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearBufferAreaAcres = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasBufferAreaAcres = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string result_bounds = 9;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getResultBounds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setResultBounds = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearResultBounds = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasResultBounds = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string processing_status = 10;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getProcessingStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setProcessingStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string requested_bounds_geojson = 12;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getRequestedBoundsGeojson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setRequestedBoundsGeojson = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearRequestedBoundsGeojson = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasRequestedBoundsGeojson = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional DEMStatus dem_status = 13;
 * @return {!proto.landscope.mapviewer.v1.DEMStatus}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getDemStatus = function() {
  return /** @type {!proto.landscope.mapviewer.v1.DEMStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.DEMStatus} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setDemStatus = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearDemStatus = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasDemStatus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int64 demo_expires_at = 14;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getDemoExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setDemoExpiresAt = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearDemoExpiresAt = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasDemoExpiresAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string payment_status = 15;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getPaymentStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setPaymentStatus = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearPaymentStatus = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasPaymentStatus = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string payment_method = 16;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearPaymentMethod = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasPaymentMethod = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string display_status = 17;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getDisplayStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setDisplayStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool is_owner = 18;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getIsOwner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setIsOwner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional string standard_contour_unit = 19;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getStandardContourUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setStandardContourUnit = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearStandardContourUnit = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasStandardContourUnit = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * repeated CustomContour custom_contours = 20;
 * @return {!Array<!proto.landscope.mapviewer.v1.CustomContour>}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getCustomContoursList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.CustomContour>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.CustomContour, 20));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.CustomContour>} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
*/
proto.landscope.mapviewer.v1.UserProject.prototype.setCustomContoursList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CustomContour=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.CustomContour}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.addCustomContours = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.landscope.mapviewer.v1.CustomContour, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearCustomContoursList = function() {
  return this.setCustomContoursList([]);
};


/**
 * optional string boundary_color = 21;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getBoundaryColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setBoundaryColor = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearBoundaryColor = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasBoundaryColor = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional string dem_source_type = 22;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getDemSourceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setDemSourceType = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearDemSourceType = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasDemSourceType = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional DemSourceMetadata dem_source_metadata = 23;
 * @return {?proto.landscope.mapviewer.v1.DemSourceMetadata}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getDemSourceMetadata = function() {
  return /** @type{?proto.landscope.mapviewer.v1.DemSourceMetadata} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.DemSourceMetadata, 23));
};


/**
 * @param {?proto.landscope.mapviewer.v1.DemSourceMetadata|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
*/
proto.landscope.mapviewer.v1.UserProject.prototype.setDemSourceMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearDemSourceMetadata = function() {
  return this.setDemSourceMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasDemSourceMetadata = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional int64 scouting_generated_at = 24;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getScoutingGeneratedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setScoutingGeneratedAt = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearScoutingGeneratedAt = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasScoutingGeneratedAt = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string my_role = 25;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getMyRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setMyRole = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearMyRole = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasMyRole = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool is_demo = 26;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional string home_account_id = 27;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getHomeAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setHomeAccountId = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.clearHomeAccountId = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.hasHomeAccountId = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional AccessLevel access_level = 28;
 * @return {!proto.landscope.mapviewer.v1.AccessLevel}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getAccessLevel = function() {
  return /** @type {!proto.landscope.mapviewer.v1.AccessLevel} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.AccessLevel} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setAccessLevel = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional bool has_failed_layers = 29;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserProject.prototype.getHasFailedLayers = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UserProject} returns this
 */
proto.landscope.mapviewer.v1.UserProject.prototype.setHasFailedLayers = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
homeAccountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest;
  return proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHomeAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHomeAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string home_account_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.prototype.getHomeAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest} returns this
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeRequest.prototype.setHomeAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse;
  return proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse} returns this
 */
proto.landscope.mapviewer.v1.SetSharedProjectHomeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.repeatedFields_ = [16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DemSourceMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DemSourceMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
datasetName: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
datasetId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
resolutionMeters: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
resolutionUnits: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
acquisitionYear: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
doi: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
catalogUrl: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
citation: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
license: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
acquisitionStart: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
acquisitionEnd: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
workunitName: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
workunitId: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
qualityLevel: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
metadataLink: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
acquisitionOverlapsList: jspb.Message.toObjectList(msg.getAcquisitionOverlapsList(),
    proto.landscope.mapviewer.v1.DemAcquisitionOverlap.toObject, includeInstance),
projectName: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
acquisitionYearStart: (f = jspb.Message.getField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DemSourceMetadata;
  return proto.landscope.mapviewer.v1.DemSourceMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DemSourceMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDatasetName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDatasetId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setResolutionMeters(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setResolutionUnits(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAcquisitionYear(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDoi(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCatalogUrl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCitation(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLicense(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAcquisitionStart(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAcquisitionEnd(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkunitName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkunitId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setQualityLevel(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMetadataLink(value);
      break;
    case 16:
      var value = new proto.landscope.mapviewer.v1.DemAcquisitionOverlap;
      reader.readMessage(value,proto.landscope.mapviewer.v1.DemAcquisitionOverlap.deserializeBinaryFromReader);
      msg.addAcquisitionOverlaps(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectName(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAcquisitionYearStart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DemSourceMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DemSourceMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAcquisitionOverlapsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.landscope.mapviewer.v1.DemAcquisitionOverlap.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeInt32(
      18,
      f
    );
  }
};


/**
 * optional string dataset_name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getDatasetName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setDatasetName = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearDatasetName = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasDatasetName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string dataset_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getDatasetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setDatasetId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearDatasetId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasDatasetId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double resolution_meters = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getResolutionMeters = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setResolutionMeters = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearResolutionMeters = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasResolutionMeters = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string resolution_units = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getResolutionUnits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setResolutionUnits = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearResolutionUnits = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasResolutionUnits = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 acquisition_year = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getAcquisitionYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setAcquisitionYear = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearAcquisitionYear = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasAcquisitionYear = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string doi = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getDoi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setDoi = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearDoi = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasDoi = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string catalog_url = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getCatalogUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setCatalogUrl = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearCatalogUrl = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasCatalogUrl = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string citation = 8;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getCitation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setCitation = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearCitation = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasCitation = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string license = 9;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getLicense = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setLicense = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearLicense = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasLicense = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string acquisition_start = 10;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getAcquisitionStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setAcquisitionStart = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearAcquisitionStart = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasAcquisitionStart = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string acquisition_end = 11;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getAcquisitionEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setAcquisitionEnd = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearAcquisitionEnd = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasAcquisitionEnd = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string workunit_name = 12;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getWorkunitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setWorkunitName = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearWorkunitName = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasWorkunitName = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional int32 workunit_id = 13;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getWorkunitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setWorkunitId = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearWorkunitId = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasWorkunitId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string quality_level = 14;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getQualityLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setQualityLevel = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearQualityLevel = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasQualityLevel = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string metadata_link = 15;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getMetadataLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setMetadataLink = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearMetadataLink = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasMetadataLink = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated DemAcquisitionOverlap acquisition_overlaps = 16;
 * @return {!Array<!proto.landscope.mapviewer.v1.DemAcquisitionOverlap>}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getAcquisitionOverlapsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.DemAcquisitionOverlap>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.DemAcquisitionOverlap, 16));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.DemAcquisitionOverlap>} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
*/
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setAcquisitionOverlapsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.addAcquisitionOverlaps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.landscope.mapviewer.v1.DemAcquisitionOverlap, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearAcquisitionOverlapsList = function() {
  return this.setAcquisitionOverlapsList([]);
};


/**
 * optional string project_name = 17;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getProjectName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setProjectName = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearProjectName = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasProjectName = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int32 acquisition_year_start = 18;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.getAcquisitionYearStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.setAcquisitionYearStart = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.DemSourceMetadata} returns this
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.clearAcquisitionYearStart = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DemSourceMetadata.prototype.hasAcquisitionYearStart = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DemAcquisitionOverlap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.toObject = function(includeInstance, msg) {
  var f, obj = {
workunitName: jspb.Message.getFieldWithDefault(msg, 1, ""),
workunitId: jspb.Message.getFieldWithDefault(msg, 2, 0),
acquisitionStart: jspb.Message.getFieldWithDefault(msg, 3, ""),
acquisitionEnd: jspb.Message.getFieldWithDefault(msg, 4, ""),
qualityLevel: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DemAcquisitionOverlap;
  return proto.landscope.mapviewer.v1.DemAcquisitionOverlap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkunitName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorkunitId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAcquisitionStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAcquisitionEnd(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setQualityLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DemAcquisitionOverlap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkunitName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkunitId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAcquisitionStart();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAcquisitionEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQualityLevel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string workunit_name = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.getWorkunitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} returns this
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.setWorkunitName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 workunit_id = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.getWorkunitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} returns this
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.setWorkunitId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string acquisition_start = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.getAcquisitionStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} returns this
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.setAcquisitionStart = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string acquisition_end = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.getAcquisitionEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} returns this
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.setAcquisitionEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string quality_level = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.getQualityLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DemAcquisitionOverlap} returns this
 */
proto.landscope.mapviewer.v1.DemAcquisitionOverlap.prototype.setQualityLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
metadata: (f = msg.getMetadata()) && proto.landscope.mapviewer.v1.DemSourceMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest;
  return proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.DemSourceMetadata;
      reader.readMessage(value,proto.landscope.mapviewer.v1.DemSourceMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.DemSourceMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DemSourceMetadata metadata = 2;
 * @return {?proto.landscope.mapviewer.v1.DemSourceMetadata}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.getMetadata = function() {
  return /** @type{?proto.landscope.mapviewer.v1.DemSourceMetadata} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.DemSourceMetadata, 2));
};


/**
 * @param {?proto.landscope.mapviewer.v1.DemSourceMetadata|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} returns this
*/
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
project: (f = msg.getProject()) && proto.landscope.mapviewer.v1.UserProject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse;
  return proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.UserProject;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserProject.deserializeBinaryFromReader);
      msg.setProject(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProject();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.UserProject.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional UserProject project = 3;
 * @return {?proto.landscope.mapviewer.v1.UserProject}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.getProject = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UserProject} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UserProject, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UserProject|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} returns this
*/
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.setProject = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.clearProject = function() {
  return this.setProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataResponse.prototype.hasProject = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.Coordinate.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.Coordinate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.Coordinate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Coordinate.toObject = function(includeInstance, msg) {
  var f, obj = {
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.Coordinate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.Coordinate;
  return proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.Coordinate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.Coordinate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.Coordinate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Coordinate.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Coordinate} returns this
 */
proto.landscope.mapviewer.v1.Coordinate.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Coordinate.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Coordinate} returns this
 */
proto.landscope.mapviewer.v1.Coordinate.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ValidateCouponRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
couponCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
sku: jspb.Message.getFieldWithDefault(msg, 2, 0),
projectId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponRequest}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ValidateCouponRequest;
  return proto.landscope.mapviewer.v1.ValidateCouponRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponRequest}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponCode(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (reader.readEnum());
      msg.setSku(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ValidateCouponRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCouponCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSku();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string coupon_code = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.getCouponCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponRequest} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.setCouponCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PlanSku sku = 2;
 * @return {!proto.landscope.mapviewer.v1.PlanSku}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.getSku = function() {
  return /** @type {!proto.landscope.mapviewer.v1.PlanSku} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.PlanSku} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponRequest} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponRequest} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponRequest} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.clearProjectId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ValidateCouponRequest.prototype.hasProjectId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ValidateCouponResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
errorMessage: jspb.Message.getFieldWithDefault(msg, 2, ""),
affiliateId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
couponCodeId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
discountPercent: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
grossAmountCents: jspb.Message.getFieldWithDefault(msg, 6, 0),
discountCents: jspb.Message.getFieldWithDefault(msg, 7, 0),
amountCents: jspb.Message.getFieldWithDefault(msg, 8, 0),
rejectionReason: jspb.Message.getFieldWithDefault(msg, 9, 0),
couponExpiresAt: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
couponCodeApplied: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ValidateCouponResponse;
  return proto.landscope.mapviewer.v1.ValidateCouponResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setErrorMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAffiliateId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponCodeId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDiscountPercent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGrossAmountCents(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscountCents(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 9:
      var value = /** @type {!proto.landscope.mapviewer.v1.CouponRejectionReason} */ (reader.readEnum());
      msg.setRejectionReason(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCouponExpiresAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCouponCodeApplied(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ValidateCouponResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ValidateCouponResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getGrossAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getDiscountCents();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getRejectionReason();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCouponCodeApplied();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string error_message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string affiliate_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getAffiliateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setAffiliateId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.clearAffiliateId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.hasAffiliateId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string coupon_code_id = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getCouponCodeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setCouponCodeId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.clearCouponCodeId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.hasCouponCodeId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double discount_percent = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getDiscountPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setDiscountPercent = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.clearDiscountPercent = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.hasDiscountPercent = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 gross_amount_cents = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getGrossAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setGrossAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 discount_cents = 7;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getDiscountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setDiscountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 amount_cents = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional CouponRejectionReason rejection_reason = 9;
 * @return {!proto.landscope.mapviewer.v1.CouponRejectionReason}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getRejectionReason = function() {
  return /** @type {!proto.landscope.mapviewer.v1.CouponRejectionReason} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.CouponRejectionReason} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int64 coupon_expires_at = 10;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getCouponExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setCouponExpiresAt = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.clearCouponExpiresAt = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.hasCouponExpiresAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string coupon_code_applied = 11;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.getCouponCodeApplied = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ValidateCouponResponse} returns this
 */
proto.landscope.mapviewer.v1.ValidateCouponResponse.prototype.setCouponCodeApplied = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
returnUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest;
  return proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReturnUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReturnUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string return_url = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.prototype.getReturnUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionRequest.prototype.setReturnUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse;
  return proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateBillingPortalSessionResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
coordinatesList: jspb.Message.toObjectList(msg.getCoordinatesList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest;
  return proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addCoordinates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Coordinate coordinates = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.prototype.getCoordinatesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} returns this
*/
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.prototype.setCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.prototype.addCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest} returns this
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityRequest.prototype.clearCoordinatesList = function() {
  return this.setCoordinatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
available: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
state: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse;
  return proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvailable(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.CoverageState} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional bool available = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.prototype.getAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse} returns this
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.prototype.setAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional CoverageState state = 2;
 * @return {!proto.landscope.mapviewer.v1.CoverageState}
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.prototype.getState = function() {
  return /** @type {!proto.landscope.mapviewer.v1.CoverageState} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.CoverageState} value
 * @return {!proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse} returns this
 */
proto.landscope.mapviewer.v1.CheckCoverageAvailabilityResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.StatBreakdownItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, ""),
description: jspb.Message.getFieldWithDefault(msg, 4, ""),
percent: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.StatBreakdownItem;
  return proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem} returns this
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem} returns this
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem} returns this
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem} returns this
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double percent = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.getPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem} returns this
 */
proto.landscope.mapviewer.v1.StatBreakdownItem.prototype.setPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetProjectStatisticsRequest;
  return proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.repeatedFields_ = [1,2,7,8,13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
propertyPolygonList: jspb.Message.toObjectList(msg.getPropertyPolygonList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
bufferPolygonList: jspb.Message.toObjectList(msg.getBufferPolygonList(),
    proto.landscope.mapviewer.v1.Coordinate.toObject, includeInstance),
maxHeightM: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
minHeightM: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
altitudeStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
hemisphere: jspb.Message.getFieldWithDefault(msg, 6, ""),
aspectBreakdownList: jspb.Message.toObjectList(msg.getAspectBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
slopeBreakdownList: jspb.Message.toObjectList(msg.getSlopeBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
elevationBreakdownList: jspb.Message.toObjectList(msg.getElevationBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
geomorphonsBreakdownList: jspb.Message.toObjectList(msg.getGeomorphonsBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
projectAreaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
projectBufferAreaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
name: jspb.Message.getFieldWithDefault(msg, 11, ""),
description: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetProjectStatisticsResponse;
  return proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addPropertyPolygon(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.Coordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Coordinate.deserializeBinaryFromReader);
      msg.addBufferPolygon(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeightM(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinHeightM(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitudeStdDev(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHemisphere(value);
      break;
    case 7:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addAspectBreakdown(value);
      break;
    case 8:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addSlopeBreakdown(value);
      break;
    case 13:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addElevationBreakdown(value);
      break;
    case 14:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addGeomorphonsBreakdown(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProjectAreaM2(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProjectBufferAreaM2(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyPolygonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getBufferPolygonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.Coordinate.serializeBinaryToWriter
    );
  }
  f = message.getMaxHeightM();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMinHeightM();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getAltitudeStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getHemisphere();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAspectBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getSlopeBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getElevationBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getGeomorphonsBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getProjectAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getProjectBufferAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * repeated Coordinate property_polygon = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getPropertyPolygonList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setPropertyPolygonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.addPropertyPolygon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.clearPropertyPolygonList = function() {
  return this.setPropertyPolygonList([]);
};


/**
 * repeated Coordinate buffer_polygon = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.Coordinate>}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getBufferPolygonList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Coordinate, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Coordinate>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setBufferPolygonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Coordinate}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.addBufferPolygon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.clearBufferPolygonList = function() {
  return this.setBufferPolygonList([]);
};


/**
 * optional double max_height_m = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getMaxHeightM = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setMaxHeightM = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double min_height_m = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getMinHeightM = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setMinHeightM = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double altitude_std_dev = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getAltitudeStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setAltitudeStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string hemisphere = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getHemisphere = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setHemisphere = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated StatBreakdownItem aspect_breakdown = 7;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getAspectBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 7));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setAspectBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.addAspectBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.clearAspectBreakdownList = function() {
  return this.setAspectBreakdownList([]);
};


/**
 * repeated StatBreakdownItem slope_breakdown = 8;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getSlopeBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 8));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setSlopeBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.addSlopeBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.clearSlopeBreakdownList = function() {
  return this.setSlopeBreakdownList([]);
};


/**
 * repeated StatBreakdownItem elevation_breakdown = 13;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getElevationBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 13));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setElevationBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.addElevationBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.clearElevationBreakdownList = function() {
  return this.setElevationBreakdownList([]);
};


/**
 * repeated StatBreakdownItem geomorphons_breakdown = 14;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getGeomorphonsBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 14));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setGeomorphonsBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.addGeomorphonsBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.clearGeomorphonsBreakdownList = function() {
  return this.setGeomorphonsBreakdownList([]);
};


/**
 * optional double project_area_m2 = 9;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getProjectAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setProjectAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double project_buffer_area_m2 = 10;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getProjectBufferAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setProjectBufferAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional string name = 11;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string description = 12;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectStatisticsResponse.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateProjectDownloadRequest;
  return proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateProjectDownloadRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
downloadId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateProjectDownloadResponse;
  return proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDownloadId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDownloadId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string download_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.prototype.getDownloadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateProjectDownloadResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateProjectDownloadResponse.prototype.setDownloadId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
downloadId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest;
  return proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDownloadId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDownloadId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string download_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.prototype.getDownloadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest} returns this
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusRequest.prototype.setDownloadId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, ""),
presignedUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
error: jspb.Message.getFieldWithDefault(msg, 3, ""),
expiresAt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse;
  return proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPresignedUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setError(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPresignedUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpiresAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string presigned_url = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.getPresignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.setPresignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string error = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 expires_at = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse} returns this
 */
proto.landscope.mapviewer.v1.GetProjectDownloadStatusResponse.prototype.setExpiresAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
artifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
format: jspb.Message.getFieldWithDefault(msg, 2, 0),
options: (f = msg.getOptions()) && proto.landscope.mapviewer.v1.ExportOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactRequest}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportArtifactRequest;
  return proto.landscope.mapviewer.v1.ExportArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactRequest}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.ExportOptions;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ExportOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.ExportOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExportFormat format = 2;
 * @return {!proto.landscope.mapviewer.v1.ExportFormat}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.getFormat = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportFormat} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ExportOptions options = 3;
 * @return {?proto.landscope.mapviewer.v1.ExportOptions}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.getOptions = function() {
  return /** @type{?proto.landscope.mapviewer.v1.ExportOptions} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.ExportOptions, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.ExportOptions|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactRequest} returns this
*/
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.setOptions = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.clearOptions = function() {
  return this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ExportArtifactRequest.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
downloadUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
downloadId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactResponse}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportArtifactResponse;
  return proto.landscope.mapviewer.v1.ExportArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactResponse}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDownloadUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDownloadId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDownloadUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDownloadId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string download_url = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.getDownloadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.setDownloadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string download_id = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.getDownloadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportArtifactResponse.prototype.setDownloadId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
layerName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest;
  return proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLayerName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLayerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string layer_name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.prototype.getLayerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsRequest.prototype.setLayerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
availableFormatsList: jspb.Message.toObjectList(msg.getAvailableFormatsList(),
    proto.landscope.mapviewer.v1.AvailableExportFormat.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse;
  return proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.AvailableExportFormat;
      reader.readMessage(value,proto.landscope.mapviewer.v1.AvailableExportFormat.deserializeBinaryFromReader);
      msg.addAvailableFormats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailableFormatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.AvailableExportFormat.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AvailableExportFormat available_formats = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.AvailableExportFormat>}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.prototype.getAvailableFormatsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.AvailableExportFormat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.AvailableExportFormat, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.AvailableExportFormat>} value
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.prototype.setAvailableFormatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.AvailableExportFormat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.AvailableExportFormat}
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.prototype.addAvailableFormats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.AvailableExportFormat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetSupportedExportFormatsResponse.prototype.clearAvailableFormatsList = function() {
  return this.setAvailableFormatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.AvailableExportFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.AvailableExportFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
format: jspb.Message.getFieldWithDefault(msg, 1, 0),
artifactId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.AvailableExportFormat}
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.AvailableExportFormat;
  return proto.landscope.mapviewer.v1.AvailableExportFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.AvailableExportFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.AvailableExportFormat}
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.AvailableExportFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.AvailableExportFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ExportFormat format = 1;
 * @return {!proto.landscope.mapviewer.v1.ExportFormat}
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.prototype.getFormat = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportFormat} value
 * @return {!proto.landscope.mapviewer.v1.AvailableExportFormat} returns this
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string artifact_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.AvailableExportFormat} returns this
 */
proto.landscope.mapviewer.v1.AvailableExportFormat.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportUserArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
artifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
format: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportUserArtifactRequest;
  return proto.landscope.mapviewer.v1.ExportUserArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportUserArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExportFormat format = 2;
 * @return {!proto.landscope.mapviewer.v1.ExportFormat}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.prototype.getFormat = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportFormat} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportUserArtifactRequest.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportUserArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
downloadUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
filename: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportUserArtifactResponse;
  return proto.landscope.mapviewer.v1.ExportUserArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDownloadUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFilename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportUserArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDownloadUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string download_url = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.getDownloadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.setDownloadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string filename = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserArtifactResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportUserFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
folderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
format: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderRequest}
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportUserFolderRequest;
  return proto.landscope.mapviewer.v1.ExportUserFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderRequest}
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportUserFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string folder_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExportFormat format = 2;
 * @return {!proto.landscope.mapviewer.v1.ExportFormat}
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.prototype.getFormat = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ExportFormat} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ExportFormat} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.ExportUserFolderRequest.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportUserFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
downloadUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
filename: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderResponse}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportUserFolderResponse;
  return proto.landscope.mapviewer.v1.ExportUserFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderResponse}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDownloadUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFilename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportUserFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDownloadUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string download_url = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.getDownloadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.setDownloadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string filename = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ExportUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.ExportUserFolderResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
standardContourUnit: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
customContoursList: jspb.Message.toObjectList(msg.getCustomContoursList(),
    proto.landscope.mapviewer.v1.CustomContour.toObject, includeInstance),
boundaryColor: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateProjectRequest;
  return proto.landscope.mapviewer.v1.UpdateProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStandardContourUnit(value);
      break;
    case 5:
      var value = new proto.landscope.mapviewer.v1.CustomContour;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CustomContour.deserializeBinaryFromReader);
      msg.addCustomContours(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBoundaryColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCustomContoursList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.landscope.mapviewer.v1.CustomContour.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string standard_contour_unit = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.getStandardContourUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.setStandardContourUnit = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.clearStandardContourUnit = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.hasStandardContourUnit = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated CustomContour custom_contours = 5;
 * @return {!Array<!proto.landscope.mapviewer.v1.CustomContour>}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.getCustomContoursList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.CustomContour>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.CustomContour, 5));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.CustomContour>} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
*/
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.setCustomContoursList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.CustomContour=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.CustomContour}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.addCustomContours = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.landscope.mapviewer.v1.CustomContour, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.clearCustomContoursList = function() {
  return this.setCustomContoursList([]);
};


/**
 * optional string boundary_color = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.getBoundaryColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.setBoundaryColor = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.clearBoundaryColor = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateProjectRequest.prototype.hasBoundaryColor = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectResponse}
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateProjectResponse;
  return proto.landscope.mapviewer.v1.UpdateProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectResponse}
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateProjectResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateProjectResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectRequest}
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveProjectRequest;
  return proto.landscope.mapviewer.v1.RemoveProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectRequest}
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectRequest} returns this
 */
proto.landscope.mapviewer.v1.RemoveProjectRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectResponse}
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveProjectResponse;
  return proto.landscope.mapviewer.v1.RemoveProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectResponse}
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectResponse} returns this
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveProjectResponse} returns this
 */
proto.landscope.mapviewer.v1.RemoveProjectResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ExportOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ExportOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ExportOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportOptions.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ExportOptions}
 */
proto.landscope.mapviewer.v1.ExportOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ExportOptions;
  return proto.landscope.mapviewer.v1.ExportOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ExportOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ExportOptions}
 */
proto.landscope.mapviewer.v1.ExportOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ExportOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ExportOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ExportOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ExportOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.InviteCollaboratorRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstName: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
lastName: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
role: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
acknowledgeSeatCharge: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.InviteCollaboratorRequest;
  return proto.landscope.mapviewer.v1.InviteCollaboratorRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRole(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAcknowledgeSeatCharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.InviteCollaboratorRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.clearFirstName = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.hasFirstName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.setLastName = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.clearLastName = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.hasLastName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string role = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.setRole = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.clearRole = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.hasRole = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool acknowledge_seat_charge = 6;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.getAcknowledgeSeatCharge = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.setAcknowledgeSeatCharge = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.clearAcknowledgeSeatCharge = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorRequest.prototype.hasAcknowledgeSeatCharge = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.InviteCollaboratorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
userWasCreated: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
userId: jspb.Message.getFieldWithDefault(msg, 4, ""),
userNotFound: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.InviteCollaboratorResponse;
  return proto.landscope.mapviewer.v1.InviteCollaboratorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserWasCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserNotFound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.InviteCollaboratorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserWasCreated();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserNotFound();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool user_was_created = 3;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.getUserWasCreated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.setUserWasCreated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool user_not_found = 5;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.getUserNotFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.InviteCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.InviteCollaboratorResponse.prototype.setUserNotFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveCollaboratorRequest;
  return proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorRequest} returns this
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RemoveCollaboratorResponse;
  return proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RemoveCollaboratorResponse} returns this
 */
proto.landscope.mapviewer.v1.RemoveCollaboratorResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListCollaboratorsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListCollaboratorsRequest;
  return proto.landscope.mapviewer.v1.ListCollaboratorsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListCollaboratorsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsRequest} returns this
 */
proto.landscope.mapviewer.v1.ListCollaboratorsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListCollaboratorsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
collaboratorsList: jspb.Message.toObjectList(msg.getCollaboratorsList(),
    proto.landscope.mapviewer.v1.Collaborator.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListCollaboratorsResponse;
  return proto.landscope.mapviewer.v1.ListCollaboratorsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Collaborator;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Collaborator.deserializeBinaryFromReader);
      msg.addCollaborators(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListCollaboratorsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollaboratorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Collaborator.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Collaborator collaborators = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Collaborator>}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.prototype.getCollaboratorsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Collaborator>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Collaborator, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Collaborator>} value
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse} returns this
*/
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.prototype.setCollaboratorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Collaborator=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Collaborator}
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.prototype.addCollaborators = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Collaborator, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListCollaboratorsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListCollaboratorsResponse.prototype.clearCollaboratorsList = function() {
  return this.setCollaboratorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.Collaborator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.Collaborator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Collaborator.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
addedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
collaboratorType: jspb.Message.getFieldWithDefault(msg, 7, ""),
expiresAt: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
role: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.Collaborator}
 */
proto.landscope.mapviewer.v1.Collaborator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.Collaborator;
  return proto.landscope.mapviewer.v1.Collaborator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.Collaborator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.Collaborator}
 */
proto.landscope.mapviewer.v1.Collaborator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAddedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCollaboratorType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.Collaborator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.Collaborator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Collaborator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCollaboratorType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 added_at = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getAddedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setAddedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string collaborator_type = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getCollaboratorType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setCollaboratorType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 expires_at = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setExpiresAt = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.clearExpiresAt = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.hasExpiresAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string role = 9;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Collaborator} returns this
 */
proto.landscope.mapviewer.v1.Collaborator.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CameraPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CameraPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CameraPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
height: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
heading: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
pitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
roll: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CameraPosition}
 */
proto.landscope.mapviewer.v1.CameraPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CameraPosition;
  return proto.landscope.mapviewer.v1.CameraPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CameraPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CameraPosition}
 */
proto.landscope.mapviewer.v1.CameraPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeading(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPitch(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CameraPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CameraPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CameraPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getHeading();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPitch();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getRoll();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CameraPosition} returns this
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CameraPosition} returns this
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double height = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CameraPosition} returns this
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double heading = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.getHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CameraPosition} returns this
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.setHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double pitch = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.getPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CameraPosition} returns this
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.setPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double roll = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.getRoll = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CameraPosition} returns this
 */
proto.landscope.mapviewer.v1.CameraPosition.prototype.setRoll = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LayerConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LayerConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
artifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
visible: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
opacity: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LayerConfig}
 */
proto.landscope.mapviewer.v1.LayerConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LayerConfig;
  return proto.landscope.mapviewer.v1.LayerConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LayerConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LayerConfig}
 */
proto.landscope.mapviewer.v1.LayerConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpacity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LayerConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LayerConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LayerConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOpacity();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.LayerConfig} returns this
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool visible = 2;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.LayerConfig} returns this
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional double opacity = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.getOpacity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LayerConfig} returns this
 */
proto.landscope.mapviewer.v1.LayerConfig.prototype.setOpacity = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ScopeArtifactConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
artifactType: jspb.Message.getFieldWithDefault(msg, 2, 0),
artifactId: jspb.Message.getFieldWithDefault(msg, 3, ""),
visible: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
opacity: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
colorOverride: jspb.Message.getFieldWithDefault(msg, 6, ""),
viewState: jspb.Message.getFieldWithDefault(msg, 7, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ScopeArtifactConfig;
  return proto.landscope.mapviewer.v1.ScopeArtifactConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.landscope.mapviewer.v1.ScopeArtifactType} */ (reader.readEnum());
      msg.setArtifactType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpacity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColorOverride(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setViewState(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ScopeArtifactConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArtifactType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOpacity();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getColorOverride();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getViewState();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ScopeArtifactType artifact_type = 2;
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactType}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getArtifactType = function() {
  return /** @type {!proto.landscope.mapviewer.v1.ScopeArtifactType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactType} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setArtifactType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string artifact_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool visible = 4;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional double opacity = 5;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getOpacity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setOpacity = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string color_override = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getColorOverride = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setColorOverride = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string view_state = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getViewState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setViewState = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 sort_order = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig} returns this
 */
proto.landscope.mapviewer.v1.ScopeArtifactConfig.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.Scope.repeatedFields_ = [8,17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.Scope.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.Scope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.Scope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Scope.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
cameraPosition: (f = msg.getCameraPosition()) && proto.landscope.mapviewer.v1.CameraPosition.toObject(includeInstance, f),
layerConfigsList: jspb.Message.toObjectList(msg.getLayerConfigsList(),
    proto.landscope.mapviewer.v1.LayerConfig.toObject, includeInstance),
createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
artifactConfigsList: jspb.Message.toObjectList(msg.getArtifactConfigsList(),
    proto.landscope.mapviewer.v1.ScopeArtifactConfig.toObject, includeInstance),
sortOrder: jspb.Message.getFieldWithDefault(msg, 18, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.Scope}
 */
proto.landscope.mapviewer.v1.Scope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.Scope;
  return proto.landscope.mapviewer.v1.Scope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.Scope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.Scope}
 */
proto.landscope.mapviewer.v1.Scope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 7:
      var value = new proto.landscope.mapviewer.v1.CameraPosition;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CameraPosition.deserializeBinaryFromReader);
      msg.setCameraPosition(value);
      break;
    case 8:
      var value = new proto.landscope.mapviewer.v1.LayerConfig;
      reader.readMessage(value,proto.landscope.mapviewer.v1.LayerConfig.deserializeBinaryFromReader);
      msg.addLayerConfigs(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 17:
      var value = new proto.landscope.mapviewer.v1.ScopeArtifactConfig;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ScopeArtifactConfig.deserializeBinaryFromReader);
      msg.addArtifactConfigs(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.Scope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.Scope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.Scope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Scope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCameraPosition();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.landscope.mapviewer.v1.CameraPosition.serializeBinaryToWriter
    );
  }
  f = message.getLayerConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.landscope.mapviewer.v1.LayerConfig.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getArtifactConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.landscope.mapviewer.v1.ScopeArtifactConfig.serializeBinaryToWriter
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional CameraPosition camera_position = 7;
 * @return {?proto.landscope.mapviewer.v1.CameraPosition}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getCameraPosition = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CameraPosition} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CameraPosition, 7));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CameraPosition|undefined} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
*/
proto.landscope.mapviewer.v1.Scope.prototype.setCameraPosition = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.clearCameraPosition = function() {
  return this.setCameraPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Scope.prototype.hasCameraPosition = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated LayerConfig layer_configs = 8;
 * @return {!Array<!proto.landscope.mapviewer.v1.LayerConfig>}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getLayerConfigsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.LayerConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.LayerConfig, 8));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.LayerConfig>} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
*/
proto.landscope.mapviewer.v1.Scope.prototype.setLayerConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.LayerConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.LayerConfig}
 */
proto.landscope.mapviewer.v1.Scope.prototype.addLayerConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.landscope.mapviewer.v1.LayerConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.clearLayerConfigsList = function() {
  return this.setLayerConfigsList([]);
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 updated_at = 12;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * repeated ScopeArtifactConfig artifact_configs = 17;
 * @return {!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getArtifactConfigsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ScopeArtifactConfig, 17));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
*/
proto.landscope.mapviewer.v1.Scope.prototype.setArtifactConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig}
 */
proto.landscope.mapviewer.v1.Scope.prototype.addArtifactConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.landscope.mapviewer.v1.ScopeArtifactConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.clearArtifactConfigsList = function() {
  return this.setArtifactConfigsList([]);
};


/**
 * optional int32 sort_order = 18;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Scope.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Scope} returns this
 */
proto.landscope.mapviewer.v1.Scope.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateScopeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateScopeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
cameraPosition: (f = msg.getCameraPosition()) && proto.landscope.mapviewer.v1.CameraPosition.toObject(includeInstance, f),
layerConfigsList: jspb.Message.toObjectList(msg.getLayerConfigsList(),
    proto.landscope.mapviewer.v1.LayerConfig.toObject, includeInstance),
artifactConfigsList: jspb.Message.toObjectList(msg.getArtifactConfigsList(),
    proto.landscope.mapviewer.v1.ScopeArtifactConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateScopeRequest;
  return proto.landscope.mapviewer.v1.CreateScopeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateScopeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.CameraPosition;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CameraPosition.deserializeBinaryFromReader);
      msg.setCameraPosition(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.LayerConfig;
      reader.readMessage(value,proto.landscope.mapviewer.v1.LayerConfig.deserializeBinaryFromReader);
      msg.addLayerConfigs(value);
      break;
    case 5:
      var value = new proto.landscope.mapviewer.v1.ScopeArtifactConfig;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ScopeArtifactConfig.deserializeBinaryFromReader);
      msg.addArtifactConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateScopeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateScopeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCameraPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.CameraPosition.serializeBinaryToWriter
    );
  }
  f = message.getLayerConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.LayerConfig.serializeBinaryToWriter
    );
  }
  f = message.getArtifactConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.landscope.mapviewer.v1.ScopeArtifactConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CameraPosition camera_position = 3;
 * @return {?proto.landscope.mapviewer.v1.CameraPosition}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.getCameraPosition = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CameraPosition} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CameraPosition, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CameraPosition|undefined} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
*/
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.setCameraPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.clearCameraPosition = function() {
  return this.setCameraPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.hasCameraPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated LayerConfig layer_configs = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.LayerConfig>}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.getLayerConfigsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.LayerConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.LayerConfig, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.LayerConfig>} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
*/
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.setLayerConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.LayerConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.LayerConfig}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.addLayerConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.LayerConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.clearLayerConfigsList = function() {
  return this.setLayerConfigsList([]);
};


/**
 * repeated ScopeArtifactConfig artifact_configs = 5;
 * @return {!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.getArtifactConfigsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ScopeArtifactConfig, 5));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
*/
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.setArtifactConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig}
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.addArtifactConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.landscope.mapviewer.v1.ScopeArtifactConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeRequest.prototype.clearArtifactConfigsList = function() {
  return this.setArtifactConfigsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateScopeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateScopeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
scopeId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeResponse}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateScopeResponse;
  return proto.landscope.mapviewer.v1.CreateScopeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateScopeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateScopeResponse}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateScopeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateScopeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string scope_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateScopeResponse.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetScopesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetScopesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetScopesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetScopesRequest}
 */
proto.landscope.mapviewer.v1.GetScopesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetScopesRequest;
  return proto.landscope.mapviewer.v1.GetScopesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetScopesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetScopesRequest}
 */
proto.landscope.mapviewer.v1.GetScopesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetScopesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetScopesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetScopesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetScopesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetScopesRequest} returns this
 */
proto.landscope.mapviewer.v1.GetScopesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetScopesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetScopesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetScopesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetScopesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
scopesList: jspb.Message.toObjectList(msg.getScopesList(),
    proto.landscope.mapviewer.v1.Scope.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetScopesResponse}
 */
proto.landscope.mapviewer.v1.GetScopesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetScopesResponse;
  return proto.landscope.mapviewer.v1.GetScopesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetScopesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetScopesResponse}
 */
proto.landscope.mapviewer.v1.GetScopesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Scope;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Scope.deserializeBinaryFromReader);
      msg.addScopes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetScopesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetScopesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetScopesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScopesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Scope.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Scope scopes = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Scope>}
 */
proto.landscope.mapviewer.v1.GetScopesResponse.prototype.getScopesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Scope>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Scope, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Scope>} value
 * @return {!proto.landscope.mapviewer.v1.GetScopesResponse} returns this
*/
proto.landscope.mapviewer.v1.GetScopesResponse.prototype.setScopesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Scope=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Scope}
 */
proto.landscope.mapviewer.v1.GetScopesResponse.prototype.addScopes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Scope, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetScopesResponse} returns this
 */
proto.landscope.mapviewer.v1.GetScopesResponse.prototype.clearScopesList = function() {
  return this.setScopesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetScopeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetScopeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetScopeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
scopeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetScopeRequest}
 */
proto.landscope.mapviewer.v1.GetScopeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetScopeRequest;
  return proto.landscope.mapviewer.v1.GetScopeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetScopeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetScopeRequest}
 */
proto.landscope.mapviewer.v1.GetScopeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetScopeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetScopeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetScopeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string scope_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetScopeRequest.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.GetScopeRequest.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetScopeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetScopeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetScopeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
scope: (f = msg.getScope()) && proto.landscope.mapviewer.v1.Scope.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetScopeResponse}
 */
proto.landscope.mapviewer.v1.GetScopeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetScopeResponse;
  return proto.landscope.mapviewer.v1.GetScopeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetScopeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetScopeResponse}
 */
proto.landscope.mapviewer.v1.GetScopeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Scope;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Scope.deserializeBinaryFromReader);
      msg.setScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetScopeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetScopeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetScopeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetScopeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScope();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Scope.serializeBinaryToWriter
    );
  }
};


/**
 * optional Scope scope = 1;
 * @return {?proto.landscope.mapviewer.v1.Scope}
 */
proto.landscope.mapviewer.v1.GetScopeResponse.prototype.getScope = function() {
  return /** @type{?proto.landscope.mapviewer.v1.Scope} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.Scope, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.Scope|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetScopeResponse} returns this
*/
proto.landscope.mapviewer.v1.GetScopeResponse.prototype.setScope = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.GetScopeResponse.prototype.clearScope = function() {
  return this.setScope(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetScopeResponse.prototype.hasScope = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateScopeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
scopeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
cameraPosition: (f = msg.getCameraPosition()) && proto.landscope.mapviewer.v1.CameraPosition.toObject(includeInstance, f),
layerConfigsList: jspb.Message.toObjectList(msg.getLayerConfigsList(),
    proto.landscope.mapviewer.v1.LayerConfig.toObject, includeInstance),
artifactConfigsList: jspb.Message.toObjectList(msg.getArtifactConfigsList(),
    proto.landscope.mapviewer.v1.ScopeArtifactConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateScopeRequest;
  return proto.landscope.mapviewer.v1.UpdateScopeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.CameraPosition;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CameraPosition.deserializeBinaryFromReader);
      msg.setCameraPosition(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.LayerConfig;
      reader.readMessage(value,proto.landscope.mapviewer.v1.LayerConfig.deserializeBinaryFromReader);
      msg.addLayerConfigs(value);
      break;
    case 5:
      var value = new proto.landscope.mapviewer.v1.ScopeArtifactConfig;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ScopeArtifactConfig.deserializeBinaryFromReader);
      msg.addArtifactConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateScopeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCameraPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.CameraPosition.serializeBinaryToWriter
    );
  }
  f = message.getLayerConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.LayerConfig.serializeBinaryToWriter
    );
  }
  f = message.getArtifactConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.landscope.mapviewer.v1.ScopeArtifactConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string scope_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CameraPosition camera_position = 3;
 * @return {?proto.landscope.mapviewer.v1.CameraPosition}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.getCameraPosition = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CameraPosition} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CameraPosition, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CameraPosition|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
*/
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.setCameraPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.clearCameraPosition = function() {
  return this.setCameraPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.hasCameraPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated LayerConfig layer_configs = 4;
 * @return {!Array<!proto.landscope.mapviewer.v1.LayerConfig>}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.getLayerConfigsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.LayerConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.LayerConfig, 4));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.LayerConfig>} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
*/
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.setLayerConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.LayerConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.LayerConfig}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.addLayerConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.landscope.mapviewer.v1.LayerConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.clearLayerConfigsList = function() {
  return this.setLayerConfigsList([]);
};


/**
 * repeated ScopeArtifactConfig artifact_configs = 5;
 * @return {!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.getArtifactConfigsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ScopeArtifactConfig, 5));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ScopeArtifactConfig>} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
*/
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.setArtifactConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ScopeArtifactConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ScopeArtifactConfig}
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.addArtifactConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.landscope.mapviewer.v1.ScopeArtifactConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeRequest.prototype.clearArtifactConfigsList = function() {
  return this.setArtifactConfigsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateScopeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeResponse}
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateScopeResponse;
  return proto.landscope.mapviewer.v1.UpdateScopeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeResponse}
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateScopeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateScopeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateScopeResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteScopeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
scopeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeRequest}
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteScopeRequest;
  return proto.landscope.mapviewer.v1.DeleteScopeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeRequest}
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteScopeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string scope_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteScopeRequest.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteScopeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeResponse}
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteScopeResponse;
  return proto.landscope.mapviewer.v1.DeleteScopeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeResponse}
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteScopeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteScopeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteScopeResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteScopeResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReorderScopesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
scopeIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesRequest}
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReorderScopesRequest;
  return proto.landscope.mapviewer.v1.ReorderScopesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesRequest}
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addScopeIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReorderScopesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScopeIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string scope_ids = 2;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.getScopeIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.setScopeIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.addScopeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderScopesRequest.prototype.clearScopeIdsList = function() {
  return this.setScopeIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReorderScopesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesResponse}
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReorderScopesResponse;
  return proto.landscope.mapviewer.v1.ReorderScopesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReorderScopesResponse}
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReorderScopesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReorderScopesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderScopesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
polygonGeojson: jspb.Message.getFieldWithDefault(msg, 2, ""),
areaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest;
  return proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPolygonGeojson(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAreaM2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPolygonGeojson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string polygon_geojson = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.getPolygonGeojson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.setPolygonGeojson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double area_m2 = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.getAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest.prototype.setAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.repeatedFields_ = [6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
maxHeightM: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
minHeightM: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
altitudeStdDev: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
areaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
hemisphere: jspb.Message.getFieldWithDefault(msg, 5, ""),
aspectBreakdownList: jspb.Message.toObjectList(msg.getAspectBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
slopeBreakdownList: jspb.Message.toObjectList(msg.getSlopeBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
elevationBreakdownList: jspb.Message.toObjectList(msg.getElevationBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance),
geomorphonsBreakdownList: jspb.Message.toObjectList(msg.getGeomorphonsBreakdownList(),
    proto.landscope.mapviewer.v1.StatBreakdownItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse;
  return proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeightM(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinHeightM(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitudeStdDev(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAreaM2(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHemisphere(value);
      break;
    case 6:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addAspectBreakdown(value);
      break;
    case 7:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addSlopeBreakdown(value);
      break;
    case 8:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addElevationBreakdown(value);
      break;
    case 9:
      var value = new proto.landscope.mapviewer.v1.StatBreakdownItem;
      reader.readMessage(value,proto.landscope.mapviewer.v1.StatBreakdownItem.deserializeBinaryFromReader);
      msg.addGeomorphonsBreakdown(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxHeightM();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMinHeightM();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getAltitudeStdDev();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getHemisphere();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAspectBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getSlopeBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getElevationBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
  f = message.getGeomorphonsBreakdownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.landscope.mapviewer.v1.StatBreakdownItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional double max_height_m = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getMaxHeightM = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setMaxHeightM = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double min_height_m = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getMinHeightM = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setMinHeightM = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double altitude_std_dev = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getAltitudeStdDev = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setAltitudeStdDev = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double area_m2 = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string hemisphere = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getHemisphere = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setHemisphere = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated StatBreakdownItem aspect_breakdown = 6;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getAspectBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 6));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setAspectBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.addAspectBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.clearAspectBreakdownList = function() {
  return this.setAspectBreakdownList([]);
};


/**
 * repeated StatBreakdownItem slope_breakdown = 7;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getSlopeBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 7));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setSlopeBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.addSlopeBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.clearSlopeBreakdownList = function() {
  return this.setSlopeBreakdownList([]);
};


/**
 * repeated StatBreakdownItem elevation_breakdown = 8;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getElevationBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 8));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setElevationBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.addElevationBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.clearElevationBreakdownList = function() {
  return this.setElevationBreakdownList([]);
};


/**
 * repeated StatBreakdownItem geomorphons_breakdown = 9;
 * @return {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.getGeomorphonsBreakdownList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.StatBreakdownItem, 9));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.StatBreakdownItem>} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
*/
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.setGeomorphonsBreakdownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.StatBreakdownItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.StatBreakdownItem}
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.addGeomorphonsBreakdown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.landscope.mapviewer.v1.StatBreakdownItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonStatisticsResponse.prototype.clearGeomorphonsBreakdownList = function() {
  return this.setGeomorphonsBreakdownList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
polygonGeojson: jspb.Message.getFieldWithDefault(msg, 2, ""),
planarAreaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest;
  return proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPolygonGeojson(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPlanarAreaM2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPolygonGeojson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlanarAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string polygon_geojson = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.getPolygonGeojson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.setPolygonGeojson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double planar_area_m2 = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.getPlanarAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest.prototype.setPlanarAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
planarAreaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
surfaceAreaM2: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
coveredFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse;
  return proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPlanarAreaM2(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSurfaceAreaM2(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCoveredFraction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanarAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSurfaceAreaM2();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCoveredFraction();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double planar_area_m2 = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.getPlanarAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.setPlanarAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double surface_area_m2 = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.getSurfaceAreaM2 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.setSurfaceAreaM2 = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double covered_fraction = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.getCoveredFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse} returns this
 */
proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaResponse.prototype.setCoveredFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CommentAuthor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CommentAuthor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommentAuthor.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 3, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 4, ""),
commentColor: jspb.Message.getFieldWithDefault(msg, 5, ""),
avatarUrl: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor}
 */
proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CommentAuthor;
  return proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CommentAuthor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor}
 */
proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFirstName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentColor(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAvatarUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CommentAuthor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CommentAuthor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommentAuthor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCommentColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAvatarUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor} returns this
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor} returns this
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor} returns this
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string last_name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor} returns this
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string comment_color = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.getCommentColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor} returns this
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.setCommentColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string avatar_url = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.getAvatarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentAuthor} returns this
 */
proto.landscope.mapviewer.v1.CommentAuthor.prototype.setAvatarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.Attachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.Attachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Attachment.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
contentType: jspb.Message.getFieldWithDefault(msg, 3, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 4, 0),
presignedUrl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.Attachment}
 */
proto.landscope.mapviewer.v1.Attachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.Attachment;
  return proto.landscope.mapviewer.v1.Attachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.Attachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.Attachment}
 */
proto.landscope.mapviewer.v1.Attachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContentType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSizeBytes(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPresignedUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.Attachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.Attachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Attachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPresignedUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Attachment} returns this
 */
proto.landscope.mapviewer.v1.Attachment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Attachment} returns this
 */
proto.landscope.mapviewer.v1.Attachment.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Attachment} returns this
 */
proto.landscope.mapviewer.v1.Attachment.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 size_bytes = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Attachment} returns this
 */
proto.landscope.mapviewer.v1.Attachment.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string presigned_url = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Attachment.prototype.getPresignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Attachment} returns this
 */
proto.landscope.mapviewer.v1.Attachment.prototype.setPresignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CommentAnchor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CommentAnchor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommentAnchor.toObject = function(includeInstance, msg) {
  var f, obj = {
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
height: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CommentAnchor}
 */
proto.landscope.mapviewer.v1.CommentAnchor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CommentAnchor;
  return proto.landscope.mapviewer.v1.CommentAnchor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CommentAnchor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CommentAnchor}
 */
proto.landscope.mapviewer.v1.CommentAnchor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CommentAnchor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CommentAnchor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommentAnchor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CommentAnchor} returns this
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CommentAnchor} returns this
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double height = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CommentAnchor} returns this
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.setHeight = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CommentAnchor} returns this
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.clearHeight = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CommentAnchor.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.Comment.repeatedFields_ = [7,12,14,16,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.Comment.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.Comment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.Comment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Comment.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
scopeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
parentCommentId: jspb.Message.getFieldWithDefault(msg, 4, ""),
content: jspb.Message.getFieldWithDefault(msg, 5, ""),
author: (f = msg.getAuthor()) && proto.landscope.mapviewer.v1.CommentAuthor.toObject(includeInstance, f),
repliesList: jspb.Message.toObjectList(msg.getRepliesList(),
    proto.landscope.mapviewer.v1.Comment.toObject, includeInstance),
replyCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.landscope.mapviewer.v1.Attachment.toObject, includeInstance),
artifactIdsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
anchor: (f = msg.getAnchor()) && proto.landscope.mapviewer.v1.CommentAnchor.toObject(includeInstance, f),
mentionedUserIdsList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
resolved: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
tagsList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.Comment}
 */
proto.landscope.mapviewer.v1.Comment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.Comment;
  return proto.landscope.mapviewer.v1.Comment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.Comment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.Comment}
 */
proto.landscope.mapviewer.v1.Comment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentCommentId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    case 6:
      var value = new proto.landscope.mapviewer.v1.CommentAuthor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinaryFromReader);
      msg.setAuthor(value);
      break;
    case 7:
      var value = new proto.landscope.mapviewer.v1.Comment;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Comment.deserializeBinaryFromReader);
      msg.addReplies(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReplyCount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 12:
      var value = new proto.landscope.mapviewer.v1.Attachment;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Attachment.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addArtifactIds(value);
      break;
    case 15:
      var value = new proto.landscope.mapviewer.v1.CommentAnchor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentAnchor.deserializeBinaryFromReader);
      msg.setAnchor(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addMentionedUserIds(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResolved(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.Comment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.Comment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.Comment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.Comment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParentCommentId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAuthor();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.landscope.mapviewer.v1.CommentAuthor.serializeBinaryToWriter
    );
  }
  f = message.getRepliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.landscope.mapviewer.v1.Comment.serializeBinaryToWriter
    );
  }
  f = message.getReplyCount();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.landscope.mapviewer.v1.Attachment.serializeBinaryToWriter
    );
  }
  f = message.getArtifactIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getAnchor();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.landscope.mapviewer.v1.CommentAnchor.serializeBinaryToWriter
    );
  }
  f = message.getMentionedUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getResolved();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string scope_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string parent_comment_id = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getParentCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setParentCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string content = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CommentAuthor author = 6;
 * @return {?proto.landscope.mapviewer.v1.CommentAuthor}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getAuthor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentAuthor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentAuthor, 6));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentAuthor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
*/
proto.landscope.mapviewer.v1.Comment.prototype.setAuthor = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearAuthor = function() {
  return this.setAuthor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Comment.prototype.hasAuthor = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Comment replies = 7;
 * @return {!Array<!proto.landscope.mapviewer.v1.Comment>}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getRepliesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Comment, 7));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Comment>} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
*/
proto.landscope.mapviewer.v1.Comment.prototype.setRepliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Comment}
 */
proto.landscope.mapviewer.v1.Comment.prototype.addReplies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.landscope.mapviewer.v1.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearRepliesList = function() {
  return this.setRepliesList([]);
};


/**
 * optional int64 reply_count = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getReplyCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setReplyCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 updated_at = 10;
 * @return {number}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool deleted = 11;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * repeated Attachment attachments = 12;
 * @return {!Array<!proto.landscope.mapviewer.v1.Attachment>}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Attachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Attachment, 12));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Attachment>} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
*/
proto.landscope.mapviewer.v1.Comment.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Attachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Attachment}
 */
proto.landscope.mapviewer.v1.Comment.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.landscope.mapviewer.v1.Attachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};


/**
 * repeated string artifact_ids = 14;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getArtifactIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setArtifactIdsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.addArtifactIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearArtifactIdsList = function() {
  return this.setArtifactIdsList([]);
};


/**
 * optional CommentAnchor anchor = 15;
 * @return {?proto.landscope.mapviewer.v1.CommentAnchor}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getAnchor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentAnchor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentAnchor, 15));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentAnchor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
*/
proto.landscope.mapviewer.v1.Comment.prototype.setAnchor = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearAnchor = function() {
  return this.setAnchor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Comment.prototype.hasAnchor = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated string mentioned_user_ids = 16;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getMentionedUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setMentionedUserIdsList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.addMentionedUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearMentionedUserIdsList = function() {
  return this.setMentionedUserIdsList([]);
};


/**
 * optional bool resolved = 17;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getResolved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setResolved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * repeated string tags = 18;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.Comment.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.Comment} returns this
 */
proto.landscope.mapviewer.v1.Comment.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CommentCursor.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CommentCursor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CommentCursor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommentCursor.toObject = function(includeInstance, msg) {
  var f, obj = {
createdAt: jspb.Message.getFieldWithDefault(msg, 1, 0),
commentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CommentCursor}
 */
proto.landscope.mapviewer.v1.CommentCursor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CommentCursor;
  return proto.landscope.mapviewer.v1.CommentCursor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CommentCursor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CommentCursor}
 */
proto.landscope.mapviewer.v1.CommentCursor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CommentCursor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CommentCursor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CommentCursor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CommentCursor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 created_at = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.CommentCursor.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.CommentCursor} returns this
 */
proto.landscope.mapviewer.v1.CommentCursor.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string comment_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CommentCursor.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CommentCursor} returns this
 */
proto.landscope.mapviewer.v1.CommentCursor.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.repeatedFields_ = [6,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
scopeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
parentCommentId: jspb.Message.getFieldWithDefault(msg, 3, ""),
content: jspb.Message.getFieldWithDefault(msg, 4, ""),
artifactIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
anchor: (f = msg.getAnchor()) && proto.landscope.mapviewer.v1.CommentAnchor.toObject(includeInstance, f),
mentionedUserIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
tagsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateCommentRequest;
  return proto.landscope.mapviewer.v1.CreateCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentCommentId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addArtifactIds(value);
      break;
    case 7:
      var value = new proto.landscope.mapviewer.v1.CommentAnchor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentAnchor.deserializeBinaryFromReader);
      msg.setAnchor(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addMentionedUserIds(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentCommentId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getArtifactIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getAnchor();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.landscope.mapviewer.v1.CommentAnchor.serializeBinaryToWriter
    );
  }
  f = message.getMentionedUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string scope_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string parent_comment_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getParentCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setParentCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string content = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string artifact_ids = 6;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getArtifactIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setArtifactIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.addArtifactIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.clearArtifactIdsList = function() {
  return this.setArtifactIdsList([]);
};


/**
 * optional CommentAnchor anchor = 7;
 * @return {?proto.landscope.mapviewer.v1.CommentAnchor}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getAnchor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentAnchor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentAnchor, 7));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentAnchor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
*/
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setAnchor = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.clearAnchor = function() {
  return this.setAnchor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.hasAnchor = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string mentioned_user_ids = 8;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getMentionedUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setMentionedUserIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.addMentionedUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.clearMentionedUserIdsList = function() {
  return this.setMentionedUserIdsList([]);
};


/**
 * repeated string tags = 9;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
commentId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentResponse}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateCommentResponse;
  return proto.landscope.mapviewer.v1.CreateCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateCommentResponse}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string comment_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateCommentResponse.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReplyToCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
scopeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
parentCommentId: jspb.Message.getFieldWithDefault(msg, 3, ""),
content: jspb.Message.getFieldWithDefault(msg, 4, ""),
additionalArtifactIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
mentionedUserIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReplyToCommentRequest;
  return proto.landscope.mapviewer.v1.ReplyToCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentCommentId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addAdditionalArtifactIds(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addMentionedUserIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReplyToCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentCommentId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAdditionalArtifactIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getMentionedUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string scope_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string parent_comment_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.getParentCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.setParentCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string content = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string additional_artifact_ids = 5;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.getAdditionalArtifactIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.setAdditionalArtifactIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.addAdditionalArtifactIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.clearAdditionalArtifactIdsList = function() {
  return this.setAdditionalArtifactIdsList([]);
};


/**
 * repeated string mentioned_user_ids = 6;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.getMentionedUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.setMentionedUserIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.addMentionedUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ReplyToCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.ReplyToCommentRequest.prototype.clearMentionedUserIdsList = function() {
  return this.setMentionedUserIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
commentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
content: jspb.Message.getFieldWithDefault(msg, 2, ""),
tagsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateCommentRequest;
  return proto.landscope.mapviewer.v1.UpdateCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string tags = 3;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentResponse}
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateCommentResponse;
  return proto.landscope.mapviewer.v1.UpdateCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentResponse}
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateCommentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
commentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentRequest}
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteCommentRequest;
  return proto.landscope.mapviewer.v1.DeleteCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentRequest}
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentResponse}
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteCommentResponse;
  return proto.landscope.mapviewer.v1.DeleteCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentResponse}
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteCommentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCommentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCommentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
scopeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
cursor: (f = msg.getCursor()) && proto.landscope.mapviewer.v1.CommentCursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCommentsRequest;
  return proto.landscope.mapviewer.v1.GetCommentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCommentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScopeId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 4:
      var value = new proto.landscope.mapviewer.v1.CommentCursor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentCursor.deserializeBinaryFromReader);
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCommentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCommentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCursor();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.landscope.mapviewer.v1.CommentCursor.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string scope_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional CommentCursor cursor = 4;
 * @return {?proto.landscope.mapviewer.v1.CommentCursor}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.getCursor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentCursor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentCursor, 4));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentCursor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest} returns this
*/
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.setCursor = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.clearCursor = function() {
  return this.setCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCommentsRequest.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCommentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCommentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto.landscope.mapviewer.v1.Comment.toObject, includeInstance),
nextCursor: (f = msg.getNextCursor()) && proto.landscope.mapviewer.v1.CommentCursor.toObject(includeInstance, f),
hasMore: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCommentsResponse;
  return proto.landscope.mapviewer.v1.GetCommentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCommentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Comment;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Comment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.CommentCursor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentCursor.deserializeBinaryFromReader);
      msg.setNextCursor(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasMore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCommentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCommentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Comment.serializeBinaryToWriter
    );
  }
  f = message.getNextCursor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.CommentCursor.serializeBinaryToWriter
    );
  }
  f = message.getHasMore();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated Comment comments = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.Comment>}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Comment, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Comment>} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Comment}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};


/**
 * optional CommentCursor next_cursor = 2;
 * @return {?proto.landscope.mapviewer.v1.CommentCursor}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.getNextCursor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentCursor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentCursor, 2));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentCursor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse} returns this
*/
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.setNextCursor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.clearNextCursor = function() {
  return this.setNextCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.hasNextCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool has_more = 3;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.getHasMore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentsResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCommentsResponse.prototype.setHasMore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
commentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCommentRequest}
 */
proto.landscope.mapviewer.v1.GetCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCommentRequest;
  return proto.landscope.mapviewer.v1.GetCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCommentRequest}
 */
proto.landscope.mapviewer.v1.GetCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentRequest} returns this
 */
proto.landscope.mapviewer.v1.GetCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
comment: (f = msg.getComment()) && proto.landscope.mapviewer.v1.Comment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetCommentResponse}
 */
proto.landscope.mapviewer.v1.GetCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetCommentResponse;
  return proto.landscope.mapviewer.v1.GetCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetCommentResponse}
 */
proto.landscope.mapviewer.v1.GetCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.Comment;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Comment comment = 1;
 * @return {?proto.landscope.mapviewer.v1.Comment}
 */
proto.landscope.mapviewer.v1.GetCommentResponse.prototype.getComment = function() {
  return /** @type{?proto.landscope.mapviewer.v1.Comment} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.Comment, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.Comment|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetCommentResponse} returns this
*/
proto.landscope.mapviewer.v1.GetCommentResponse.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetCommentResponse} returns this
 */
proto.landscope.mapviewer.v1.GetCommentResponse.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetCommentResponse.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest;
  return proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest} returns this
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
tagsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse;
  return proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tags = 1;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse} returns this
 */
proto.landscope.mapviewer.v1.ListProjectCommentTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
commentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
contentType: jspb.Message.getFieldWithDefault(msg, 3, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest;
  return proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCommentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContentType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSizeBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 size_bytes = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLRequest.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
presignedUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse;
  return proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPresignedUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPresignedUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse} returns this
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string presigned_url = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.prototype.getPresignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse} returns this
 */
proto.landscope.mapviewer.v1.GetAttachmentUploadURLResponse.prototype.setPresignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attachmentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConfirmAttachmentRequest;
  return proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentRequest} returns this
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConfirmAttachmentResponse;
  return proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmAttachmentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attachmentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteAttachmentRequest;
  return proto.landscope.mapviewer.v1.DeleteAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteAttachmentResponse;
  return proto.landscope.mapviewer.v1.DeleteAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteAttachmentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ArtifactNote.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ArtifactNote.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ArtifactNote} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ArtifactNote.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
artifactId: jspb.Message.getFieldWithDefault(msg, 2, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
content: jspb.Message.getFieldWithDefault(msg, 4, ""),
author: (f = msg.getAuthor()) && proto.landscope.mapviewer.v1.CommentAuthor.toObject(includeInstance, f),
canEdit: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.landscope.mapviewer.v1.Attachment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote}
 */
proto.landscope.mapviewer.v1.ArtifactNote.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ArtifactNote;
  return proto.landscope.mapviewer.v1.ArtifactNote.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ArtifactNote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote}
 */
proto.landscope.mapviewer.v1.ArtifactNote.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    case 5:
      var value = new proto.landscope.mapviewer.v1.CommentAuthor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinaryFromReader);
      msg.setAuthor(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanEdit(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = new proto.landscope.mapviewer.v1.Attachment;
      reader.readMessage(value,proto.landscope.mapviewer.v1.Attachment.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ArtifactNote.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ArtifactNote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ArtifactNote.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAuthor();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.landscope.mapviewer.v1.CommentAuthor.serializeBinaryToWriter
    );
  }
  f = message.getCanEdit();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.landscope.mapviewer.v1.Attachment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string artifact_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string content = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional CommentAuthor author = 5;
 * @return {?proto.landscope.mapviewer.v1.CommentAuthor}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getAuthor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentAuthor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentAuthor, 5));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentAuthor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
*/
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setAuthor = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.clearAuthor = function() {
  return this.setAuthor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.hasAuthor = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool can_edit = 6;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getCanEdit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setCanEdit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int64 created_at = 7;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 updated_at = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated Attachment attachments = 9;
 * @return {!Array<!proto.landscope.mapviewer.v1.Attachment>}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.Attachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.Attachment, 9));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.Attachment>} value
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
*/
proto.landscope.mapviewer.v1.ArtifactNote.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.Attachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.Attachment}
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.landscope.mapviewer.v1.Attachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote} returns this
 */
proto.landscope.mapviewer.v1.ArtifactNote.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userArtifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateArtifactNoteRequest;
  return proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserArtifactId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.prototype.getUserArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.prototype.setUserArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
noteId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateArtifactNoteResponse;
  return proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNoteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNoteId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string note_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.getNoteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateArtifactNoteResponse.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListArtifactNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userArtifactId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListArtifactNotesRequest;
  return proto.landscope.mapviewer.v1.ListArtifactNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserArtifactId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListArtifactNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.prototype.getUserArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesRequest} returns this
 */
proto.landscope.mapviewer.v1.ListArtifactNotesRequest.prototype.setUserArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ListArtifactNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.landscope.mapviewer.v1.ArtifactNote.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ListArtifactNotesResponse;
  return proto.landscope.mapviewer.v1.ListArtifactNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.ArtifactNote;
      reader.readMessage(value,proto.landscope.mapviewer.v1.ArtifactNote.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ListArtifactNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.ArtifactNote.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ArtifactNote notes = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.ArtifactNote>}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.ArtifactNote>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.ArtifactNote, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.ArtifactNote>} value
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse} returns this
*/
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.ArtifactNote=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ArtifactNote}
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.ArtifactNote, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ListArtifactNotesResponse} returns this
 */
proto.landscope.mapviewer.v1.ListArtifactNotesResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest;
  return proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNoteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string note_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.prototype.getNoteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse;
  return proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.UpdateArtifactNoteResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest;
  return proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNoteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string note_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.prototype.getNoteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse;
  return proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteArtifactNoteResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
contentType: jspb.Message.getFieldWithDefault(msg, 3, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest;
  return proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNoteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setContentType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSizeBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string note_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.getNoteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 size_bytes = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest} returns this
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLRequest.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
attachmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
presignedUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse;
  return proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPresignedUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPresignedUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse} returns this
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string presigned_url = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.prototype.getPresignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse} returns this
 */
proto.landscope.mapviewer.v1.GetNoteAttachmentUploadURLResponse.prototype.setPresignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attachmentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest;
  return proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest} returns this
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse;
  return proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.ConfirmNoteAttachmentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attachmentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest;
  return proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string attachment_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.prototype.getAttachmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentRequest.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse;
  return proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse} returns this
 */
proto.landscope.mapviewer.v1.DeleteNoteAttachmentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UTMCoordinate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UTMCoordinate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UTMCoordinate.toObject = function(includeInstance, msg) {
  var f, obj = {
zone: jspb.Message.getFieldWithDefault(msg, 1, 0),
hemisphere: jspb.Message.getFieldWithDefault(msg, 2, ""),
easting: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
northing: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UTMCoordinate}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UTMCoordinate;
  return proto.landscope.mapviewer.v1.UTMCoordinate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UTMCoordinate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UTMCoordinate}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZone(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHemisphere(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEasting(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNorthing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UTMCoordinate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UTMCoordinate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UTMCoordinate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZone();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHemisphere();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEasting();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getNorthing();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional int32 zone = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.getZone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UTMCoordinate} returns this
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.setZone = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string hemisphere = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.getHemisphere = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UTMCoordinate} returns this
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.setHemisphere = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double easting = 3;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.getEasting = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UTMCoordinate} returns this
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.setEasting = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double northing = 4;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.getNorthing = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UTMCoordinate} returns this
 */
proto.landscope.mapviewer.v1.UTMCoordinate.prototype.setNorthing = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.LatLongCoordinate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.LatLongCoordinate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.toObject = function(includeInstance, msg) {
  var f, obj = {
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.LatLongCoordinate}
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.LatLongCoordinate;
  return proto.landscope.mapviewer.v1.LatLongCoordinate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.LatLongCoordinate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.LatLongCoordinate}
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.LatLongCoordinate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.LatLongCoordinate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LatLongCoordinate} returns this
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.LatLongCoordinate} returns this
 */
proto.landscope.mapviewer.v1.LatLongCoordinate.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
utm: (f = msg.getUtm()) && proto.landscope.mapviewer.v1.UTMCoordinate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest;
  return proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UTMCoordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UTMCoordinate.deserializeBinaryFromReader);
      msg.setUtm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtm();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UTMCoordinate.serializeBinaryToWriter
    );
  }
};


/**
 * optional UTMCoordinate utm = 1;
 * @return {?proto.landscope.mapviewer.v1.UTMCoordinate}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.prototype.getUtm = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UTMCoordinate} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UTMCoordinate, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UTMCoordinate|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} returns this
*/
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.prototype.setUtm = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest} returns this
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.prototype.clearUtm = function() {
  return this.setUtm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongRequest.prototype.hasUtm = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
error: jspb.Message.getFieldWithDefault(msg, 2, ""),
latLong: (f = msg.getLatLong()) && proto.landscope.mapviewer.v1.LatLongCoordinate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse;
  return proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setError(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.LatLongCoordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.LatLongCoordinate.deserializeBinaryFromReader);
      msg.setLatLong(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLatLong();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.LatLongCoordinate.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} returns this
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} returns this
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional LatLongCoordinate lat_long = 3;
 * @return {?proto.landscope.mapviewer.v1.LatLongCoordinate}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.getLatLong = function() {
  return /** @type{?proto.landscope.mapviewer.v1.LatLongCoordinate} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.LatLongCoordinate, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.LatLongCoordinate|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} returns this
*/
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.setLatLong = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse} returns this
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.clearLatLong = function() {
  return this.setLatLong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConvertUTMToLatLongResponse.prototype.hasLatLong = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
latLong: (f = msg.getLatLong()) && proto.landscope.mapviewer.v1.LatLongCoordinate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest;
  return proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.LatLongCoordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.LatLongCoordinate.deserializeBinaryFromReader);
      msg.setLatLong(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatLong();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.LatLongCoordinate.serializeBinaryToWriter
    );
  }
};


/**
 * optional LatLongCoordinate lat_long = 1;
 * @return {?proto.landscope.mapviewer.v1.LatLongCoordinate}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.prototype.getLatLong = function() {
  return /** @type{?proto.landscope.mapviewer.v1.LatLongCoordinate} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.LatLongCoordinate, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.LatLongCoordinate|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} returns this
*/
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.prototype.setLatLong = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest} returns this
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.prototype.clearLatLong = function() {
  return this.setLatLong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMRequest.prototype.hasLatLong = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
error: jspb.Message.getFieldWithDefault(msg, 2, ""),
utm: (f = msg.getUtm()) && proto.landscope.mapviewer.v1.UTMCoordinate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse;
  return proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setError(value);
      break;
    case 3:
      var value = new proto.landscope.mapviewer.v1.UTMCoordinate;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UTMCoordinate.deserializeBinaryFromReader);
      msg.setUtm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUtm();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.landscope.mapviewer.v1.UTMCoordinate.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} returns this
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} returns this
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional UTMCoordinate utm = 3;
 * @return {?proto.landscope.mapviewer.v1.UTMCoordinate}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.getUtm = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UTMCoordinate} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UTMCoordinate, 3));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UTMCoordinate|undefined} value
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} returns this
*/
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.setUtm = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse} returns this
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.clearUtm = function() {
  return this.setUtm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ConvertLatLongToUTMResponse.prototype.hasUtm = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UserFolder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UserFolder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UserFolder.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
ownerUserId: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
color: jspb.Message.getFieldWithDefault(msg, 5, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 6, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
parentFolderId: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
owner: (f = msg.getOwner()) && proto.landscope.mapviewer.v1.CommentAuthor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UserFolder}
 */
proto.landscope.mapviewer.v1.UserFolder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UserFolder;
  return proto.landscope.mapviewer.v1.UserFolder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UserFolder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UserFolder}
 */
proto.landscope.mapviewer.v1.UserFolder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOwnerUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentFolderId(value);
      break;
    case 10:
      var value = new proto.landscope.mapviewer.v1.CommentAuthor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UserFolder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UserFolder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UserFolder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOwnerUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.landscope.mapviewer.v1.CommentAuthor.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string owner_user_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getOwnerUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setOwnerUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 sort_order = 6;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 created_at = 7;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 updated_at = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string parent_folder_id = 9;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getParentFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.setParentFolderId = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.clearParentFolderId = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.hasParentFolderId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CommentAuthor owner = 10;
 * @return {?proto.landscope.mapviewer.v1.CommentAuthor}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.getOwner = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentAuthor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentAuthor, 10));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentAuthor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
*/
proto.landscope.mapviewer.v1.UserFolder.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserFolder} returns this
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserFolder.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UserArtifact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UserArtifact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UserArtifact.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
folderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
artifactType: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
color: jspb.Message.getFieldWithDefault(msg, 5, ""),
displayUnit: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
geometryJson: jspb.Message.getFieldWithDefault(msg, 7, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
icon: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
showLabel: (f = jspb.Message.getBooleanField(msg, 12)) == null ? undefined : f,
author: (f = msg.getAuthor()) && proto.landscope.mapviewer.v1.CommentAuthor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UserArtifact}
 */
proto.landscope.mapviewer.v1.UserArtifact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UserArtifact;
  return proto.landscope.mapviewer.v1.UserArtifact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UserArtifact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UserArtifact}
 */
proto.landscope.mapviewer.v1.UserArtifact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayUnit(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGeometryJson(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIcon(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowLabel(value);
      break;
    case 13:
      var value = new proto.landscope.mapviewer.v1.CommentAuthor;
      reader.readMessage(value,proto.landscope.mapviewer.v1.CommentAuthor.deserializeBinaryFromReader);
      msg.setAuthor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UserArtifact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UserArtifact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UserArtifact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArtifactType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGeometryJson();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getAuthor();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.landscope.mapviewer.v1.CommentAuthor.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string folder_id = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string artifact_type = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getArtifactType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setArtifactType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string display_unit = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getDisplayUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setDisplayUnit = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.clearDisplayUnit = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.hasDisplayUnit = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string geometry_json = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getGeometryJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setGeometryJson = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 sort_order = 8;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 updated_at = 10;
 * @return {number}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string icon = 11;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setIcon = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.clearIcon = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool show_label = 12;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getShowLabel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.setShowLabel = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.clearShowLabel = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.hasShowLabel = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional CommentAuthor author = 13;
 * @return {?proto.landscope.mapviewer.v1.CommentAuthor}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.getAuthor = function() {
  return /** @type{?proto.landscope.mapviewer.v1.CommentAuthor} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.CommentAuthor, 13));
};


/**
 * @param {?proto.landscope.mapviewer.v1.CommentAuthor|undefined} value
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
*/
proto.landscope.mapviewer.v1.UserArtifact.prototype.setAuthor = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UserArtifact} returns this
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.clearAuthor = function() {
  return this.setAuthor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UserArtifact.prototype.hasAuthor = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateUserFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, ""),
parentFolderId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateUserFolderRequest;
  return proto.landscope.mapviewer.v1.CreateUserFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateUserFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string parent_folder_id = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.getParentFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.setParentFolderId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.clearParentFolderId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserFolderRequest.prototype.hasParentFolderId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateUserFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
folder: (f = msg.getFolder()) && proto.landscope.mapviewer.v1.UserFolder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderResponse}
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateUserFolderResponse;
  return proto.landscope.mapviewer.v1.CreateUserFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderResponse}
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UserFolder;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserFolder.deserializeBinaryFromReader);
      msg.setFolder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateUserFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateUserFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UserFolder.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserFolder folder = 1;
 * @return {?proto.landscope.mapviewer.v1.UserFolder}
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.prototype.getFolder = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UserFolder} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UserFolder, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UserFolder|undefined} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderResponse} returns this
*/
proto.landscope.mapviewer.v1.CreateUserFolderResponse.prototype.setFolder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.prototype.clearFolder = function() {
  return this.setFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserFolderResponse.prototype.hasFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserFoldersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersRequest}
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserFoldersRequest;
  return proto.landscope.mapviewer.v1.GetUserFoldersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersRequest}
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserFoldersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.GetUserFoldersRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserFoldersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
foldersList: jspb.Message.toObjectList(msg.getFoldersList(),
    proto.landscope.mapviewer.v1.UserFolder.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersResponse}
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserFoldersResponse;
  return proto.landscope.mapviewer.v1.GetUserFoldersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersResponse}
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UserFolder;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserFolder.deserializeBinaryFromReader);
      msg.addFolders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserFoldersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserFoldersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFoldersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UserFolder.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserFolder folders = 1;
 * @return {!Array<!proto.landscope.mapviewer.v1.UserFolder>}
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.prototype.getFoldersList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.UserFolder>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.UserFolder, 1));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.UserFolder>} value
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersResponse} returns this
*/
proto.landscope.mapviewer.v1.GetUserFoldersResponse.prototype.setFoldersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UserFolder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.UserFolder}
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.prototype.addFolders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.landscope.mapviewer.v1.UserFolder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetUserFoldersResponse} returns this
 */
proto.landscope.mapviewer.v1.GetUserFoldersResponse.prototype.clearFoldersList = function() {
  return this.setFoldersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
folderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderRequest}
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserFolderRequest;
  return proto.landscope.mapviewer.v1.GetUserFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderRequest}
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string folder_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.GetUserFolderRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
folder: (f = msg.getFolder()) && proto.landscope.mapviewer.v1.UserFolder.toObject(includeInstance, f),
artifactsList: jspb.Message.toObjectList(msg.getArtifactsList(),
    proto.landscope.mapviewer.v1.UserArtifact.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderResponse}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserFolderResponse;
  return proto.landscope.mapviewer.v1.GetUserFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderResponse}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UserFolder;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserFolder.deserializeBinaryFromReader);
      msg.setFolder(value);
      break;
    case 2:
      var value = new proto.landscope.mapviewer.v1.UserArtifact;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserArtifact.deserializeBinaryFromReader);
      msg.addArtifacts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UserFolder.serializeBinaryToWriter
    );
  }
  f = message.getArtifactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.landscope.mapviewer.v1.UserArtifact.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserFolder folder = 1;
 * @return {?proto.landscope.mapviewer.v1.UserFolder}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.getFolder = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UserFolder} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UserFolder, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UserFolder|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderResponse} returns this
*/
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.setFolder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.clearFolder = function() {
  return this.setFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.hasFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UserArtifact artifacts = 2;
 * @return {!Array<!proto.landscope.mapviewer.v1.UserArtifact>}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.getArtifactsList = function() {
  return /** @type{!Array<!proto.landscope.mapviewer.v1.UserArtifact>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.landscope.mapviewer.v1.UserArtifact, 2));
};


/**
 * @param {!Array<!proto.landscope.mapviewer.v1.UserArtifact>} value
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderResponse} returns this
*/
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.setArtifactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.landscope.mapviewer.v1.UserArtifact=} opt_value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.UserArtifact}
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.addArtifacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.landscope.mapviewer.v1.UserArtifact, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.GetUserFolderResponse} returns this
 */
proto.landscope.mapviewer.v1.GetUserFolderResponse.prototype.clearArtifactsList = function() {
  return this.setArtifactsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateUserFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
folderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
color: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
parentFolderId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateUserFolderRequest;
  return proto.landscope.mapviewer.v1.UpdateUserFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateUserFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string folder_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.setColor = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.clearColor = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.hasColor = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string parent_folder_id = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.getParentFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.setParentFolderId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.clearParentFolderId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderRequest.prototype.hasParentFolderId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateUserFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderResponse}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateUserFolderResponse;
  return proto.landscope.mapviewer.v1.UpdateUserFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserFolderResponse}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateUserFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteUserFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
folderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteUserFolderRequest;
  return proto.landscope.mapviewer.v1.DeleteUserFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteUserFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string folder_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteUserFolderRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteUserFolderRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteUserFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserFolderResponse}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteUserFolderResponse;
  return proto.landscope.mapviewer.v1.DeleteUserFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserFolderResponse}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteUserFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
folderIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
parentFolderId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReorderUserFoldersRequest;
  return proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addFolderIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setParentFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFolderIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string folder_ids = 2;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.getFolderIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.setFolderIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.addFolderIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.clearFolderIdsList = function() {
  return this.setFolderIdsList([]);
};


/**
 * optional string parent_folder_id = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.getParentFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.setParentFolderId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.clearParentFolderId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersRequest.prototype.hasParentFolderId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReorderUserFoldersResponse;
  return proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserFoldersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserFoldersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateUserArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
folderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
artifactType: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
color: jspb.Message.getFieldWithDefault(msg, 4, ""),
displayUnit: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
geometryJson: jspb.Message.getFieldWithDefault(msg, 6, ""),
icon: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
showLabel: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateUserArtifactRequest;
  return proto.landscope.mapviewer.v1.CreateUserArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setArtifactType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayUnit(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGeometryJson(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIcon(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateUserArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArtifactType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGeometryJson();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string folder_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string artifact_type = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getArtifactType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setArtifactType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string color = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_unit = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getDisplayUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setDisplayUnit = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.clearDisplayUnit = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.hasDisplayUnit = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string geometry_json = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getGeometryJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setGeometryJson = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string icon = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setIcon = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.clearIcon = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool show_label = 8;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.getShowLabel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.setShowLabel = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.clearShowLabel = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactRequest.prototype.hasShowLabel = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.CreateUserArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
artifact: (f = msg.getArtifact()) && proto.landscope.mapviewer.v1.UserArtifact.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.CreateUserArtifactResponse;
  return proto.landscope.mapviewer.v1.CreateUserArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UserArtifact;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserArtifact.deserializeBinaryFromReader);
      msg.setArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.CreateUserArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifact();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UserArtifact.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserArtifact artifact = 1;
 * @return {?proto.landscope.mapviewer.v1.UserArtifact}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.prototype.getArtifact = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UserArtifact} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UserArtifact, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UserArtifact|undefined} value
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse} returns this
*/
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.prototype.setArtifact = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.CreateUserArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.prototype.clearArtifact = function() {
  return this.setArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.CreateUserArtifactResponse.prototype.hasArtifact = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userArtifactId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserArtifactRequest;
  return proto.landscope.mapviewer.v1.GetUserArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserArtifactId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.prototype.getUserArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.GetUserArtifactRequest.prototype.setUserArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.GetUserArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
artifact: (f = msg.getArtifact()) && proto.landscope.mapviewer.v1.UserArtifact.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.GetUserArtifactResponse;
  return proto.landscope.mapviewer.v1.GetUserArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.landscope.mapviewer.v1.UserArtifact;
      reader.readMessage(value,proto.landscope.mapviewer.v1.UserArtifact.deserializeBinaryFromReader);
      msg.setArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.GetUserArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.GetUserArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifact();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.landscope.mapviewer.v1.UserArtifact.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserArtifact artifact = 1;
 * @return {?proto.landscope.mapviewer.v1.UserArtifact}
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.prototype.getArtifact = function() {
  return /** @type{?proto.landscope.mapviewer.v1.UserArtifact} */ (
    jspb.Message.getWrapperField(this, proto.landscope.mapviewer.v1.UserArtifact, 1));
};


/**
 * @param {?proto.landscope.mapviewer.v1.UserArtifact|undefined} value
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactResponse} returns this
*/
proto.landscope.mapviewer.v1.GetUserArtifactResponse.prototype.setArtifact = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.GetUserArtifactResponse} returns this
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.prototype.clearArtifact = function() {
  return this.setArtifact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.GetUserArtifactResponse.prototype.hasArtifact = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userArtifactId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
color: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
displayUnit: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
geometryJson: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
folderId: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
icon: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
showLabel: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateUserArtifactRequest;
  return proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserArtifactId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisplayUnit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGeometryJson(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIcon(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string user_artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getUserArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setUserArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setColor = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearColor = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasColor = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string display_unit = 4;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getDisplayUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setDisplayUnit = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearDisplayUnit = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasDisplayUnit = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string geometry_json = 5;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getGeometryJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setGeometryJson = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearGeometryJson = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasGeometryJson = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string folder_id = 6;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearFolderId = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasFolderId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string icon = 7;
 * @return {string}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setIcon = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearIcon = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool show_label = 8;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.getShowLabel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.setShowLabel = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.clearShowLabel = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactRequest.prototype.hasShowLabel = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.UpdateUserArtifactResponse;
  return proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.UpdateUserArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.UpdateUserArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userArtifactId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteUserArtifactRequest;
  return proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUserArtifactId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserArtifactId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_artifact_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.prototype.getUserArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.DeleteUserArtifactRequest} returns this
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactRequest.prototype.setUserArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.DeleteUserArtifactResponse;
  return proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.DeleteUserArtifactResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.DeleteUserArtifactResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
folderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
artifactIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest;
  return proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFolderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addArtifactIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArtifactIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string folder_id = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string artifact_ids = 2;
 * @return {!Array<string>}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.getArtifactIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.setArtifactIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.addArtifactIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest} returns this
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsRequest.prototype.clearArtifactIdsList = function() {
  return this.setArtifactIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse;
  return proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ReorderUserArtifactsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ResendVerificationEmailRequest;
  return proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailRequest} returns this
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.ResendVerificationEmailResponse;
  return proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse} returns this
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.ResendVerificationEmailResponse} returns this
 */
proto.landscope.mapviewer.v1.ResendVerificationEmailResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
reason: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RequestAccountDeletionRequest;
  return proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reason = 1;
 * @return {string}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionRequest} returns this
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
requestedAt: jspb.Message.getFieldWithDefault(msg, 1, 0),
alreadyRequested: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.landscope.mapviewer.v1.RequestAccountDeletionResponse;
  return proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestedAt(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlreadyRequested(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestedAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAlreadyRequested();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int64 requested_at = 1;
 * @return {number}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.prototype.getRequestedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.prototype.setRequestedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool already_requested = 2;
 * @return {boolean}
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.prototype.getAlreadyRequested = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.landscope.mapviewer.v1.RequestAccountDeletionResponse} returns this
 */
proto.landscope.mapviewer.v1.RequestAccountDeletionResponse.prototype.setAlreadyRequested = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.SupportMessageCategory = {
  SUPPORT_MESSAGE_CATEGORY_UNSPECIFIED: 0,
  SUPPORT_MESSAGE_CATEGORY_SUPPORT: 1,
  SUPPORT_MESSAGE_CATEGORY_FEATURE_REQUEST: 2
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.PlanSku = {
  PLAN_SKU_UNSPECIFIED: 0,
  PLAN_SKU_SINGLE_MAP: 1,
  PLAN_SKU_UNLIMITED_YEARLY: 2,
  PLAN_SKU_UNLIMITED_MONTHLY: 3,
  PLAN_SKU_PROJECT_SEAT: 4,
  PLAN_SKU_WORKSPACE_SEAT: 5
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.AccessLevel = {
  ACCESS_LEVEL_NONE: 0,
  ACCESS_LEVEL_SCOUTING: 1,
  ACCESS_LEVEL_DEMO: 2,
  ACCESS_LEVEL_FULL: 3
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.CustomerIntent = {
  CUSTOMER_INTENT_UNSPECIFIED: 0,
  CUSTOMER_INTENT_ONE_MAP: 1,
  CUSTOMER_INTENT_MORE_THAN_ONE: 2
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.LayerProcessingState = {
  LAYER_PROCESSING_STATE_UNSPECIFIED: 0,
  LAYER_PROCESSING_STATE_PROCESSING: 1,
  LAYER_PROCESSING_STATE_READY: 2,
  LAYER_PROCESSING_STATE_FAILED: 3
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.ExternalProvider = {
  EXTERNAL_PROVIDER_UNSPECIFIED: 0,
  EXTERNAL_PROVIDER_GOOGLE: 1
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.LoginMethod = {
  LOGIN_METHOD_UNSPECIFIED: 0,
  LOGIN_METHOD_PASSWORD: 1,
  LOGIN_METHOD_GOOGLE: 2,
  LOGIN_METHOD_UNVERIFIED: 3
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.TeamSize = {
  TEAM_SIZE_UNSPECIFIED: 0,
  SOLO: 1,
  TEAM_2_5: 2,
  LARGER_TEAM: 3
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.ArtifactType = {
  ARTIFACT_TYPE_UNSPECIFIED: 0,
  GROUND_OVERLAY: 1,
  VECTOR_DATA: 2,
  SCREEN_OVERLAY: 3,
  PLACEMARK: 4,
  INFO_PANEL: 5
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.UsagePurpose = {
  USAGE_PURPOSE_UNSPECIFIED: 0,
  EVALUATING_PROPERTY: 1,
  PLANNING_DESIGNING_LAND: 2,
  LAND_DEVELOPMENT_CONSULTING: 3,
  OTHER: 4,
  DESIGN_CONSULTING_CLIENTS: 5,
  MULTI_SITE_DEVELOPMENT: 6,
  TEACHING_RESEARCH_INSTITUTIONAL: 7,
  PREFER_NOT_TO_SAY: 8,
  ENVIRONMENTAL_CONSULTING: 9,
  CIVIL_SITE_ENGINEERING: 10,
  LANDSCAPE_ARCHITECTURE: 11,
  PERMACULTURE_REGENERATIVE_DESIGN: 12,
  LAND_INVESTMENT: 13,
  LAND_DEVELOPMENT: 14,
  RENEWABLE_ENERGY_SITING: 15,
  CONSERVATION_STEWARDSHIP: 16,
  TEACHING_RESEARCH_GOVERNMENT: 17,
  ARCHITECTURE: 18,
  TEACHING_RESEARCH: 19,
  GOVERNMENT_AGENCY: 20
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.ValidationErrorType = {
  VALIDATION_ERROR_TYPE_UNSPECIFIED: 0,
  FILE_CORRUPTED: 1,
  EXCEEDS_MAX_AREA: 2,
  UNSUPPORTED_DATUM: 3
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.DEMStatus = {
  DEM_STATUS_UNSPECIFIED: 0,
  DEM_STATUS_PENDING: 1,
  DEM_STATUS_CATALOG_CHECKED: 2,
  DEM_STATUS_NO_COVERAGE: 3,
  DEM_STATUS_PROCURING: 4,
  DEM_STATUS_PROCESSING: 5,
  DEM_STATUS_COMPLETED: 6,
  DEM_STATUS_FAILED: 7
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.CouponRejectionReason = {
  COUPON_REJECTION_REASON_NONE: 0,
  COUPON_REJECTION_REASON_NOT_FOUND: 1,
  COUPON_REJECTION_REASON_INACTIVE: 2,
  COUPON_REJECTION_REASON_EXPIRED: 3,
  COUPON_REJECTION_REASON_ALREADY_USED: 4,
  COUPON_REJECTION_REASON_LIMIT_REACHED: 5,
  COUPON_REJECTION_REASON_NOT_APPLICABLE: 6
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.CoverageState = {
  COVERAGE_STATE_UNSPECIFIED: 0,
  COVERAGE_STATE_INSTANT: 1,
  COVERAGE_STATE_PROCURABLE: 2,
  COVERAGE_STATE_NONE: 3
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.ExportFormat = {
  EXPORT_FORMAT_UNSPECIFIED: 0,
  EXPORT_FORMAT_TIF: 1,
  EXPORT_FORMAT_PNG: 2,
  EXPORT_FORMAT_KML: 3,
  EXPORT_FORMAT_SHAPEFILE: 4,
  EXPORT_FORMAT_GEOJSON: 5,
  EXPORT_FORMAT_SVG: 6,
  EXPORT_FORMAT_DXF: 7,
  EXPORT_FORMAT_PNG_MAP: 8
};

/**
 * @enum {number}
 */
proto.landscope.mapviewer.v1.ScopeArtifactType = {
  SCOPE_ARTIFACT_TYPE_UNSPECIFIED: 0,
  SCOPE_ARTIFACT_TYPE_SYSTEM: 1,
  SCOPE_ARTIFACT_TYPE_USER: 2
};

goog.object.extend(exports, proto.landscope.mapviewer.v1);
